/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * AOS Pathways API
 * OpenAPI spec version: 26.6.3
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AIUsageResponse,
  AddInterruptedMessage201,
  AddInterruptedMessageRequest,
  AddSubtaskParams,
  AgentToolAnalyticsResponse,
  AgentToolDescriptorResponse,
  AgentToolToggleRequest,
  ApprovalWorkflowResponse,
  ApproveCompletionRequest,
  ApproveTaskCompletionParams,
  ApproveTaskCreationParams,
  AssignManagerRequest,
  AssignManagerResponse,
  AuthCallbackRequest,
  AuthCallbackResponse,
  AutoTaskAdminConfigRequest,
  AutoTaskAdminStatus,
  AutotaskAdminConfig200,
  AvatarDownloadResponse,
  AvatarStatusResponse,
  AvatarStyle,
  AvatarUploadUrlRequest,
  AvatarUploadUrlResponse,
  BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost,
  BodyUploadFileFilesUploadPost,
  BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost,
  BulkApprovalRequest,
  BulkApprovalResponse,
  BulkUpdateDepartmentRequest,
  BulkUpdateDepartmentResponse,
  CalendarEventListResponse,
  CallAnalysis,
  CallAnalysisSummary,
  ChatRequest,
  ChatSettingsResponse,
  ChatSettingsUpdate,
  CoachingRoleAdmin,
  CoachingRoleAdminListResponse,
  CoachingRoleListResponse,
  CoachingUsageReportResponse,
  CommunitySettingsResponse,
  CommunitySettingsUpdateRequest,
  CompanyEventsResponse,
  ConfirmUploadResponse,
  Conversation,
  ConversationListResponse,
  ConversationWithMessages,
  CreateCoachingRoleRequest,
  CreateConversationRequest,
  CreateGoalRequest,
  CreateGoalWithMilestonesRequest,
  CreateIdResponse,
  CreateMilestoneRequest,
  CreateRequirementRequest,
  CreateResourceCategoryRequest,
  CreateSubtaskRequest,
  CreateTaskParams,
  CreateTaskRequest,
  CreateTemplateRequest,
  DashboardSummaryResponse,
  DeleteAvatarResponse,
  DeleteCategoryResponse,
  DeleteMilestoneParams,
  DeleteResponse,
  DeleteSubtaskParams,
  DeleteTaskParams,
  DeleteTranscriptResponse,
  Department,
  DepartmentAssignmentListResponse,
  DocumentGenerationSettingsResponse,
  DocumentGenerationSettingsUpdate,
  DownloadUrlResponse,
  EngagementResponse,
  EnrichMsLearnDoc200,
  EnrichPricingSnapshot200,
  EnrichRoadmapItem200,
  EnrichUrl200,
  EnrichVulnerability200,
  EnrichYoutubeVideo200,
  ErrorResponse,
  ExportTeamReportParams,
  FirefliesConnectRequest,
  FirefliesDisconnectResponse,
  FirefliesStatusResponse,
  FirefliesTranscriptListResponse,
  GenerateAvatarRequest,
  GenerateAvatarResponse,
  GetAgentToolAnalyticsParams,
  GetAiUsageParams,
  GetApprovalWorkflowMetricsParams,
  GetAssignableTeamMembers200Item,
  GetCallAnalysisSummaryParams,
  GetCoachingUsageParams,
  GetCompanyEventsParams,
  GetEngagementParams,
  GetGoalParams,
  GetLearningProgressParams,
  GetRequirementPreviewParams,
  GetTeamCallAnalyticsParams,
  GetTeamMemberGoalsParams,
  GetTeamMembersParams,
  GetTeamOverviewParams,
  GetTrainingOverviewParams,
  GetTrainingRequirementsParams,
  GetWebhookEventSummaryParams,
  GetWebhookEventsParams,
  GoalListResponse,
  GoalResponse,
  GoalStatsResponse,
  HTTPValidationError,
  HealthResponse,
  HubSpotAdminConfigRequest,
  HubSpotAdminStatus,
  HubSpotConnectResponse,
  HubSpotConnectionStatus,
  HubspotAdminConfig200,
  HubspotAdminRevokeAll200,
  HubspotCallbackParams,
  HubspotDisconnect200,
  IconUrlResponse,
  ImageGenerationSettingsResponse,
  ImageGenerationSettingsUpdate,
  ImportMeetingsParams,
  ImportTranscriptResponse,
  ImportedTranscript,
  ItemsExistParams,
  KbEnrichmentJobRequest,
  KbItem,
  KbItemListResponse,
  KbItemPatchRequest,
  KbItemsExistsResponse,
  KbManualSaveRequest,
  KbPromoteRequest,
  KbPromoteResponse,
  KbSaveFromAgentRequest,
  KbSaveResponse,
  LearningProgressResponse,
  ListCallAnalysesParams,
  ListConversationsParams,
  ListFirefliesTranscriptsParams,
  ListGoalsParams,
  ListKbItemsParams,
  ListResourcesParams,
  ListSyncedEventsParams,
  ListTranscriptsParams,
  LogoutResponse,
  ManagerMarkTaskCompleteParams,
  MeetingListResponse,
  MessageFeedback,
  MessageFeedbackRequest,
  MilestoneResponse,
  MyAvatarResponse,
  OrgCalendarStatusResponse,
  OrgCalendarsResponse,
  OutlookSettingsResponse,
  OutlookSettingsUpdate,
  OutlookStatusResponse,
  OutlookSyncResponse,
  PaginatedResources,
  PendingApprovalsResponse,
  PreviewOrgEventsParams,
  RAGStatsResponse,
  RAGStatusResponse,
  RagStatusResponse,
  RegenerateRequest,
  RegisterDevAccountRequest,
  RegisterDevAccountResponse,
  RejectCompletionRequest,
  RejectCreationRequest,
  RejectTaskCompletionParams,
  RejectTaskCreationParams,
  ReorderCategoriesRequest,
  ReorderCategoriesResponse,
  ReorderCoachingRolesRequest,
  ReorderMilestonesRequest,
  ReorderResponse,
  ReorderTasksParams,
  ReorderTasksRequest,
  ReportPoorResultRequest,
  ReportPoorResultResponse,
  RequirementPreviewResponse,
  ResourceCategoryAdminListResponse,
  ResourceCategoryAdminResponse,
  ResourceCategoryListResponse,
  ResourceCoachingRolesResponse,
  ResourceCreate,
  ResourceLinkCreate,
  ResourceReplaceRequest,
  ResourceResponse,
  ResourceUpdate,
  RestoreVersionRequest,
  RoleAssignmentListResponse,
  SearchFirefliesTranscriptsParams,
  SearchParams,
  SearchResponse,
  SelectStyleRequest,
  SelectStyleResponse,
  SessionRefreshRequest,
  SessionRefreshResponse,
  SessionSettingsResponse,
  SessionSettingsUpdate,
  SessionStatusResponse,
  SetDefaultRoleRequest,
  SetOrgCalendarRequest,
  SubmitTaskForCompletionParams,
  SubtaskResponse,
  SuccessResponse,
  TaskResponse,
  TeamCallAnalytics,
  TeamGoalsResponse,
  TeamMembersResponse,
  TeamOverviewResponse,
  TeamTrainingResponse,
  TemplateListResponse,
  TemplateResponse,
  ThinkificApiKeyConnectRequest,
  ThinkificBundleListResponse,
  ThinkificConnectRequest,
  ThinkificCourseListResponse,
  ThinkificEnrollmentListResponse,
  ThinkificOAuthCallbackRequest,
  ThinkificOAuthStartResponse,
  ThinkificSettingsUpdateRequest,
  ThinkificStatusResponse,
  ThinkificSyncResponse,
  ThinkificVerifyTasksResponse,
  ToggleSubtaskParams,
  ToggleTaskParams,
  TrainingOverviewResponse,
  TrainingRequirement,
  TrainingRequirementListResponse,
  TranscriptListResponse,
  UnassignedUsersResponse,
  UpdateCoachingRoleRequest,
  UpdateConversationRequest,
  UpdateDepartmentAssignmentRequest,
  UpdateGoalRequest,
  UpdateMeetingCategoryRequest,
  UpdateMilestoneParams,
  UpdateMilestoneRequest,
  UpdateResourceCategoryRequest,
  UpdateResourceCoachingRolesRequest,
  UpdateRoleAssignmentRequest,
  UpdateRoleRequest,
  UpdateRoleResponse,
  UpdateSubtaskParams,
  UpdateSubtaskRequest,
  UpdateTaskParams,
  UpdateTaskRequest,
  UpdateTemplateRequest,
  UpdateUserAssignmentRequest,
  UpdateUserDepartmentRequest,
  UpdateVisibilityRequest,
  UploadUrlRequest,
  UploadUrlResponse,
  UploadedFile,
  UserCalendarsResponse,
  UserCoachingAssignment,
  UserProfileResponse,
  VersionHistoryResponse,
  WebhookConfigResponse,
  WebhookEventSummaryResponse,
  WebhookEventsListResponse,
  WebhookSecretResponse,
} from "./generated.schemas";

import { apiMutator } from "./queryClient";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getHealthCheckUrl = () => {
  return `/health`;
};

/**
 * Health check endpoint for monitoring and load balancer probes.
 * @summary Health check
 */
export const healthCheck = async (options?: RequestInit): Promise<HealthResponse> => {
  return apiMutator<HealthResponse>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/health`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) =>
    healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>;
export type HealthCheckQueryError = unknown;

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListAgentToolsUrl = () => {
  return `/admin/agent-tools`;
};

/**
 * List every tool in REGISTRY with its current on/off state.
 *
 * Requires READ_SYSTEM (super_admin only).
 * @summary List all registered agent tools with their current enablement state
 */
export const listAgentTools = async (
  options?: RequestInit
): Promise<AgentToolDescriptorResponse[]> => {
  return apiMutator<AgentToolDescriptorResponse[]>(getListAgentToolsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAgentToolsQueryKey = () => {
  return [`/admin/agent-tools`] as const;
};

export const getListAgentToolsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentTools>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentTools>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentToolsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentTools>>> = ({ signal }) =>
    listAgentTools({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentTools>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAgentToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentTools>>>;
export type ListAgentToolsQueryError = ErrorResponse;

export function useListAgentTools<
  TData = Awaited<ReturnType<typeof listAgentTools>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentTools>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentTools>>,
          TError,
          Awaited<ReturnType<typeof listAgentTools>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentTools<
  TData = Awaited<ReturnType<typeof listAgentTools>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentTools>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentTools>>,
          TError,
          Awaited<ReturnType<typeof listAgentTools>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentTools<
  TData = Awaited<ReturnType<typeof listAgentTools>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentTools>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all registered agent tools with their current enablement state
 */

export function useListAgentTools<
  TData = Awaited<ReturnType<typeof listAgentTools>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentTools>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentToolsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateAgentToolUrl = (toolName: string) => {
  return `/admin/agent-tools/${toolName}`;
};

/**
 * Toggle a tool's enablement state.
 *
 * Returns the updated descriptor. Requires WRITE_SYSTEM (super_admin
 * only). Changes propagate to other Cloud Run instances within the
 * settings cache TTL (60 s).
 * @summary Enable or disable a specific agent tool
 */
export const updateAgentTool = async (
  toolName: string,
  agentToolToggleRequest: AgentToolToggleRequest,
  options?: RequestInit
): Promise<AgentToolDescriptorResponse> => {
  return apiMutator<AgentToolDescriptorResponse>(getUpdateAgentToolUrl(toolName), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(agentToolToggleRequest),
  });
};

export const getUpdateAgentToolMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAgentTool>>,
    TError,
    { toolName: string; data: AgentToolToggleRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAgentTool>>,
  TError,
  { toolName: string; data: AgentToolToggleRequest },
  TContext
> => {
  const mutationKey = ["updateAgentTool"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAgentTool>>,
    { toolName: string; data: AgentToolToggleRequest }
  > = (props) => {
    const { toolName, data } = props ?? {};

    return updateAgentTool(toolName, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAgentToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAgentTool>>
>;
export type UpdateAgentToolMutationBody = AgentToolToggleRequest;
export type UpdateAgentToolMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Enable or disable a specific agent tool
 */
export const useUpdateAgentTool = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAgentTool>>,
      TError,
      { toolName: string; data: AgentToolToggleRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAgentTool>>,
  TError,
  { toolName: string; data: AgentToolToggleRequest },
  TContext
> => {
  return useMutation(getUpdateAgentToolMutationOptions(options), queryClient);
};

export const getGetAgentToolAnalyticsUrl = (params: GetAgentToolAnalyticsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/admin/agent-tools/analytics?${stringifiedParams}`
    : `/admin/agent-tools/analytics`;
};

/**
 * Return aggregated metrics for the requested window.
 *
 * Results are cached for 5 minutes per unique (window, tool, outcome)
 * combination. Direct Firestore query under the hood — a scheduled
 * rollup is a documented escape hatch for a future spec if p95 query
 * latency exceeds ~1.5 s at scale.
 * @summary Aggregated agent tool usage metrics for the admin dashboard
 */
export const getAgentToolAnalytics = async (
  params: GetAgentToolAnalyticsParams,
  options?: RequestInit
): Promise<AgentToolAnalyticsResponse> => {
  return apiMutator<AgentToolAnalyticsResponse>(getGetAgentToolAnalyticsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAgentToolAnalyticsQueryKey = (params?: GetAgentToolAnalyticsParams) => {
  return [`/admin/agent-tools/analytics`, ...(params ? [params] : [])] as const;
};

export const getGetAgentToolAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentToolAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: GetAgentToolAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgentToolAnalytics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentToolAnalyticsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentToolAnalytics>>> = ({ signal }) =>
    getAgentToolAnalytics(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentToolAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAgentToolAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgentToolAnalytics>>
>;
export type GetAgentToolAnalyticsQueryError = ErrorResponse | HTTPValidationError;

export function useGetAgentToolAnalytics<
  TData = Awaited<ReturnType<typeof getAgentToolAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: GetAgentToolAnalyticsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgentToolAnalytics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentToolAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAgentToolAnalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentToolAnalytics<
  TData = Awaited<ReturnType<typeof getAgentToolAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: GetAgentToolAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgentToolAnalytics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentToolAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAgentToolAnalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentToolAnalytics<
  TData = Awaited<ReturnType<typeof getAgentToolAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: GetAgentToolAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgentToolAnalytics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Aggregated agent tool usage metrics for the admin dashboard
 */

export function useGetAgentToolAnalytics<
  TData = Awaited<ReturnType<typeof getAgentToolAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: GetAgentToolAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgentToolAnalytics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgentToolAnalyticsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetChatSettingsUrl = () => {
  return `/admin/chat-settings`;
};

/**
 * Get chat settings including audit fields.
 *
 * Requires READ_SYSTEM permission.
 * Returns full settings with updated_at and updated_by fields.
 * @summary Get chat settings
 */
export const getChatSettings = async (options?: RequestInit): Promise<ChatSettingsResponse> => {
  return apiMutator<ChatSettingsResponse>(getGetChatSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetChatSettingsQueryKey = () => {
  return [`/admin/chat-settings`] as const;
};

export const getGetChatSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatSettings>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSettings>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatSettings>>> = ({ signal }) =>
    getChatSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetChatSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getChatSettings>>>;
export type GetChatSettingsQueryError = ErrorResponse;

export function useGetChatSettings<
  TData = Awaited<ReturnType<typeof getChatSettings>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSettings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatSettings>>,
          TError,
          Awaited<ReturnType<typeof getChatSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetChatSettings<
  TData = Awaited<ReturnType<typeof getChatSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSettings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatSettings>>,
          TError,
          Awaited<ReturnType<typeof getChatSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetChatSettings<
  TData = Awaited<ReturnType<typeof getChatSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSettings>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get chat settings
 */

export function useGetChatSettings<
  TData = Awaited<ReturnType<typeof getChatSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSettings>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetChatSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateChatSettingsUrl = () => {
  return `/admin/chat-settings`;
};

/**
 * Update chat settings.
 *
 * Requires WRITE_SYSTEM permission.
 * Supports partial updates - only specified fields are modified.
 *
 * Setting identity_context_enabled to false will disable user identity
 * context from being included in chat prompts globally.
 * @summary Update chat settings
 */
export const updateChatSettings = async (
  chatSettingsUpdate: ChatSettingsUpdate,
  options?: RequestInit
): Promise<ChatSettingsResponse> => {
  return apiMutator<ChatSettingsResponse>(getUpdateChatSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(chatSettingsUpdate),
  });
};

export const getUpdateChatSettingsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChatSettings>>,
    TError,
    { data: ChatSettingsUpdate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChatSettings>>,
  TError,
  { data: ChatSettingsUpdate },
  TContext
> => {
  const mutationKey = ["updateChatSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChatSettings>>,
    { data: ChatSettingsUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateChatSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChatSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChatSettings>>
>;
export type UpdateChatSettingsMutationBody = ChatSettingsUpdate;
export type UpdateChatSettingsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update chat settings
 */
export const useUpdateChatSettings = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateChatSettings>>,
      TError,
      { data: ChatSettingsUpdate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateChatSettings>>,
  TError,
  { data: ChatSettingsUpdate },
  TContext
> => {
  return useMutation(getUpdateChatSettingsMutationOptions(options), queryClient);
};

export const getGetDepartmentAssignmentsUrl = () => {
  return `/admin/coaching-roles/department-assignments`;
};

/**
 * Get all department-based coaching role assignments (admin only).
 *
 * Returns which coaching roles are assigned to each department
 * (sales, service, operations).
 * @summary Get department assignments
 */
export const getDepartmentAssignments = async (
  options?: RequestInit
): Promise<DepartmentAssignmentListResponse> => {
  return apiMutator<DepartmentAssignmentListResponse>(getGetDepartmentAssignmentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDepartmentAssignmentsQueryKey = () => {
  return [`/admin/coaching-roles/department-assignments`] as const;
};

export const getGetDepartmentAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepartmentAssignments>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAssignments>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDepartmentAssignmentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentAssignments>>> = ({
    signal,
  }) => getDepartmentAssignments({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDepartmentAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDepartmentAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepartmentAssignments>>
>;
export type GetDepartmentAssignmentsQueryError = ErrorResponse;

export function useGetDepartmentAssignments<
  TData = Awaited<ReturnType<typeof getDepartmentAssignments>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAssignments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentAssignments>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentAssignments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDepartmentAssignments<
  TData = Awaited<ReturnType<typeof getDepartmentAssignments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAssignments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentAssignments>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentAssignments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDepartmentAssignments<
  TData = Awaited<ReturnType<typeof getDepartmentAssignments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAssignments>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get department assignments
 */

export function useGetDepartmentAssignments<
  TData = Awaited<ReturnType<typeof getDepartmentAssignments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAssignments>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDepartmentAssignmentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateDepartmentAssignmentUrl = (department: Department) => {
  return `/admin/coaching-roles/department-assignments/${department}`;
};

/**
 * Update coaching role assignment for a department (admin only).
 *
 * Args:
 *     department: The department (sales, service, operations)
 *     payload: Assignment update with coaching_role_ids and optional default_role_id
 * @summary Update department assignment
 */
export const updateDepartmentAssignment = async (
  department: Department,
  updateDepartmentAssignmentRequest: UpdateDepartmentAssignmentRequest,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getUpdateDepartmentAssignmentUrl(department), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateDepartmentAssignmentRequest),
  });
};

export const getUpdateDepartmentAssignmentMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDepartmentAssignment>>,
    TError,
    { department: Department; data: UpdateDepartmentAssignmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDepartmentAssignment>>,
  TError,
  { department: Department; data: UpdateDepartmentAssignmentRequest },
  TContext
> => {
  const mutationKey = ["updateDepartmentAssignment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDepartmentAssignment>>,
    { department: Department; data: UpdateDepartmentAssignmentRequest }
  > = (props) => {
    const { department, data } = props ?? {};

    return updateDepartmentAssignment(department, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDepartmentAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDepartmentAssignment>>
>;
export type UpdateDepartmentAssignmentMutationBody = UpdateDepartmentAssignmentRequest;
export type UpdateDepartmentAssignmentMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update department assignment
 */
export const useUpdateDepartmentAssignment = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDepartmentAssignment>>,
      TError,
      { department: Department; data: UpdateDepartmentAssignmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDepartmentAssignment>>,
  TError,
  { department: Department; data: UpdateDepartmentAssignmentRequest },
  TContext
> => {
  return useMutation(getUpdateDepartmentAssignmentMutationOptions(options), queryClient);
};

export const getListAllCoachingRolesUrl = () => {
  return `/admin/coaching-roles`;
};

/**
 * List all coaching roles (admin only).
 *
 * Returns all roles with summary info (no prompt content).
 * @summary List all coaching roles
 */
export const listAllCoachingRoles = async (
  options?: RequestInit
): Promise<CoachingRoleAdminListResponse> => {
  return apiMutator<CoachingRoleAdminListResponse>(getListAllCoachingRolesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAllCoachingRolesQueryKey = () => {
  return [`/admin/coaching-roles`] as const;
};

export const getListAllCoachingRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllCoachingRoles>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllCoachingRoles>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllCoachingRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllCoachingRoles>>> = ({ signal }) =>
    listAllCoachingRoles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllCoachingRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAllCoachingRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllCoachingRoles>>
>;
export type ListAllCoachingRolesQueryError = ErrorResponse;

export function useListAllCoachingRoles<
  TData = Awaited<ReturnType<typeof listAllCoachingRoles>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllCoachingRoles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllCoachingRoles>>,
          TError,
          Awaited<ReturnType<typeof listAllCoachingRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllCoachingRoles<
  TData = Awaited<ReturnType<typeof listAllCoachingRoles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllCoachingRoles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllCoachingRoles>>,
          TError,
          Awaited<ReturnType<typeof listAllCoachingRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllCoachingRoles<
  TData = Awaited<ReturnType<typeof listAllCoachingRoles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllCoachingRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all coaching roles
 */

export function useListAllCoachingRoles<
  TData = Awaited<ReturnType<typeof listAllCoachingRoles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllCoachingRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAllCoachingRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateCoachingRoleUrl = () => {
  return `/admin/coaching-roles`;
};

/**
 * Create a new coaching role (admin only).
 *
 * System prompt is stored securely in Secret Manager.
 * @summary Create coaching role
 */
export const createCoachingRole = async (
  createCoachingRoleRequest: CreateCoachingRoleRequest,
  options?: RequestInit
): Promise<CreateIdResponse> => {
  return apiMutator<CreateIdResponse>(getCreateCoachingRoleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCoachingRoleRequest),
  });
};

export const getCreateCoachingRoleMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoachingRole>>,
    TError,
    { data: CreateCoachingRoleRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCoachingRole>>,
  TError,
  { data: CreateCoachingRoleRequest },
  TContext
> => {
  const mutationKey = ["createCoachingRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCoachingRole>>,
    { data: CreateCoachingRoleRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createCoachingRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCoachingRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCoachingRole>>
>;
export type CreateCoachingRoleMutationBody = CreateCoachingRoleRequest;
export type CreateCoachingRoleMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create coaching role
 */
export const useCreateCoachingRole = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCoachingRole>>,
      TError,
      { data: CreateCoachingRoleRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCoachingRole>>,
  TError,
  { data: CreateCoachingRoleRequest },
  TContext
> => {
  return useMutation(getCreateCoachingRoleMutationOptions(options), queryClient);
};

export const getGetCoachingRoleUrl = (roleId: string) => {
  return `/admin/coaching-roles/${roleId}`;
};

/**
 * Get coaching role details with system prompt (admin only).
 * @summary Get coaching role details
 */
export const getCoachingRole = async (
  roleId: string,
  options?: RequestInit
): Promise<CoachingRoleAdmin> => {
  return apiMutator<CoachingRoleAdmin>(getGetCoachingRoleUrl(roleId), {
    ...options,
    method: "GET",
  });
};

export const getGetCoachingRoleQueryKey = (roleId: string) => {
  return [`/admin/coaching-roles/${roleId}`] as const;
};

export const getGetCoachingRoleQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachingRole>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  roleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingRole>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoachingRoleQueryKey(roleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoachingRole>>> = ({ signal }) =>
    getCoachingRole(roleId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: roleId !== null && roleId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCoachingRole>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetCoachingRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getCoachingRole>>>;
export type GetCoachingRoleQueryError = ErrorResponse | HTTPValidationError;

export function useGetCoachingRole<
  TData = Awaited<ReturnType<typeof getCoachingRole>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  roleId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingRole>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachingRole>>,
          TError,
          Awaited<ReturnType<typeof getCoachingRole>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCoachingRole<
  TData = Awaited<ReturnType<typeof getCoachingRole>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  roleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingRole>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachingRole>>,
          TError,
          Awaited<ReturnType<typeof getCoachingRole>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCoachingRole<
  TData = Awaited<ReturnType<typeof getCoachingRole>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  roleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingRole>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get coaching role details
 */

export function useGetCoachingRole<
  TData = Awaited<ReturnType<typeof getCoachingRole>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  roleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingRole>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCoachingRoleQueryOptions(roleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateCoachingRoleUrl = (roleId: string) => {
  return `/admin/coaching-roles/${roleId}`;
};

/**
 * Update an existing coaching role (admin only).
 *
 * Only provided fields will be updated.
 * Built-in bare_llm roles have restricted update fields.
 * @summary Update coaching role
 */
export const updateCoachingRole = async (
  roleId: string,
  updateCoachingRoleRequest: UpdateCoachingRoleRequest,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getUpdateCoachingRoleUrl(roleId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCoachingRoleRequest),
  });
};

export const getUpdateCoachingRoleMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoachingRole>>,
    TError,
    { roleId: string; data: UpdateCoachingRoleRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCoachingRole>>,
  TError,
  { roleId: string; data: UpdateCoachingRoleRequest },
  TContext
> => {
  const mutationKey = ["updateCoachingRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCoachingRole>>,
    { roleId: string; data: UpdateCoachingRoleRequest }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return updateCoachingRole(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCoachingRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCoachingRole>>
>;
export type UpdateCoachingRoleMutationBody = UpdateCoachingRoleRequest;
export type UpdateCoachingRoleMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update coaching role
 */
export const useUpdateCoachingRole = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCoachingRole>>,
      TError,
      { roleId: string; data: UpdateCoachingRoleRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateCoachingRole>>,
  TError,
  { roleId: string; data: UpdateCoachingRoleRequest },
  TContext
> => {
  return useMutation(getUpdateCoachingRoleMutationOptions(options), queryClient);
};

export const getDeleteCoachingRoleUrl = (roleId: string) => {
  return `/admin/coaching-roles/${roleId}`;
};

/**
 * Delete a coaching role (admin only).
 *
 * This will also delete the associated secret and remove
 * the role from all assignments.
 *
 * Built-in roles cannot be deleted (use disable instead).
 * @summary Delete coaching role
 */
export const deleteCoachingRole = async (
  roleId: string,
  options?: RequestInit
): Promise<DeleteResponse> => {
  return apiMutator<DeleteResponse>(getDeleteCoachingRoleUrl(roleId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCoachingRoleMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCoachingRole>>,
    TError,
    { roleId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCoachingRole>>,
  TError,
  { roleId: string },
  TContext
> => {
  const mutationKey = ["deleteCoachingRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCoachingRole>>,
    { roleId: string }
  > = (props) => {
    const { roleId } = props ?? {};

    return deleteCoachingRole(roleId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCoachingRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCoachingRole>>
>;

export type DeleteCoachingRoleMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete coaching role
 */
export const useDeleteCoachingRole = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCoachingRole>>,
      TError,
      { roleId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCoachingRole>>,
  TError,
  { roleId: string },
  TContext
> => {
  return useMutation(getDeleteCoachingRoleMutationOptions(options), queryClient);
};

export const getUploadCustomIconUrl = (roleId: string) => {
  return `/admin/coaching-roles/${roleId}/icon`;
};

/**
 * Upload a custom icon for a coaching role (admin only).
 *
 * Accepts PNG, JPEG, or SVG files up to 500KB.
 * @summary Upload custom icon
 */
export const uploadCustomIcon = async (
  roleId: string,
  bodyUploadCustomIconAdminCoachingRolesRoleIdIconPost: BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost,
  options?: RequestInit
): Promise<IconUrlResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadCustomIconAdminCoachingRolesRoleIdIconPost.file);

  return apiMutator<IconUrlResponse>(getUploadCustomIconUrl(roleId), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadCustomIconMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadCustomIcon>>,
    TError,
    { roleId: string; data: BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadCustomIcon>>,
  TError,
  { roleId: string; data: BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost },
  TContext
> => {
  const mutationKey = ["uploadCustomIcon"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadCustomIcon>>,
    { roleId: string; data: BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return uploadCustomIcon(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadCustomIconMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadCustomIcon>>
>;
export type UploadCustomIconMutationBody = BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost;
export type UploadCustomIconMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Upload custom icon
 */
export const useUploadCustomIcon = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadCustomIcon>>,
      TError,
      { roleId: string; data: BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof uploadCustomIcon>>,
  TError,
  { roleId: string; data: BodyUploadCustomIconAdminCoachingRolesRoleIdIconPost },
  TContext
> => {
  return useMutation(getUploadCustomIconMutationOptions(options), queryClient);
};

export const getReorderCoachingRolesUrl = () => {
  return `/admin/coaching-roles/reorder`;
};

/**
 * Reorder coaching roles (admin only).
 *
 * Updates display_order based on provided role_ids array order.
 * @summary Reorder coaching roles
 */
export const reorderCoachingRoles = async (
  reorderCoachingRolesRequest: ReorderCoachingRolesRequest,
  options?: RequestInit
): Promise<ReorderResponse> => {
  return apiMutator<ReorderResponse>(getReorderCoachingRolesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderCoachingRolesRequest),
  });
};

export const getReorderCoachingRolesMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderCoachingRoles>>,
    TError,
    { data: ReorderCoachingRolesRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderCoachingRoles>>,
  TError,
  { data: ReorderCoachingRolesRequest },
  TContext
> => {
  const mutationKey = ["reorderCoachingRoles"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderCoachingRoles>>,
    { data: ReorderCoachingRolesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return reorderCoachingRoles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderCoachingRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderCoachingRoles>>
>;
export type ReorderCoachingRolesMutationBody = ReorderCoachingRolesRequest;
export type ReorderCoachingRolesMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reorder coaching roles
 */
export const useReorderCoachingRoles = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderCoachingRoles>>,
      TError,
      { data: ReorderCoachingRolesRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderCoachingRoles>>,
  TError,
  { data: ReorderCoachingRolesRequest },
  TContext
> => {
  return useMutation(getReorderCoachingRolesMutationOptions(options), queryClient);
};

export const getGetRoleAssignmentsUrl = () => {
  return `/admin/coaching-roles/assignments/by-role`;
};

/**
 * Get all role-based assignments (admin only).
 *
 * Returns which coaching roles are assigned to each user role
 * (user, manager, director, administrator).
 * @summary Get role assignments
 */
export const getRoleAssignments = async (
  options?: RequestInit
): Promise<RoleAssignmentListResponse> => {
  return apiMutator<RoleAssignmentListResponse>(getGetRoleAssignmentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRoleAssignmentsQueryKey = () => {
  return [`/admin/coaching-roles/assignments/by-role`] as const;
};

export const getGetRoleAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleAssignments>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleAssignments>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRoleAssignmentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoleAssignments>>> = ({ signal }) =>
    getRoleAssignments({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleAssignments>>
>;
export type GetRoleAssignmentsQueryError = ErrorResponse;

export function useGetRoleAssignments<
  TData = Awaited<ReturnType<typeof getRoleAssignments>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleAssignments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getRoleAssignments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRoleAssignments<
  TData = Awaited<ReturnType<typeof getRoleAssignments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRoleAssignments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getRoleAssignments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRoleAssignments<
  TData = Awaited<ReturnType<typeof getRoleAssignments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleAssignments>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get role assignments
 */

export function useGetRoleAssignments<
  TData = Awaited<ReturnType<typeof getRoleAssignments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleAssignments>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRoleAssignmentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateRoleAssignmentUrl = (userRole: string) => {
  return `/admin/coaching-roles/assignments/by-role/${userRole}`;
};

/**
 * Update coaching role assignment for a user role (admin only).
 * @summary Update role assignment
 */
export const updateRoleAssignment = async (
  userRole: string,
  updateRoleAssignmentRequest: UpdateRoleAssignmentRequest,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getUpdateRoleAssignmentUrl(userRole), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateRoleAssignmentRequest),
  });
};

export const getUpdateRoleAssignmentMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRoleAssignment>>,
    TError,
    { userRole: string; data: UpdateRoleAssignmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRoleAssignment>>,
  TError,
  { userRole: string; data: UpdateRoleAssignmentRequest },
  TContext
> => {
  const mutationKey = ["updateRoleAssignment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRoleAssignment>>,
    { userRole: string; data: UpdateRoleAssignmentRequest }
  > = (props) => {
    const { userRole, data } = props ?? {};

    return updateRoleAssignment(userRole, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoleAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRoleAssignment>>
>;
export type UpdateRoleAssignmentMutationBody = UpdateRoleAssignmentRequest;
export type UpdateRoleAssignmentMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update role assignment
 */
export const useUpdateRoleAssignment = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRoleAssignment>>,
      TError,
      { userRole: string; data: UpdateRoleAssignmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateRoleAssignment>>,
  TError,
  { userRole: string; data: UpdateRoleAssignmentRequest },
  TContext
> => {
  return useMutation(getUpdateRoleAssignmentMutationOptions(options), queryClient);
};

export const getGetUserAssignmentUrl = (userId: string) => {
  return `/admin/coaching-roles/assignments/user/${userId}`;
};

/**
 * Get individual user's additional coaching role assignments (admin only).
 * @summary Get user assignment
 */
export const getUserAssignment = async (
  userId: string,
  options?: RequestInit
): Promise<UserCoachingAssignment> => {
  return apiMutator<UserCoachingAssignment>(getGetUserAssignmentUrl(userId), {
    ...options,
    method: "GET",
  });
};

export const getGetUserAssignmentQueryKey = (userId: string) => {
  return [`/admin/coaching-roles/assignments/user/${userId}`] as const;
};

export const getGetUserAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAssignment>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssignment>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserAssignmentQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAssignment>>> = ({ signal }) =>
    getUserAssignment(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUserAssignment>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUserAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserAssignment>>
>;
export type GetUserAssignmentQueryError = ErrorResponse | HTTPValidationError;

export function useGetUserAssignment<
  TData = Awaited<ReturnType<typeof getUserAssignment>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssignment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssignment>>,
          TError,
          Awaited<ReturnType<typeof getUserAssignment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAssignment<
  TData = Awaited<ReturnType<typeof getUserAssignment>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssignment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssignment>>,
          TError,
          Awaited<ReturnType<typeof getUserAssignment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAssignment<
  TData = Awaited<ReturnType<typeof getUserAssignment>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssignment>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user assignment
 */

export function useGetUserAssignment<
  TData = Awaited<ReturnType<typeof getUserAssignment>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssignment>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserAssignmentQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateUserAssignmentUrl = (userId: string) => {
  return `/admin/coaching-roles/assignments/user/${userId}`;
};

/**
 * Update individual user's additional coaching role assignments (admin only).
 *
 * These are additional roles beyond what the user gets from their user role.
 * @summary Update user assignment
 */
export const updateUserAssignment = async (
  userId: string,
  updateUserAssignmentRequest: UpdateUserAssignmentRequest,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getUpdateUserAssignmentUrl(userId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserAssignmentRequest),
  });
};

export const getUpdateUserAssignmentMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserAssignment>>,
    TError,
    { userId: string; data: UpdateUserAssignmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserAssignment>>,
  TError,
  { userId: string; data: UpdateUserAssignmentRequest },
  TContext
> => {
  const mutationKey = ["updateUserAssignment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserAssignment>>,
    { userId: string; data: UpdateUserAssignmentRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateUserAssignment(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserAssignment>>
>;
export type UpdateUserAssignmentMutationBody = UpdateUserAssignmentRequest;
export type UpdateUserAssignmentMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update user assignment
 */
export const useUpdateUserAssignment = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserAssignment>>,
      TError,
      { userId: string; data: UpdateUserAssignmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserAssignment>>,
  TError,
  { userId: string; data: UpdateUserAssignmentRequest },
  TContext
> => {
  return useMutation(getUpdateUserAssignmentMutationOptions(options), queryClient);
};

export const getGetDocumentGenerationSettingsUrl = () => {
  return `/admin/document-generation`;
};

/**
 * Get document generation settings including audit fields.
 *
 * Requires READ_SYSTEM permission.
 * @summary Get document generation settings
 */
export const getDocumentGenerationSettings = async (
  options?: RequestInit
): Promise<DocumentGenerationSettingsResponse> => {
  return apiMutator<DocumentGenerationSettingsResponse>(getGetDocumentGenerationSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDocumentGenerationSettingsQueryKey = () => {
  return [`/admin/document-generation`] as const;
};

export const getGetDocumentGenerationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDocumentGenerationSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDocumentGenerationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentGenerationSettings>>> = ({
    signal,
  }) => getDocumentGenerationSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDocumentGenerationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentGenerationSettings>>
>;
export type GetDocumentGenerationSettingsQueryError = ErrorResponse;

export function useGetDocumentGenerationSettings<
  TData = Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocumentGenerationSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
          TError,
          Awaited<ReturnType<typeof getDocumentGenerationSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDocumentGenerationSettings<
  TData = Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocumentGenerationSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
          TError,
          Awaited<ReturnType<typeof getDocumentGenerationSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDocumentGenerationSettings<
  TData = Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocumentGenerationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get document generation settings
 */

export function useGetDocumentGenerationSettings<
  TData = Awaited<ReturnType<typeof getDocumentGenerationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocumentGenerationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDocumentGenerationSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateDocumentGenerationSettingsUrl = () => {
  return `/admin/document-generation`;
};

/**
 * Update document generation settings.
 *
 * Requires WRITE_SYSTEM permission.
 * Supports partial updates - only specified fields are modified.
 * @summary Update document generation settings
 */
export const updateDocumentGenerationSettings = async (
  documentGenerationSettingsUpdate: DocumentGenerationSettingsUpdate,
  options?: RequestInit
): Promise<DocumentGenerationSettingsResponse> => {
  return apiMutator<DocumentGenerationSettingsResponse>(getUpdateDocumentGenerationSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(documentGenerationSettingsUpdate),
  });
};

export const getUpdateDocumentGenerationSettingsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDocumentGenerationSettings>>,
    TError,
    { data: DocumentGenerationSettingsUpdate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDocumentGenerationSettings>>,
  TError,
  { data: DocumentGenerationSettingsUpdate },
  TContext
> => {
  const mutationKey = ["updateDocumentGenerationSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDocumentGenerationSettings>>,
    { data: DocumentGenerationSettingsUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateDocumentGenerationSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDocumentGenerationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDocumentGenerationSettings>>
>;
export type UpdateDocumentGenerationSettingsMutationBody = DocumentGenerationSettingsUpdate;
export type UpdateDocumentGenerationSettingsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update document generation settings
 */
export const useUpdateDocumentGenerationSettings = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDocumentGenerationSettings>>,
      TError,
      { data: DocumentGenerationSettingsUpdate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDocumentGenerationSettings>>,
  TError,
  { data: DocumentGenerationSettingsUpdate },
  TContext
> => {
  return useMutation(getUpdateDocumentGenerationSettingsMutationOptions(options), queryClient);
};

export const getListTemplatesUrl = () => {
  return `/admin/document-generation/templates`;
};

/**
 * List all document templates.
 *
 * Requires READ_SYSTEM permission.
 * @summary List document templates
 */
export const listTemplates = async (options?: RequestInit): Promise<TemplateListResponse> => {
  return apiMutator<TemplateListResponse>(getListTemplatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTemplatesQueryKey = () => {
  return [`/admin/document-generation/templates`] as const;
};

export const getListTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) =>
    listTemplates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>;
export type ListTemplatesQueryError = ErrorResponse;

export function useListTemplates<
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTemplates<
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTemplates<
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List document templates
 */

export function useListTemplates<
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTemplatesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateTemplateUrl = () => {
  return `/admin/document-generation/templates`;
};

/**
 * Create a new custom document template.
 *
 * Requires WRITE_SYSTEM permission.
 * @summary Create document template
 */
export const createTemplate = async (
  createTemplateRequest: CreateTemplateRequest,
  options?: RequestInit
): Promise<TemplateResponse> => {
  return apiMutator<TemplateResponse>(getCreateTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTemplateRequest),
  });
};

export const getCreateTemplateMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    { data: CreateTemplateRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { data: CreateTemplateRequest },
  TContext
> => {
  const mutationKey = ["createTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTemplate>>,
    { data: CreateTemplateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplate>>>;
export type CreateTemplateMutationBody = CreateTemplateRequest;
export type CreateTemplateMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create document template
 */
export const useCreateTemplate = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTemplate>>,
      TError,
      { data: CreateTemplateRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { data: CreateTemplateRequest },
  TContext
> => {
  return useMutation(getCreateTemplateMutationOptions(options), queryClient);
};

export const getUpdateTemplateUrl = (templateId: string) => {
  return `/admin/document-generation/templates/${templateId}`;
};

/**
 * Update a document template.
 *
 * Requires WRITE_SYSTEM permission.
 * @summary Update document template
 */
export const updateTemplate = async (
  templateId: string,
  updateTemplateRequest: UpdateTemplateRequest,
  options?: RequestInit
): Promise<TemplateResponse> => {
  return apiMutator<TemplateResponse>(getUpdateTemplateUrl(templateId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTemplateRequest),
  });
};

export const getUpdateTemplateMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTemplate>>,
    TError,
    { templateId: string; data: UpdateTemplateRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { templateId: string; data: UpdateTemplateRequest },
  TContext
> => {
  const mutationKey = ["updateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTemplate>>,
    { templateId: string; data: UpdateTemplateRequest }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return updateTemplate(templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplate>>>;
export type UpdateTemplateMutationBody = UpdateTemplateRequest;
export type UpdateTemplateMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update document template
 */
export const useUpdateTemplate = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTemplate>>,
      TError,
      { templateId: string; data: UpdateTemplateRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { templateId: string; data: UpdateTemplateRequest },
  TContext
> => {
  return useMutation(getUpdateTemplateMutationOptions(options), queryClient);
};

export const getDeleteTemplateUrl = (templateId: string) => {
  return `/admin/document-generation/templates/${templateId}`;
};

/**
 * Delete a non-system document template.
 *
 * System templates cannot be deleted.
 * Requires WRITE_SYSTEM permission.
 * @summary Delete document template
 */
export const deleteTemplate = async (templateId: string, options?: RequestInit): Promise<void> => {
  return apiMutator<void>(getDeleteTemplateUrl(templateId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTemplateMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplate>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ["deleteTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTemplate>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return deleteTemplate(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplate>>>;

export type DeleteTemplateMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete document template
 */
export const useDeleteTemplate = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTemplate>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { templateId: string },
  TContext
> => {
  return useMutation(getDeleteTemplateMutationOptions(options), queryClient);
};

export const getUploadTemplateFileUrl = (templateId: string) => {
  return `/admin/document-generation/templates/${templateId}/file`;
};

/**
 * Upload a template file for a file-based template.
 *
 * Validates file size, format, and rejects files containing macros.
 * Replaces the existing file in GCS and invalidates the renderer cache.
 * Requires WRITE_SYSTEM permission.
 * @summary Upload template file (file-based templates)
 */
export const uploadTemplateFile = async (
  templateId: string,
  bodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost: BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost,
  options?: RequestInit
): Promise<TemplateResponse> => {
  const formData = new FormData();
  formData.append(
    `file`,
    bodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost.file
  );

  return apiMutator<TemplateResponse>(getUploadTemplateFileUrl(templateId), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadTemplateFileMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadTemplateFile>>,
    TError,
    {
      templateId: string;
      data: BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadTemplateFile>>,
  TError,
  {
    templateId: string;
    data: BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost;
  },
  TContext
> => {
  const mutationKey = ["uploadTemplateFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadTemplateFile>>,
    {
      templateId: string;
      data: BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost;
    }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return uploadTemplateFile(templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadTemplateFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadTemplateFile>>
>;
export type UploadTemplateFileMutationBody =
  BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost;
export type UploadTemplateFileMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Upload template file (file-based templates)
 */
export const useUploadTemplateFile = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadTemplateFile>>,
      TError,
      {
        templateId: string;
        data: BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof uploadTemplateFile>>,
  TError,
  {
    templateId: string;
    data: BodyUploadTemplateFileAdminDocumentGenerationTemplatesTemplateIdFilePost;
  },
  TContext
> => {
  return useMutation(getUploadTemplateFileMutationOptions(options), queryClient);
};

export const getDownloadTemplateFileUrl = (templateId: string) => {
  return `/admin/document-generation/templates/${templateId}/file`;
};

/**
 * Download the template file for a file-based template.
 *
 * Returns the file with Content-Disposition: attachment.
 * Requires READ_SYSTEM permission.
 * @summary Download template file (file-based templates)
 */
export const downloadTemplateFile = async (
  templateId: string,
  options?: RequestInit
): Promise<unknown> => {
  return apiMutator<unknown>(getDownloadTemplateFileUrl(templateId), {
    ...options,
    method: "GET",
  });
};

export const getDownloadTemplateFileQueryKey = (templateId: string) => {
  return [`/admin/document-generation/templates/${templateId}/file`] as const;
};

export const getDownloadTemplateFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadTemplateFile>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadTemplateFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadTemplateFileQueryKey(templateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadTemplateFile>>> = ({ signal }) =>
    downloadTemplateFile(templateId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: templateId !== null && templateId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof downloadTemplateFile>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DownloadTemplateFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadTemplateFile>>
>;
export type DownloadTemplateFileQueryError = ErrorResponse | HTTPValidationError;

export function useDownloadTemplateFile<
  TData = Awaited<ReturnType<typeof downloadTemplateFile>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadTemplateFile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTemplateFile>>,
          TError,
          Awaited<ReturnType<typeof downloadTemplateFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadTemplateFile<
  TData = Awaited<ReturnType<typeof downloadTemplateFile>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadTemplateFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTemplateFile>>,
          TError,
          Awaited<ReturnType<typeof downloadTemplateFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadTemplateFile<
  TData = Awaited<ReturnType<typeof downloadTemplateFile>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadTemplateFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download template file (file-based templates)
 */

export function useDownloadTemplateFile<
  TData = Awaited<ReturnType<typeof downloadTemplateFile>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadTemplateFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadTemplateFileQueryOptions(templateId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetImageGenerationSettingsUrl = () => {
  return `/admin/image-generation`;
};

/**
 * Get image generation settings including audit fields.
 *
 * Requires READ_SYSTEM permission.
 * Returns full settings with updated_at and updated_by fields.
 * @summary Get image generation settings
 */
export const getImageGenerationSettings = async (
  options?: RequestInit
): Promise<ImageGenerationSettingsResponse> => {
  return apiMutator<ImageGenerationSettingsResponse>(getGetImageGenerationSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetImageGenerationSettingsQueryKey = () => {
  return [`/admin/image-generation`] as const;
};

export const getGetImageGenerationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getImageGenerationSettings>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getImageGenerationSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImageGenerationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImageGenerationSettings>>> = ({
    signal,
  }) => getImageGenerationSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getImageGenerationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetImageGenerationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImageGenerationSettings>>
>;
export type GetImageGenerationSettingsQueryError = ErrorResponse;

export function useGetImageGenerationSettings<
  TData = Awaited<ReturnType<typeof getImageGenerationSettings>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImageGenerationSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageGenerationSettings>>,
          TError,
          Awaited<ReturnType<typeof getImageGenerationSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImageGenerationSettings<
  TData = Awaited<ReturnType<typeof getImageGenerationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImageGenerationSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageGenerationSettings>>,
          TError,
          Awaited<ReturnType<typeof getImageGenerationSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImageGenerationSettings<
  TData = Awaited<ReturnType<typeof getImageGenerationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImageGenerationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get image generation settings
 */

export function useGetImageGenerationSettings<
  TData = Awaited<ReturnType<typeof getImageGenerationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImageGenerationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetImageGenerationSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateImageGenerationSettingsUrl = () => {
  return `/admin/image-generation`;
};

/**
 * Update image generation settings.
 *
 * Requires WRITE_SYSTEM permission.
 * Supports partial updates - only specified fields are modified.
 * @summary Update image generation settings
 */
export const updateImageGenerationSettings = async (
  imageGenerationSettingsUpdate: ImageGenerationSettingsUpdate,
  options?: RequestInit
): Promise<ImageGenerationSettingsResponse> => {
  return apiMutator<ImageGenerationSettingsResponse>(getUpdateImageGenerationSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(imageGenerationSettingsUpdate),
  });
};

export const getUpdateImageGenerationSettingsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateImageGenerationSettings>>,
    TError,
    { data: ImageGenerationSettingsUpdate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateImageGenerationSettings>>,
  TError,
  { data: ImageGenerationSettingsUpdate },
  TContext
> => {
  const mutationKey = ["updateImageGenerationSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateImageGenerationSettings>>,
    { data: ImageGenerationSettingsUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateImageGenerationSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateImageGenerationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateImageGenerationSettings>>
>;
export type UpdateImageGenerationSettingsMutationBody = ImageGenerationSettingsUpdate;
export type UpdateImageGenerationSettingsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update image generation settings
 */
export const useUpdateImageGenerationSettings = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateImageGenerationSettings>>,
      TError,
      { data: ImageGenerationSettingsUpdate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateImageGenerationSettings>>,
  TError,
  { data: ImageGenerationSettingsUpdate },
  TContext
> => {
  return useMutation(getUpdateImageGenerationSettingsMutationOptions(options), queryClient);
};

export const getListOrgCalendarsUrl = () => {
  return `/admin/outlook/org-calendars`;
};

/**
 * List calendars available to the admin for org calendar selection.
 *
 * Requires administrator role and Microsoft 365 sign-in.
 * @summary List calendars for org selection
 */
export const listOrgCalendars = async (options?: RequestInit): Promise<OrgCalendarsResponse> => {
  return apiMutator<OrgCalendarsResponse>(getListOrgCalendarsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListOrgCalendarsQueryKey = () => {
  return [`/admin/outlook/org-calendars`] as const;
};

export const getListOrgCalendarsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrgCalendars>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgCalendars>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOrgCalendarsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgCalendars>>> = ({ signal }) =>
    listOrgCalendars({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrgCalendars>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrgCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgCalendars>>>;
export type ListOrgCalendarsQueryError = ErrorResponse;

export function useListOrgCalendars<
  TData = Awaited<ReturnType<typeof listOrgCalendars>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgCalendars>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgCalendars>>,
          TError,
          Awaited<ReturnType<typeof listOrgCalendars>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrgCalendars<
  TData = Awaited<ReturnType<typeof listOrgCalendars>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgCalendars>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgCalendars>>,
          TError,
          Awaited<ReturnType<typeof listOrgCalendars>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrgCalendars<
  TData = Awaited<ReturnType<typeof listOrgCalendars>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgCalendars>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List calendars for org selection
 */

export function useListOrgCalendars<
  TData = Awaited<ReturnType<typeof listOrgCalendars>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgCalendars>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListOrgCalendarsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSetOrgCalendarUrl = () => {
  return `/admin/outlook/org-calendar`;
};

/**
 * Set the organization calendar for company events.
 *
 * Requires administrator role and Microsoft 365 sign-in.
 * @summary Set organization calendar
 */
export const setOrgCalendar = async (
  setOrgCalendarRequest: SetOrgCalendarRequest,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getSetOrgCalendarUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setOrgCalendarRequest),
  });
};

export const getSetOrgCalendarMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrgCalendar>>,
    TError,
    { data: SetOrgCalendarRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setOrgCalendar>>,
  TError,
  { data: SetOrgCalendarRequest },
  TContext
> => {
  const mutationKey = ["setOrgCalendar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setOrgCalendar>>,
    { data: SetOrgCalendarRequest }
  > = (props) => {
    const { data } = props ?? {};

    return setOrgCalendar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetOrgCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof setOrgCalendar>>>;
export type SetOrgCalendarMutationBody = SetOrgCalendarRequest;
export type SetOrgCalendarMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Set organization calendar
 */
export const useSetOrgCalendar = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setOrgCalendar>>,
      TError,
      { data: SetOrgCalendarRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setOrgCalendar>>,
  TError,
  { data: SetOrgCalendarRequest },
  TContext
> => {
  return useMutation(getSetOrgCalendarMutationOptions(options), queryClient);
};

export const getDisableOrgCalendarUrl = () => {
  return `/admin/outlook/org-calendar`;
};

/**
 * Disable the organization calendar feature.
 *
 * Requires administrator role.
 * @summary Disable organization calendar
 */
export const disableOrgCalendar = async (options?: RequestInit): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getDisableOrgCalendarUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDisableOrgCalendarMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableOrgCalendar>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof disableOrgCalendar>>, TError, void, TContext> => {
  const mutationKey = ["disableOrgCalendar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableOrgCalendar>>, void> = () => {
    return disableOrgCalendar(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableOrgCalendarMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableOrgCalendar>>
>;

export type DisableOrgCalendarMutationError = ErrorResponse;

/**
 * @summary Disable organization calendar
 */
export const useDisableOrgCalendar = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disableOrgCalendar>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof disableOrgCalendar>>, TError, void, TContext> => {
  return useMutation(getDisableOrgCalendarMutationOptions(options), queryClient);
};

export const getGetOrgStatusUrl = () => {
  return `/admin/outlook/org-status`;
};

/**
 * Get organization calendar connection status.
 *
 * Requires administrator role.
 * @summary Get organization calendar status
 */
export const getOrgStatus = async (options?: RequestInit): Promise<OrgCalendarStatusResponse> => {
  return apiMutator<OrgCalendarStatusResponse>(getGetOrgStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOrgStatusQueryKey = () => {
  return [`/admin/outlook/org-status`] as const;
};

export const getGetOrgStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgStatus>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrgStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgStatus>>> = ({ signal }) =>
    getOrgStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgStatus>>>;
export type GetOrgStatusQueryError = ErrorResponse;

export function useGetOrgStatus<
  TData = Awaited<ReturnType<typeof getOrgStatus>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrgStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrgStatus<
  TData = Awaited<ReturnType<typeof getOrgStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrgStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrgStatus<
  TData = Awaited<ReturnType<typeof getOrgStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization calendar status
 */

export function useGetOrgStatus<
  TData = Awaited<ReturnType<typeof getOrgStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrgStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPreviewOrgEventsUrl = (params?: PreviewOrgEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/admin/outlook/org-events?${stringifiedParams}`
    : `/admin/outlook/org-events`;
};

/**
 * Preview company events from the organization calendar.
 *
 * Requires administrator role and Microsoft 365 sign-in.
 * @summary Preview organization calendar events
 */
export const previewOrgEvents = async (
  params?: PreviewOrgEventsParams,
  options?: RequestInit
): Promise<CompanyEventsResponse> => {
  return apiMutator<CompanyEventsResponse>(getPreviewOrgEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getPreviewOrgEventsQueryKey = (params?: PreviewOrgEventsParams) => {
  return [`/admin/outlook/org-events`, ...(params ? [params] : [])] as const;
};

export const getPreviewOrgEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof previewOrgEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: PreviewOrgEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPreviewOrgEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof previewOrgEvents>>> = ({ signal }) =>
    previewOrgEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof previewOrgEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PreviewOrgEventsQueryResult = NonNullable<Awaited<ReturnType<typeof previewOrgEvents>>>;
export type PreviewOrgEventsQueryError = ErrorResponse | HTTPValidationError;

export function usePreviewOrgEvents<
  TData = Awaited<ReturnType<typeof previewOrgEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | PreviewOrgEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewOrgEvents>>,
          TError,
          Awaited<ReturnType<typeof previewOrgEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePreviewOrgEvents<
  TData = Awaited<ReturnType<typeof previewOrgEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: PreviewOrgEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewOrgEvents>>,
          TError,
          Awaited<ReturnType<typeof previewOrgEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePreviewOrgEvents<
  TData = Awaited<ReturnType<typeof previewOrgEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: PreviewOrgEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Preview organization calendar events
 */

export function usePreviewOrgEvents<
  TData = Awaited<ReturnType<typeof previewOrgEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: PreviewOrgEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewOrgEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPreviewOrgEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getReorderCategoriesUrl = () => {
  return `/admin/resource-categories/reorder`;
};

/**
 * Bulk update display order for categories (admin only).
 *
 * The 'uncategorized' category is always displayed last and should not be
 * included in the order list.
 * @summary Reorder resource categories
 */
export const reorderCategories = async (
  reorderCategoriesRequest: ReorderCategoriesRequest,
  options?: RequestInit
): Promise<ReorderCategoriesResponse> => {
  return apiMutator<ReorderCategoriesResponse>(getReorderCategoriesUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderCategoriesRequest),
  });
};

export const getReorderCategoriesMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderCategories>>,
    TError,
    { data: ReorderCategoriesRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderCategories>>,
  TError,
  { data: ReorderCategoriesRequest },
  TContext
> => {
  const mutationKey = ["reorderCategories"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderCategories>>,
    { data: ReorderCategoriesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return reorderCategories(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderCategories>>
>;
export type ReorderCategoriesMutationBody = ReorderCategoriesRequest;
export type ReorderCategoriesMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reorder resource categories
 */
export const useReorderCategories = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderCategories>>,
      TError,
      { data: ReorderCategoriesRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderCategories>>,
  TError,
  { data: ReorderCategoriesRequest },
  TContext
> => {
  return useMutation(getReorderCategoriesMutationOptions(options), queryClient);
};

export const getListAdminCategoriesUrl = () => {
  return `/admin/resource-categories`;
};

/**
 * List all resource categories with resource counts (admin only).
 *
 * Categories are returned sorted by display_order.
 * @summary List all resource categories
 */
export const listAdminCategories = async (
  options?: RequestInit
): Promise<ResourceCategoryAdminListResponse> => {
  return apiMutator<ResourceCategoryAdminListResponse>(getListAdminCategoriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminCategoriesQueryKey = () => {
  return [`/admin/resource-categories`] as const;
};

export const getListAdminCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminCategories>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCategories>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCategories>>> = ({ signal }) =>
    listAdminCategories({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAdminCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminCategories>>
>;
export type ListAdminCategoriesQueryError = ErrorResponse;

export function useListAdminCategories<
  TData = Awaited<ReturnType<typeof listAdminCategories>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminCategories>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminCategories>>,
          TError,
          Awaited<ReturnType<typeof listAdminCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAdminCategories<
  TData = Awaited<ReturnType<typeof listAdminCategories>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminCategories>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminCategories>>,
          TError,
          Awaited<ReturnType<typeof listAdminCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAdminCategories<
  TData = Awaited<ReturnType<typeof listAdminCategories>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminCategories>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all resource categories
 */

export function useListAdminCategories<
  TData = Awaited<ReturnType<typeof listAdminCategories>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAdminCategories>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAdminCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateCategoryUrl = () => {
  return `/admin/resource-categories`;
};

/**
 * Create a new resource category (admin only).
 *
 * The slug is auto-generated from the name. If display_order is not provided,
 * the category will be added at the end (before 'uncategorized').
 * @summary Create a resource category
 */
export const createCategory = async (
  createResourceCategoryRequest: CreateResourceCategoryRequest,
  options?: RequestInit
): Promise<ResourceCategoryAdminResponse> => {
  return apiMutator<ResourceCategoryAdminResponse>(getCreateCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createResourceCategoryRequest),
  });
};

export const getCreateCategoryMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    { data: CreateResourceCategoryRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: CreateResourceCategoryRequest },
  TContext
> => {
  const mutationKey = ["createCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategory>>,
    { data: CreateResourceCategoryRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>;
export type CreateCategoryMutationBody = CreateResourceCategoryRequest;
export type CreateCategoryMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create a resource category
 */
export const useCreateCategory = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCategory>>,
      TError,
      { data: CreateResourceCategoryRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: CreateResourceCategoryRequest },
  TContext
> => {
  return useMutation(getCreateCategoryMutationOptions(options), queryClient);
};

export const getGetCategoryUrl = (slug: string) => {
  return `/admin/resource-categories/${slug}`;
};

/**
 * Get a single resource category by slug (admin only).
 * @summary Get a resource category
 */
export const getCategory = async (
  slug: string,
  options?: RequestInit
): Promise<ResourceCategoryAdminResponse> => {
  return apiMutator<ResourceCategoryAdminResponse>(getGetCategoryUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetCategoryQueryKey = (slug: string) => {
  return [`/admin/resource-categories/${slug}`] as const;
};

export const getGetCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoryQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategory>>> = ({ signal }) =>
    getCategory(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCategory>>>;
export type GetCategoryQueryError = ErrorResponse | HTTPValidationError;

export function useGetCategory<
  TData = Awaited<ReturnType<typeof getCategory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategory>>,
          TError,
          Awaited<ReturnType<typeof getCategory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategory<
  TData = Awaited<ReturnType<typeof getCategory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategory>>,
          TError,
          Awaited<ReturnType<typeof getCategory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategory<
  TData = Awaited<ReturnType<typeof getCategory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a resource category
 */

export function useGetCategory<
  TData = Awaited<ReturnType<typeof getCategory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoryQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateCategoryUrl = (slug: string) => {
  return `/admin/resource-categories/${slug}`;
};

/**
 * Update an existing resource category (admin only).
 *
 * System categories (like 'uncategorized') cannot be modified.
 * @summary Update a resource category
 */
export const updateCategory = async (
  slug: string,
  updateResourceCategoryRequest: UpdateResourceCategoryRequest,
  options?: RequestInit
): Promise<ResourceCategoryAdminResponse> => {
  return apiMutator<ResourceCategoryAdminResponse>(getUpdateCategoryUrl(slug), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateResourceCategoryRequest),
  });
};

export const getUpdateCategoryMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    { slug: string; data: UpdateResourceCategoryRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { slug: string; data: UpdateResourceCategoryRequest },
  TContext
> => {
  const mutationKey = ["updateCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCategory>>,
    { slug: string; data: UpdateResourceCategoryRequest }
  > = (props) => {
    const { slug, data } = props ?? {};

    return updateCategory(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>;
export type UpdateCategoryMutationBody = UpdateResourceCategoryRequest;
export type UpdateCategoryMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update a resource category
 */
export const useUpdateCategory = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCategory>>,
      TError,
      { slug: string; data: UpdateResourceCategoryRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { slug: string; data: UpdateResourceCategoryRequest },
  TContext
> => {
  return useMutation(getUpdateCategoryMutationOptions(options), queryClient);
};

export const getDeleteCategoryUrl = (slug: string) => {
  return `/admin/resource-categories/${slug}`;
};

/**
 * Delete a resource category (admin only).
 *
 * All resources using this category will be reassigned to 'uncategorized'.
 * System categories (like 'uncategorized') cannot be deleted.
 * @summary Delete a resource category
 */
export const deleteCategory = async (
  slug: string,
  options?: RequestInit
): Promise<DeleteCategoryResponse> => {
  return apiMutator<DeleteCategoryResponse>(getDeleteCategoryUrl(slug), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCategoryMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationKey = ["deleteCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCategory>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {};

    return deleteCategory(slug, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>;

export type DeleteCategoryMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a resource category
 */
export const useDeleteCategory = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCategory>>,
      TError,
      { slug: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { slug: string },
  TContext
> => {
  return useMutation(getDeleteCategoryMutationOptions(options), queryClient);
};

export const getGetAdminSessionSettingsUrl = () => {
  return `/admin/session`;
};

/**
 * Get session settings including audit fields.
 *
 * Requires READ_SYSTEM permission.
 * Returns full settings with updated_at and updated_by fields.
 * @summary Get session settings
 */
export const getAdminSessionSettings = async (
  options?: RequestInit
): Promise<SessionSettingsResponse> => {
  return apiMutator<SessionSettingsResponse>(getGetAdminSessionSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminSessionSettingsQueryKey = () => {
  return [`/admin/session`] as const;
};

export const getGetAdminSessionSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminSessionSettings>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAdminSessionSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminSessionSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSessionSettings>>> = ({
    signal,
  }) => getAdminSessionSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSessionSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminSessionSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminSessionSettings>>
>;
export type GetAdminSessionSettingsQueryError = ErrorResponse;

export function useGetAdminSessionSettings<
  TData = Awaited<ReturnType<typeof getAdminSessionSettings>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminSessionSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSessionSettings>>,
          TError,
          Awaited<ReturnType<typeof getAdminSessionSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminSessionSettings<
  TData = Awaited<ReturnType<typeof getAdminSessionSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminSessionSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSessionSettings>>,
          TError,
          Awaited<ReturnType<typeof getAdminSessionSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminSessionSettings<
  TData = Awaited<ReturnType<typeof getAdminSessionSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminSessionSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get session settings
 */

export function useGetAdminSessionSettings<
  TData = Awaited<ReturnType<typeof getAdminSessionSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminSessionSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminSessionSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateSessionSettingsUrl = () => {
  return `/admin/session`;
};

/**
 * Update session settings.
 *
 * Requires WRITE_SYSTEM permission.
 * Supports partial updates - only specified fields are modified.
 * @summary Update session settings
 */
export const updateSessionSettings = async (
  sessionSettingsUpdate: SessionSettingsUpdate,
  options?: RequestInit
): Promise<SessionSettingsResponse> => {
  return apiMutator<SessionSettingsResponse>(getUpdateSessionSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sessionSettingsUpdate),
  });
};

export const getUpdateSessionSettingsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSessionSettings>>,
    TError,
    { data: SessionSettingsUpdate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSessionSettings>>,
  TError,
  { data: SessionSettingsUpdate },
  TContext
> => {
  const mutationKey = ["updateSessionSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSessionSettings>>,
    { data: SessionSettingsUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateSessionSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSessionSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSessionSettings>>
>;
export type UpdateSessionSettingsMutationBody = SessionSettingsUpdate;
export type UpdateSessionSettingsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update session settings
 */
export const useUpdateSessionSettings = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSessionSettings>>,
      TError,
      { data: SessionSettingsUpdate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSessionSettings>>,
  TError,
  { data: SessionSettingsUpdate },
  TContext
> => {
  return useMutation(getUpdateSessionSettingsMutationOptions(options), queryClient);
};

export const getAuthCallbackUrl = () => {
  return `/auth/callback`;
};

/**
 * @summary Authenticate with Firebase token
 */
export const authCallback = async (
  authCallbackRequest: AuthCallbackRequest,
  options?: RequestInit
): Promise<AuthCallbackResponse> => {
  return apiMutator<AuthCallbackResponse>(getAuthCallbackUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(authCallbackRequest),
  });
};

export const getAuthCallbackMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authCallback>>,
    TError,
    { data: AuthCallbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authCallback>>,
  TError,
  { data: AuthCallbackRequest },
  TContext
> => {
  const mutationKey = ["authCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authCallback>>,
    { data: AuthCallbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return authCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof authCallback>>>;
export type AuthCallbackMutationBody = AuthCallbackRequest;
export type AuthCallbackMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Authenticate with Firebase token
 */
export const useAuthCallback = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authCallback>>,
      TError,
      { data: AuthCallbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authCallback>>,
  TError,
  { data: AuthCallbackRequest },
  TContext
> => {
  return useMutation(getAuthCallbackMutationOptions(options), queryClient);
};

export const getGetProfileUrl = () => {
  return `/auth/profile`;
};

/**
 * @summary Get current user profile
 */
export const getProfile = async (options?: RequestInit): Promise<UserProfileResponse> => {
  return apiMutator<UserProfileResponse>(getGetProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetProfileQueryKey = () => {
  return [`/auth/profile`] as const;
};

export const getGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) =>
    getProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>;
export type GetProfileQueryError = ErrorResponse;

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current user profile
 */

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getLogoutUrl = () => {
  return `/auth/logout`;
};

/**
 * @summary Logout and revoke session
 */
export const logout = async (options?: RequestInit): Promise<LogoutResponse> => {
  return apiMutator<LogoutResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>;

export type LogoutMutationError = ErrorResponse;

/**
 * @summary Logout and revoke session
 */
export const useLogout = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof logout>>, TError, void, TContext> => {
  return useMutation(getLogoutMutationOptions(options), queryClient);
};

export const getRefreshSessionUrl = () => {
  return `/auth/refresh`;
};

/**
 * Extend the current session by issuing a new session cookie.
 *
 * Requires a fresh Firebase ID token from the client.
 * @summary Refresh session cookie
 */
export const refreshSession = async (
  sessionRefreshRequest: SessionRefreshRequest,
  options?: RequestInit
): Promise<SessionRefreshResponse> => {
  return apiMutator<SessionRefreshResponse>(getRefreshSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sessionRefreshRequest),
  });
};

export const getRefreshSessionMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSession>>,
    TError,
    { data: SessionRefreshRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshSession>>,
  TError,
  { data: SessionRefreshRequest },
  TContext
> => {
  const mutationKey = ["refreshSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshSession>>,
    { data: SessionRefreshRequest }
  > = (props) => {
    const { data } = props ?? {};

    return refreshSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshSessionMutationResult = NonNullable<Awaited<ReturnType<typeof refreshSession>>>;
export type RefreshSessionMutationBody = SessionRefreshRequest;
export type RefreshSessionMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Refresh session cookie
 */
export const useRefreshSession = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshSession>>,
      TError,
      { data: SessionRefreshRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof refreshSession>>,
  TError,
  { data: SessionRefreshRequest },
  TContext
> => {
  return useMutation(getRefreshSessionMutationOptions(options), queryClient);
};

export const getRegisterDevAccountUrl = () => {
  return `/auth/register-dev`;
};

/**
 * @summary Register development account
 */
export const registerDevAccount = async (
  registerDevAccountRequest: RegisterDevAccountRequest,
  options?: RequestInit
): Promise<RegisterDevAccountResponse> => {
  return apiMutator<RegisterDevAccountResponse>(getRegisterDevAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerDevAccountRequest),
  });
};

export const getRegisterDevAccountMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerDevAccount>>,
    TError,
    { data: RegisterDevAccountRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerDevAccount>>,
  TError,
  { data: RegisterDevAccountRequest },
  TContext
> => {
  const mutationKey = ["registerDevAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerDevAccount>>,
    { data: RegisterDevAccountRequest }
  > = (props) => {
    const { data } = props ?? {};

    return registerDevAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterDevAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerDevAccount>>
>;
export type RegisterDevAccountMutationBody = RegisterDevAccountRequest;
export type RegisterDevAccountMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Register development account
 */
export const useRegisterDevAccount = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerDevAccount>>,
      TError,
      { data: RegisterDevAccountRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof registerDevAccount>>,
  TError,
  { data: RegisterDevAccountRequest },
  TContext
> => {
  return useMutation(getRegisterDevAccountMutationOptions(options), queryClient);
};

export const getUpdateRoleUrl = () => {
  return `/auth/update-role`;
};

/**
 * @summary Update user role
 */
export const updateRole = async (
  updateRoleRequest: UpdateRoleRequest,
  options?: RequestInit
): Promise<UpdateRoleResponse> => {
  return apiMutator<UpdateRoleResponse>(getUpdateRoleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateRoleRequest),
  });
};

export const getUpdateRoleMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRole>>,
    TError,
    { data: UpdateRoleRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRole>>,
  TError,
  { data: UpdateRoleRequest },
  TContext
> => {
  const mutationKey = ["updateRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRole>>,
    { data: UpdateRoleRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>;
export type UpdateRoleMutationBody = UpdateRoleRequest;
export type UpdateRoleMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update user role
 */
export const useUpdateRole = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRole>>,
      TError,
      { data: UpdateRoleRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateRole>>,
  TError,
  { data: UpdateRoleRequest },
  TContext
> => {
  return useMutation(getUpdateRoleMutationOptions(options), queryClient);
};

export const getSessionStatusUrl = () => {
  return `/auth/session-status`;
};

/**
 * @summary Get session status
 */
export const sessionStatus = async (options?: RequestInit): Promise<SessionStatusResponse> => {
  return apiMutator<SessionStatusResponse>(getSessionStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getSessionStatusQueryKey = () => {
  return [`/auth/session-status`] as const;
};

export const getSessionStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof sessionStatus>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSessionStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionStatus>>> = ({ signal }) =>
    sessionStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sessionStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SessionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof sessionStatus>>>;
export type SessionStatusQueryError = ErrorResponse;

export function useSessionStatus<
  TData = Awaited<ReturnType<typeof sessionStatus>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionStatus>>,
          TError,
          Awaited<ReturnType<typeof sessionStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSessionStatus<
  TData = Awaited<ReturnType<typeof sessionStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sessionStatus>>,
          TError,
          Awaited<ReturnType<typeof sessionStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSessionStatus<
  TData = Awaited<ReturnType<typeof sessionStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get session status
 */

export function useSessionStatus<
  TData = Awaited<ReturnType<typeof sessionStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof sessionStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSessionStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetAllUsersUrl = () => {
  return `/auth/users`;
};

/**
 * Get all users in the system.
 *
 * Requires READ_USERS permission with ALL scope.
 * @summary Get all users
 */
export const getAllUsers = async (options?: RequestInit): Promise<UserProfileResponse[]> => {
  return apiMutator<UserProfileResponse[]>(getGetAllUsersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAllUsersQueryKey = () => {
  return [`/auth/users`] as const;
};

export const getGetAllUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsers>>> = ({ signal }) =>
    getAllUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>;
export type GetAllUsersQueryError = ErrorResponse;

export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all users
 */

export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllUsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAssignManagerUrl = (uid: string) => {
  return `/auth/users/${uid}/manager`;
};

/**
 * Assign or remove a manager for a user.
 *
 * Requires WRITE_USERS permission with ALL scope. Set manager_id to null to remove assignment.
 * @summary Assign manager to user
 */
export const assignManager = async (
  uid: string,
  assignManagerRequest: AssignManagerRequest,
  options?: RequestInit
): Promise<AssignManagerResponse> => {
  return apiMutator<AssignManagerResponse>(getAssignManagerUrl(uid), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignManagerRequest),
  });
};

export const getAssignManagerMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignManager>>,
    TError,
    { uid: string; data: AssignManagerRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignManager>>,
  TError,
  { uid: string; data: AssignManagerRequest },
  TContext
> => {
  const mutationKey = ["assignManager"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignManager>>,
    { uid: string; data: AssignManagerRequest }
  > = (props) => {
    const { uid, data } = props ?? {};

    return assignManager(uid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignManagerMutationResult = NonNullable<Awaited<ReturnType<typeof assignManager>>>;
export type AssignManagerMutationBody = AssignManagerRequest;
export type AssignManagerMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Assign manager to user
 */
export const useAssignManager = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignManager>>,
      TError,
      { uid: string; data: AssignManagerRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof assignManager>>,
  TError,
  { uid: string; data: AssignManagerRequest },
  TContext
> => {
  return useMutation(getAssignManagerMutationOptions(options), queryClient);
};

export const getGetUnassignedUsersUrl = () => {
  return `/auth/users/unassigned`;
};

/**
 * Get all users without an assigned manager.
 *
 * Requires READ_USERS permission with ALL scope.
 * @summary Get unassigned users
 */
export const getUnassignedUsers = async (
  options?: RequestInit
): Promise<UnassignedUsersResponse> => {
  return apiMutator<UnassignedUsersResponse>(getGetUnassignedUsersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetUnassignedUsersQueryKey = () => {
  return [`/auth/users/unassigned`] as const;
};

export const getGetUnassignedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnassignedUsers>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnassignedUsers>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUnassignedUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnassignedUsers>>> = ({ signal }) =>
    getUnassignedUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnassignedUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUnassignedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnassignedUsers>>
>;
export type GetUnassignedUsersQueryError = ErrorResponse;

export function useGetUnassignedUsers<
  TData = Awaited<ReturnType<typeof getUnassignedUsers>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnassignedUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnassignedUsers>>,
          TError,
          Awaited<ReturnType<typeof getUnassignedUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUnassignedUsers<
  TData = Awaited<ReturnType<typeof getUnassignedUsers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnassignedUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnassignedUsers>>,
          TError,
          Awaited<ReturnType<typeof getUnassignedUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUnassignedUsers<
  TData = Awaited<ReturnType<typeof getUnassignedUsers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnassignedUsers>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get unassigned users
 */

export function useGetUnassignedUsers<
  TData = Awaited<ReturnType<typeof getUnassignedUsers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnassignedUsers>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUnassignedUsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateUserDepartmentUrl = (uid: string) => {
  return `/auth/users/${uid}/department`;
};

/**
 * Update a user's department.
 *
 * Requires WRITE_USERS permission with ALL scope. Set department to null to unassign.
 * @summary Update user department
 */
export const updateUserDepartment = async (
  uid: string,
  updateUserDepartmentRequest: UpdateUserDepartmentRequest,
  options?: RequestInit
): Promise<UserProfileResponse> => {
  return apiMutator<UserProfileResponse>(getUpdateUserDepartmentUrl(uid), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserDepartmentRequest),
  });
};

export const getUpdateUserDepartmentMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserDepartment>>,
    TError,
    { uid: string; data: UpdateUserDepartmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserDepartment>>,
  TError,
  { uid: string; data: UpdateUserDepartmentRequest },
  TContext
> => {
  const mutationKey = ["updateUserDepartment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserDepartment>>,
    { uid: string; data: UpdateUserDepartmentRequest }
  > = (props) => {
    const { uid, data } = props ?? {};

    return updateUserDepartment(uid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserDepartmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserDepartment>>
>;
export type UpdateUserDepartmentMutationBody = UpdateUserDepartmentRequest;
export type UpdateUserDepartmentMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update user department
 */
export const useUpdateUserDepartment = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserDepartment>>,
      TError,
      { uid: string; data: UpdateUserDepartmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserDepartment>>,
  TError,
  { uid: string; data: UpdateUserDepartmentRequest },
  TContext
> => {
  return useMutation(getUpdateUserDepartmentMutationOptions(options), queryClient);
};

export const getBulkUpdateDepartmentsUrl = () => {
  return `/auth/users/bulk-department`;
};

/**
 * Bulk update departments for multiple users.
 *
 * Requires WRITE_USERS permission with ALL scope.
 * @summary Bulk update user departments
 */
export const bulkUpdateDepartments = async (
  bulkUpdateDepartmentRequest: BulkUpdateDepartmentRequest,
  options?: RequestInit
): Promise<BulkUpdateDepartmentResponse> => {
  return apiMutator<BulkUpdateDepartmentResponse>(getBulkUpdateDepartmentsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkUpdateDepartmentRequest),
  });
};

export const getBulkUpdateDepartmentsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateDepartments>>,
    TError,
    { data: BulkUpdateDepartmentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateDepartments>>,
  TError,
  { data: BulkUpdateDepartmentRequest },
  TContext
> => {
  const mutationKey = ["bulkUpdateDepartments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateDepartments>>,
    { data: BulkUpdateDepartmentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkUpdateDepartments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateDepartmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpdateDepartments>>
>;
export type BulkUpdateDepartmentsMutationBody = BulkUpdateDepartmentRequest;
export type BulkUpdateDepartmentsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Bulk update user departments
 */
export const useBulkUpdateDepartments = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkUpdateDepartments>>,
      TError,
      { data: BulkUpdateDepartmentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpdateDepartments>>,
  TError,
  { data: BulkUpdateDepartmentRequest },
  TContext
> => {
  return useMutation(getBulkUpdateDepartmentsMutationOptions(options), queryClient);
};

export const getGetAvatarUploadUrlUrl = () => {
  return `/avatar/upload-url`;
};

/**
 * Request a signed URL for photo upload.
 *
 * Creates an avatar record and returns a signed URL for the user
 * to upload their photo directly to GCS.
 * @summary Get avatar upload URL
 */
export const getAvatarUploadUrl = async (
  avatarUploadUrlRequest: AvatarUploadUrlRequest,
  options?: RequestInit
): Promise<AvatarUploadUrlResponse> => {
  return apiMutator<AvatarUploadUrlResponse>(getGetAvatarUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(avatarUploadUrlRequest),
  });
};

export const getGetAvatarUploadUrlMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvatarUploadUrl>>,
    TError,
    { data: AvatarUploadUrlRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvatarUploadUrl>>,
  TError,
  { data: AvatarUploadUrlRequest },
  TContext
> => {
  const mutationKey = ["getAvatarUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvatarUploadUrl>>,
    { data: AvatarUploadUrlRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getAvatarUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvatarUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAvatarUploadUrl>>
>;
export type GetAvatarUploadUrlMutationBody = AvatarUploadUrlRequest;
export type GetAvatarUploadUrlMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Get avatar upload URL
 */
export const useGetAvatarUploadUrl = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAvatarUploadUrl>>,
      TError,
      { data: AvatarUploadUrlRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAvatarUploadUrl>>,
  TError,
  { data: AvatarUploadUrlRequest },
  TContext
> => {
  return useMutation(getGetAvatarUploadUrlMutationOptions(options), queryClient);
};

export const getConfirmUploadUrl = (avatarId: string) => {
  return `/avatar/${avatarId}/confirm-upload`;
};

/**
 * Confirm photo upload and trigger face validation.
 *
 * Called after the user has uploaded their photo to GCS.
 * Downloads the photo, validates it contains a face, and
 * updates the avatar status.
 * @summary Confirm photo upload
 */
export const confirmUpload = async (
  avatarId: string,
  options?: RequestInit
): Promise<ConfirmUploadResponse> => {
  return apiMutator<ConfirmUploadResponse>(getConfirmUploadUrl(avatarId), {
    ...options,
    method: "POST",
  });
};

export const getConfirmUploadMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmUpload>>,
    TError,
    { avatarId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmUpload>>,
  TError,
  { avatarId: string },
  TContext
> => {
  const mutationKey = ["confirmUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmUpload>>,
    { avatarId: string }
  > = (props) => {
    const { avatarId } = props ?? {};

    return confirmUpload(avatarId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmUploadMutationResult = NonNullable<Awaited<ReturnType<typeof confirmUpload>>>;

export type ConfirmUploadMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Confirm photo upload
 */
export const useConfirmUpload = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmUpload>>,
      TError,
      { avatarId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof confirmUpload>>,
  TError,
  { avatarId: string },
  TContext
> => {
  return useMutation(getConfirmUploadMutationOptions(options), queryClient);
};

export const getGetStatusUrl = (avatarId: string) => {
  return `/avatar/${avatarId}/status`;
};

/**
 * Get current avatar status and download URLs if ready.
 *
 * Returns the avatar status and, if ready, signed download URLs
 * for the generated avatar images.
 * @summary Get avatar status
 */
export const getStatus = async (
  avatarId: string,
  options?: RequestInit
): Promise<AvatarStatusResponse> => {
  return apiMutator<AvatarStatusResponse>(getGetStatusUrl(avatarId), {
    ...options,
    method: "GET",
  });
};

export const getGetStatusQueryKey = (avatarId: string) => {
  return [`/avatar/${avatarId}/status`] as const;
};

export const getGetStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStatusQueryKey(avatarId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatus>>> = ({ signal }) =>
    getStatus(avatarId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: avatarId !== null && avatarId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getStatus>>>;
export type GetStatusQueryError = ErrorResponse | HTTPValidationError;

export function useGetStatus<
  TData = Awaited<ReturnType<typeof getStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatus>>,
          TError,
          Awaited<ReturnType<typeof getStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStatus<
  TData = Awaited<ReturnType<typeof getStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatus>>,
          TError,
          Awaited<ReturnType<typeof getStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStatus<
  TData = Awaited<ReturnType<typeof getStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get avatar status
 */

export function useGetStatus<
  TData = Awaited<ReturnType<typeof getStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStatusQueryOptions(avatarId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetMyAvatarUrl = () => {
  return `/avatar/my-avatar`;
};

/**
 * Get current user's avatar if exists.
 *
 * Returns the user's most recent non-failed avatar,
 * including download URLs if the avatar is ready.
 * @summary Get my avatar
 */
export const getMyAvatar = async (options?: RequestInit): Promise<MyAvatarResponse> => {
  return apiMutator<MyAvatarResponse>(getGetMyAvatarUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyAvatarQueryKey = () => {
  return [`/avatar/my-avatar`] as const;
};

export const getGetMyAvatarQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAvatar>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAvatar>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyAvatarQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAvatar>>> = ({ signal }) =>
    getMyAvatar({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyAvatar>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyAvatarQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAvatar>>>;
export type GetMyAvatarQueryError = ErrorResponse;

export function useGetMyAvatar<
  TData = Awaited<ReturnType<typeof getMyAvatar>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAvatar>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAvatar>>,
          TError,
          Awaited<ReturnType<typeof getMyAvatar>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyAvatar<
  TData = Awaited<ReturnType<typeof getMyAvatar>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAvatar>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAvatar>>,
          TError,
          Awaited<ReturnType<typeof getMyAvatar>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyAvatar<
  TData = Awaited<ReturnType<typeof getMyAvatar>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAvatar>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get my avatar
 */

export function useGetMyAvatar<
  TData = Awaited<ReturnType<typeof getMyAvatar>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAvatar>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyAvatarQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDeleteAvatarUrl = (avatarId: string) => {
  return `/avatar/${avatarId}`;
};

/**
 * Delete avatar and all associated data.
 *
 * Removes the avatar record from Firestore and deletes
 * all associated files from GCS.
 * @summary Delete avatar
 */
export const deleteAvatar = async (
  avatarId: string,
  options?: RequestInit
): Promise<DeleteAvatarResponse> => {
  return apiMutator<DeleteAvatarResponse>(getDeleteAvatarUrl(avatarId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAvatarMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAvatar>>,
    TError,
    { avatarId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAvatar>>,
  TError,
  { avatarId: string },
  TContext
> => {
  const mutationKey = ["deleteAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAvatar>>,
    { avatarId: string }
  > = (props) => {
    const { avatarId } = props ?? {};

    return deleteAvatar(avatarId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAvatar>>>;

export type DeleteAvatarMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete avatar
 */
export const useDeleteAvatar = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAvatar>>,
      TError,
      { avatarId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAvatar>>,
  TError,
  { avatarId: string },
  TContext
> => {
  return useMutation(getDeleteAvatarMutationOptions(options), queryClient);
};

export const getGenerateAvatarUrl = (avatarId: string) => {
  return `/avatar/${avatarId}/generate`;
};

/**
 * Start avatar generation with specified parameters.
 *
 * Triggers AI-powered avatar generation using the uploaded photo.
 * Both photorealistic and artistic versions are generated in parallel.
 * @summary Generate avatar
 */
export const generateAvatar = async (
  avatarId: string,
  generateAvatarRequest: GenerateAvatarRequest,
  options?: RequestInit
): Promise<GenerateAvatarResponse> => {
  return apiMutator<GenerateAvatarResponse>(getGenerateAvatarUrl(avatarId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateAvatarRequest),
  });
};

export const getGenerateAvatarMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAvatar>>,
    TError,
    { avatarId: string; data: GenerateAvatarRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAvatar>>,
  TError,
  { avatarId: string; data: GenerateAvatarRequest },
  TContext
> => {
  const mutationKey = ["generateAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAvatar>>,
    { avatarId: string; data: GenerateAvatarRequest }
  > = (props) => {
    const { avatarId, data } = props ?? {};

    return generateAvatar(avatarId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof generateAvatar>>>;
export type GenerateAvatarMutationBody = GenerateAvatarRequest;
export type GenerateAvatarMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Generate avatar
 */
export const useGenerateAvatar = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateAvatar>>,
      TError,
      { avatarId: string; data: GenerateAvatarRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof generateAvatar>>,
  TError,
  { avatarId: string; data: GenerateAvatarRequest },
  TContext
> => {
  return useMutation(getGenerateAvatarMutationOptions(options), queryClient);
};

export const getSelectStyleUrl = (avatarId: string) => {
  return `/avatar/${avatarId}/select-style`;
};

/**
 * Select preferred avatar style.
 *
 * Allows the user to choose between photorealistic and artistic styles.
 * @summary Select avatar style
 */
export const selectStyle = async (
  avatarId: string,
  selectStyleRequest: SelectStyleRequest,
  options?: RequestInit
): Promise<SelectStyleResponse> => {
  return apiMutator<SelectStyleResponse>(getSelectStyleUrl(avatarId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(selectStyleRequest),
  });
};

export const getSelectStyleMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectStyle>>,
    TError,
    { avatarId: string; data: SelectStyleRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectStyle>>,
  TError,
  { avatarId: string; data: SelectStyleRequest },
  TContext
> => {
  const mutationKey = ["selectStyle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectStyle>>,
    { avatarId: string; data: SelectStyleRequest }
  > = (props) => {
    const { avatarId, data } = props ?? {};

    return selectStyle(avatarId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectStyleMutationResult = NonNullable<Awaited<ReturnType<typeof selectStyle>>>;
export type SelectStyleMutationBody = SelectStyleRequest;
export type SelectStyleMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Select avatar style
 */
export const useSelectStyle = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof selectStyle>>,
      TError,
      { avatarId: string; data: SelectStyleRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof selectStyle>>,
  TError,
  { avatarId: string; data: SelectStyleRequest },
  TContext
> => {
  return useMutation(getSelectStyleMutationOptions(options), queryClient);
};

export const getRegenerateAvatarUrl = (avatarId: string) => {
  return `/avatar/${avatarId}/regenerate`;
};

/**
 * Regenerate avatar with same or updated parameters.
 *
 * Allows regenerating the avatar with optionally updated parameters.
 * Subject to regeneration limits unless a poor result was reported.
 * @summary Regenerate avatar
 */
export const regenerateAvatar = async (
  avatarId: string,
  regenerateRequest: RegenerateRequest,
  options?: RequestInit
): Promise<GenerateAvatarResponse> => {
  return apiMutator<GenerateAvatarResponse>(getRegenerateAvatarUrl(avatarId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(regenerateRequest),
  });
};

export const getRegenerateAvatarMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAvatar>>,
    TError,
    { avatarId: string; data: RegenerateRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateAvatar>>,
  TError,
  { avatarId: string; data: RegenerateRequest },
  TContext
> => {
  const mutationKey = ["regenerateAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateAvatar>>,
    { avatarId: string; data: RegenerateRequest }
  > = (props) => {
    const { avatarId, data } = props ?? {};

    return regenerateAvatar(avatarId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateAvatar>>
>;
export type RegenerateAvatarMutationBody = RegenerateRequest;
export type RegenerateAvatarMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Regenerate avatar
 */
export const useRegenerateAvatar = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateAvatar>>,
      TError,
      { avatarId: string; data: RegenerateRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateAvatar>>,
  TError,
  { avatarId: string; data: RegenerateRequest },
  TContext
> => {
  return useMutation(getRegenerateAvatarMutationOptions(options), queryClient);
};

export const getReportPoorResultUrl = (avatarId: string) => {
  return `/avatar/${avatarId}/report-poor-result`;
};

/**
 * Report poor generation quality.
 *
 * Allows users to report when the generated avatar doesn't meet expectations.
 * This can grant additional regeneration attempts.
 * @summary Report poor result
 */
export const reportPoorResult = async (
  avatarId: string,
  reportPoorResultRequest: ReportPoorResultRequest,
  options?: RequestInit
): Promise<ReportPoorResultResponse> => {
  return apiMutator<ReportPoorResultResponse>(getReportPoorResultUrl(avatarId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reportPoorResultRequest),
  });
};

export const getReportPoorResultMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportPoorResult>>,
    TError,
    { avatarId: string; data: ReportPoorResultRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportPoorResult>>,
  TError,
  { avatarId: string; data: ReportPoorResultRequest },
  TContext
> => {
  const mutationKey = ["reportPoorResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportPoorResult>>,
    { avatarId: string; data: ReportPoorResultRequest }
  > = (props) => {
    const { avatarId, data } = props ?? {};

    return reportPoorResult(avatarId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportPoorResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportPoorResult>>
>;
export type ReportPoorResultMutationBody = ReportPoorResultRequest;
export type ReportPoorResultMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Report poor result
 */
export const useReportPoorResult = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reportPoorResult>>,
      TError,
      { avatarId: string; data: ReportPoorResultRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reportPoorResult>>,
  TError,
  { avatarId: string; data: ReportPoorResultRequest },
  TContext
> => {
  return useMutation(getReportPoorResultMutationOptions(options), queryClient);
};

export const getGetAvatarDownloadUrlUrl = (avatarId: string, style: AvatarStyle) => {
  return `/avatar/download/${avatarId}/${style}`;
};

/**
 * Get signed download URL for avatar image.
 *
 * Returns a time-limited signed URL for downloading the specified
 * avatar style (photorealistic or artistic).
 * @summary Get avatar download URL
 */
export const getAvatarDownloadUrl = async (
  avatarId: string,
  style: AvatarStyle,
  options?: RequestInit
): Promise<AvatarDownloadResponse> => {
  return apiMutator<AvatarDownloadResponse>(getGetAvatarDownloadUrlUrl(avatarId, style), {
    ...options,
    method: "GET",
  });
};

export const getGetAvatarDownloadUrlQueryKey = (avatarId: string, style: AvatarStyle) => {
  return [`/avatar/download/${avatarId}/${style}`] as const;
};

export const getGetAvatarDownloadUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvatarDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  style: AvatarStyle,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvatarDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvatarDownloadUrlQueryKey(avatarId, style);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvatarDownloadUrl>>> = ({ signal }) =>
    getAvatarDownloadUrl(avatarId, style, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: avatarId !== null && avatarId !== undefined && style !== null && style !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAvatarDownloadUrl>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAvatarDownloadUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvatarDownloadUrl>>
>;
export type GetAvatarDownloadUrlQueryError = ErrorResponse | HTTPValidationError;

export function useGetAvatarDownloadUrl<
  TData = Awaited<ReturnType<typeof getAvatarDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  style: AvatarStyle,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvatarDownloadUrl>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvatarDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getAvatarDownloadUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvatarDownloadUrl<
  TData = Awaited<ReturnType<typeof getAvatarDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  style: AvatarStyle,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvatarDownloadUrl>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvatarDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getAvatarDownloadUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvatarDownloadUrl<
  TData = Awaited<ReturnType<typeof getAvatarDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  style: AvatarStyle,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvatarDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get avatar download URL
 */

export function useGetAvatarDownloadUrl<
  TData = Awaited<ReturnType<typeof getAvatarDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  avatarId: string,
  style: AvatarStyle,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvatarDownloadUrl>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAvatarDownloadUrlQueryOptions(avatarId, style, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListCallAnalysesUrl = (params?: ListCallAnalysesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/call-analyses?${stringifiedParams}` : `/call-analyses`;
};

/**
 * List call analyses for the authenticated user.
 *
 * Returns call grading analyses ordered by created_at descending.
 * Supports filtering by date range and coaching role.
 * @summary List call analyses
 */
export const listCallAnalyses = async (
  params?: ListCallAnalysesParams,
  options?: RequestInit
): Promise<CallAnalysis[]> => {
  return apiMutator<CallAnalysis[]>(getListCallAnalysesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCallAnalysesQueryKey = (params?: ListCallAnalysesParams) => {
  return [`/call-analyses`, ...(params ? [params] : [])] as const;
};

export const getListCallAnalysesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCallAnalyses>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListCallAnalysesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCallAnalyses>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCallAnalysesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCallAnalyses>>> = ({ signal }) =>
    listCallAnalyses(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCallAnalyses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCallAnalysesQueryResult = NonNullable<Awaited<ReturnType<typeof listCallAnalyses>>>;
export type ListCallAnalysesQueryError = ErrorResponse | HTTPValidationError;

export function useListCallAnalyses<
  TData = Awaited<ReturnType<typeof listCallAnalyses>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ListCallAnalysesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCallAnalyses>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCallAnalyses>>,
          TError,
          Awaited<ReturnType<typeof listCallAnalyses>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCallAnalyses<
  TData = Awaited<ReturnType<typeof listCallAnalyses>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListCallAnalysesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCallAnalyses>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCallAnalyses>>,
          TError,
          Awaited<ReturnType<typeof listCallAnalyses>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCallAnalyses<
  TData = Awaited<ReturnType<typeof listCallAnalyses>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListCallAnalysesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCallAnalyses>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List call analyses
 */

export function useListCallAnalyses<
  TData = Awaited<ReturnType<typeof listCallAnalyses>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListCallAnalysesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCallAnalyses>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCallAnalysesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetCallAnalysisSummaryUrl = (params?: GetCallAnalysisSummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/call-analyses/summary?${stringifiedParams}`
    : `/call-analyses/summary`;
};

/**
 * Get aggregated call analysis summary for the authenticated user.
 *
 * Returns statistics including:
 * - Total calls analyzed
 * - Average overall score
 * - Current tier
 * - Per-category score averages
 * - Focus areas (lowest 3 categories)
 * @summary Get call analysis summary
 */
export const getCallAnalysisSummary = async (
  params?: GetCallAnalysisSummaryParams,
  options?: RequestInit
): Promise<CallAnalysisSummary> => {
  return apiMutator<CallAnalysisSummary>(getGetCallAnalysisSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetCallAnalysisSummaryQueryKey = (params?: GetCallAnalysisSummaryParams) => {
  return [`/call-analyses/summary`, ...(params ? [params] : [])] as const;
};

export const getGetCallAnalysisSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallAnalysisSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCallAnalysisSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysisSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallAnalysisSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallAnalysisSummary>>> = ({ signal }) =>
    getCallAnalysisSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallAnalysisSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCallAnalysisSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallAnalysisSummary>>
>;
export type GetCallAnalysisSummaryQueryError = ErrorResponse | HTTPValidationError;

export function useGetCallAnalysisSummary<
  TData = Awaited<ReturnType<typeof getCallAnalysisSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetCallAnalysisSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysisSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallAnalysisSummary>>,
          TError,
          Awaited<ReturnType<typeof getCallAnalysisSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallAnalysisSummary<
  TData = Awaited<ReturnType<typeof getCallAnalysisSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCallAnalysisSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysisSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallAnalysisSummary>>,
          TError,
          Awaited<ReturnType<typeof getCallAnalysisSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallAnalysisSummary<
  TData = Awaited<ReturnType<typeof getCallAnalysisSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCallAnalysisSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysisSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get call analysis summary
 */

export function useGetCallAnalysisSummary<
  TData = Awaited<ReturnType<typeof getCallAnalysisSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCallAnalysisSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysisSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCallAnalysisSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTeamCallAnalyticsUrl = (params?: GetTeamCallAnalyticsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/call-analyses/team?${stringifiedParams}`
    : `/call-analyses/team`;
};

/**
 * Get call analytics for the manager's team.
 *
 * Returns aggregated statistics for all direct reports including:
 * - Total team calls
 * - Team average score
 * - Per-member breakdown with trends
 *
 * Requires manager, director, or administrator role.
 * @summary Get team call analytics
 */
export const getTeamCallAnalytics = async (
  params?: GetTeamCallAnalyticsParams,
  options?: RequestInit
): Promise<TeamCallAnalytics> => {
  return apiMutator<TeamCallAnalytics>(getGetTeamCallAnalyticsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamCallAnalyticsQueryKey = (params?: GetTeamCallAnalyticsParams) => {
  return [`/call-analyses/team`, ...(params ? [params] : [])] as const;
};

export const getGetTeamCallAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamCallAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamCallAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamCallAnalytics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamCallAnalyticsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamCallAnalytics>>> = ({ signal }) =>
    getTeamCallAnalytics(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamCallAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamCallAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamCallAnalytics>>
>;
export type GetTeamCallAnalyticsQueryError = ErrorResponse | HTTPValidationError;

export function useGetTeamCallAnalytics<
  TData = Awaited<ReturnType<typeof getTeamCallAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetTeamCallAnalyticsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamCallAnalytics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamCallAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getTeamCallAnalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamCallAnalytics<
  TData = Awaited<ReturnType<typeof getTeamCallAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamCallAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamCallAnalytics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamCallAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getTeamCallAnalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamCallAnalytics<
  TData = Awaited<ReturnType<typeof getTeamCallAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamCallAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamCallAnalytics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get team call analytics
 */

export function useGetTeamCallAnalytics<
  TData = Awaited<ReturnType<typeof getTeamCallAnalytics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamCallAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamCallAnalytics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamCallAnalyticsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetCallAnalysisUrl = (analysisId: string) => {
  return `/call-analyses/${analysisId}`;
};

/**
 * Get a specific call analysis by ID.
 *
 * Users can access their own analyses. Managers can access analyses
 * belonging to users in their management chain.
 * @summary Get a call analysis by ID
 */
export const getCallAnalysis = async (
  analysisId: string,
  options?: RequestInit
): Promise<CallAnalysis> => {
  return apiMutator<CallAnalysis>(getGetCallAnalysisUrl(analysisId), {
    ...options,
    method: "GET",
  });
};

export const getGetCallAnalysisQueryKey = (analysisId: string) => {
  return [`/call-analyses/${analysisId}`] as const;
};

export const getGetCallAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallAnalysis>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  analysisId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysis>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallAnalysisQueryKey(analysisId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallAnalysis>>> = ({ signal }) =>
    getCallAnalysis(analysisId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: analysisId !== null && analysisId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysis>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetCallAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getCallAnalysis>>>;
export type GetCallAnalysisQueryError = ErrorResponse | HTTPValidationError;

export function useGetCallAnalysis<
  TData = Awaited<ReturnType<typeof getCallAnalysis>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  analysisId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysis>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getCallAnalysis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallAnalysis<
  TData = Awaited<ReturnType<typeof getCallAnalysis>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  analysisId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysis>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getCallAnalysis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallAnalysis<
  TData = Awaited<ReturnType<typeof getCallAnalysis>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  analysisId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysis>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a call analysis by ID
 */

export function useGetCallAnalysis<
  TData = Awaited<ReturnType<typeof getCallAnalysis>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  analysisId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallAnalysis>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCallAnalysisQueryOptions(analysisId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetChatRagStatusUrl = () => {
  return `/chat/rag-status`;
};

/**
 * Get RAG availability status for chat.
 *
 * Returns whether RAG (knowledge base search) is available for chat.
 * @summary Get RAG availability status
 */
export const getChatRagStatus = async (options?: RequestInit): Promise<RagStatusResponse> => {
  return apiMutator<RagStatusResponse>(getGetChatRagStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetChatRagStatusQueryKey = () => {
  return [`/chat/rag-status`] as const;
};

export const getGetChatRagStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatRagStatus>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatRagStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatRagStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatRagStatus>>> = ({ signal }) =>
    getChatRagStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatRagStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetChatRagStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getChatRagStatus>>>;
export type GetChatRagStatusQueryError = ErrorResponse;

export function useGetChatRagStatus<
  TData = Awaited<ReturnType<typeof getChatRagStatus>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatRagStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatRagStatus>>,
          TError,
          Awaited<ReturnType<typeof getChatRagStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetChatRagStatus<
  TData = Awaited<ReturnType<typeof getChatRagStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatRagStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatRagStatus>>,
          TError,
          Awaited<ReturnType<typeof getChatRagStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetChatRagStatus<
  TData = Awaited<ReturnType<typeof getChatRagStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatRagStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get RAG availability status
 */

export function useGetChatRagStatus<
  TData = Awaited<ReturnType<typeof getChatRagStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatRagStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetChatRagStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSendMessageUrl = () => {
  return `/chat`;
};

/**
 * Send a chat message and receive streaming AI response.
 *
 * Returns Server-Sent Events with the following event types:
 * - `meta`: Contains conversation_id (sent first)
 * - `sources`: Contains RAG source citations (if available)
 * - `chunk`: Contains incremental response text
 * - `done`: Indicates stream completion
 * - `error`: Contains error information if something went wrong
 * @summary Send chat message and receive streaming response
 */
export const sendMessage = async (
  chatRequest: ChatRequest,
  options?: RequestInit
): Promise<unknown> => {
  return apiMutator<unknown>(getSendMessageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(chatRequest),
  });
};

export const getSendMessageMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { data: ChatRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { data: ChatRequest },
  TContext
> => {
  const mutationKey = ["sendMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessage>>,
    { data: ChatRequest }
  > = (props) => {
    const { data } = props ?? {};

    return sendMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendMessage>>>;
export type SendMessageMutationBody = ChatRequest;
export type SendMessageMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Send chat message and receive streaming response
 */
export const useSendMessage = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendMessage>>,
      TError,
      { data: ChatRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { data: ChatRequest },
  TContext
> => {
  return useMutation(getSendMessageMutationOptions(options), queryClient);
};

export const getListAvailableRolesUrl = () => {
  return `/coaching-roles`;
};

/**
 * Get coaching roles available to the current user.
 *
 * Returns roles the user has access to (via role assignments, department assignments,
 * or individual assignments) along with the user's default role preference.
 * @summary List available coaching roles
 */
export const listAvailableRoles = async (
  options?: RequestInit
): Promise<CoachingRoleListResponse> => {
  return apiMutator<CoachingRoleListResponse>(getListAvailableRolesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAvailableRolesQueryKey = () => {
  return [`/coaching-roles`] as const;
};

export const getListAvailableRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableRoles>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAvailableRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableRoles>>> = ({ signal }) =>
    listAvailableRoles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAvailableRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableRoles>>
>;
export type ListAvailableRolesQueryError = ErrorResponse;

export function useListAvailableRoles<
  TData = Awaited<ReturnType<typeof listAvailableRoles>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableRoles>>,
          TError,
          Awaited<ReturnType<typeof listAvailableRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAvailableRoles<
  TData = Awaited<ReturnType<typeof listAvailableRoles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableRoles>>,
          TError,
          Awaited<ReturnType<typeof listAvailableRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAvailableRoles<
  TData = Awaited<ReturnType<typeof listAvailableRoles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List available coaching roles
 */

export function useListAvailableRoles<
  TData = Awaited<ReturnType<typeof listAvailableRoles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAvailableRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSetDefaultRoleUrl = () => {
  return `/coaching-roles/default`;
};

/**
 * Set the user's default coaching role.
 *
 * The specified role must be one that the user has access to.
 * @summary Set default coaching role
 */
export const setDefaultRole = async (
  setDefaultRoleRequest: SetDefaultRoleRequest,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getSetDefaultRoleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setDefaultRoleRequest),
  });
};

export const getSetDefaultRoleMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDefaultRole>>,
    TError,
    { data: SetDefaultRoleRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDefaultRole>>,
  TError,
  { data: SetDefaultRoleRequest },
  TContext
> => {
  const mutationKey = ["setDefaultRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDefaultRole>>,
    { data: SetDefaultRoleRequest }
  > = (props) => {
    const { data } = props ?? {};

    return setDefaultRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetDefaultRoleMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultRole>>>;
export type SetDefaultRoleMutationBody = SetDefaultRoleRequest;
export type SetDefaultRoleMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Set default coaching role
 */
export const useSetDefaultRole = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setDefaultRole>>,
      TError,
      { data: SetDefaultRoleRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setDefaultRole>>,
  TError,
  { data: SetDefaultRoleRequest },
  TContext
> => {
  return useMutation(getSetDefaultRoleMutationOptions(options), queryClient);
};

export const getClearDefaultRoleUrl = () => {
  return `/coaching-roles/default`;
};

/**
 * Clear the user's default coaching role.
 *
 * After clearing, the system will use the first available role as default.
 * @summary Clear default coaching role
 */
export const clearDefaultRole = async (options?: RequestInit): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getClearDefaultRoleUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getClearDefaultRoleMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearDefaultRole>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof clearDefaultRole>>, TError, void, TContext> => {
  const mutationKey = ["clearDefaultRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearDefaultRole>>, void> = () => {
    return clearDefaultRole(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearDefaultRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearDefaultRole>>
>;

export type ClearDefaultRoleMutationError = ErrorResponse;

/**
 * @summary Clear default coaching role
 */
export const useClearDefaultRole = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof clearDefaultRole>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof clearDefaultRole>>, TError, void, TContext> => {
  return useMutation(getClearDefaultRoleMutationOptions(options), queryClient);
};

export const getGetCommunitySettingsUrl = () => {
  return `/community/settings`;
};

/**
 * Get community settings (Curator.io Feed ID).
 *
 * Available to all authenticated users.
 * @summary Get community settings
 */
export const getCommunitySettings = async (
  options?: RequestInit
): Promise<CommunitySettingsResponse> => {
  return apiMutator<CommunitySettingsResponse>(getGetCommunitySettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCommunitySettingsQueryKey = () => {
  return [`/community/settings`] as const;
};

export const getGetCommunitySettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunitySettings>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommunitySettings>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommunitySettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunitySettings>>> = ({ signal }) =>
    getCommunitySettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunitySettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCommunitySettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunitySettings>>
>;
export type GetCommunitySettingsQueryError = ErrorResponse;

export function useGetCommunitySettings<
  TData = Awaited<ReturnType<typeof getCommunitySettings>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunitySettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunitySettings>>,
          TError,
          Awaited<ReturnType<typeof getCommunitySettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCommunitySettings<
  TData = Awaited<ReturnType<typeof getCommunitySettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunitySettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunitySettings>>,
          TError,
          Awaited<ReturnType<typeof getCommunitySettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCommunitySettings<
  TData = Awaited<ReturnType<typeof getCommunitySettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunitySettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get community settings
 */

export function useGetCommunitySettings<
  TData = Awaited<ReturnType<typeof getCommunitySettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunitySettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunitySettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateCommunitySettingsUrl = () => {
  return `/community/settings`;
};

/**
 * Update community settings.
 *
 * Requires WRITE_COMMUNITY permission.
 * @summary Update community settings
 */
export const updateCommunitySettings = async (
  communitySettingsUpdateRequest: CommunitySettingsUpdateRequest,
  options?: RequestInit
): Promise<CommunitySettingsResponse> => {
  return apiMutator<CommunitySettingsResponse>(getUpdateCommunitySettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(communitySettingsUpdateRequest),
  });
};

export const getUpdateCommunitySettingsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunitySettings>>,
    TError,
    { data: CommunitySettingsUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunitySettings>>,
  TError,
  { data: CommunitySettingsUpdateRequest },
  TContext
> => {
  const mutationKey = ["updateCommunitySettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunitySettings>>,
    { data: CommunitySettingsUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateCommunitySettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommunitySettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunitySettings>>
>;
export type UpdateCommunitySettingsMutationBody = CommunitySettingsUpdateRequest;
export type UpdateCommunitySettingsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update community settings
 */
export const useUpdateCommunitySettings = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCommunitySettings>>,
      TError,
      { data: CommunitySettingsUpdateRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunitySettings>>,
  TError,
  { data: CommunitySettingsUpdateRequest },
  TContext
> => {
  return useMutation(getUpdateCommunitySettingsMutationOptions(options), queryClient);
};

export const getGetCompanyEventsUrl = (params?: GetCompanyEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/community/events?${stringifiedParams}`
    : `/community/events`;
};

/**
 * Get company events from the organization calendar.
 *
 * Returns cached events from the organization calendar.
 * Available to all authenticated users.
 * @summary Get company events
 */
export const getCompanyEvents = async (
  params?: GetCompanyEventsParams,
  options?: RequestInit
): Promise<CompanyEventsResponse> => {
  return apiMutator<CompanyEventsResponse>(getGetCompanyEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetCompanyEventsQueryKey = (params?: GetCompanyEventsParams) => {
  return [`/community/events`, ...(params ? [params] : [])] as const;
};

export const getGetCompanyEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompanyEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCompanyEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompanyEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyEvents>>> = ({ signal }) =>
    getCompanyEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompanyEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCompanyEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyEvents>>>;
export type GetCompanyEventsQueryError = ErrorResponse | HTTPValidationError;

export function useGetCompanyEvents<
  TData = Awaited<ReturnType<typeof getCompanyEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetCompanyEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyEvents>>,
          TError,
          Awaited<ReturnType<typeof getCompanyEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCompanyEvents<
  TData = Awaited<ReturnType<typeof getCompanyEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCompanyEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyEvents>>,
          TError,
          Awaited<ReturnType<typeof getCompanyEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCompanyEvents<
  TData = Awaited<ReturnType<typeof getCompanyEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCompanyEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get company events
 */

export function useGetCompanyEvents<
  TData = Awaited<ReturnType<typeof getCompanyEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCompanyEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCompanyEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListConversationsUrl = (params?: ListConversationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/conversations?${stringifiedParams}` : `/conversations`;
};

/**
 * List user's conversations, newest first.
 * @summary List user's conversations
 */
export const listConversations = async (
  params?: ListConversationsParams,
  options?: RequestInit
): Promise<ConversationListResponse> => {
  return apiMutator<ConversationListResponse>(getListConversationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListConversationsQueryKey = (params?: ListConversationsParams) => {
  return [`/conversations`, ...(params ? [params] : [])] as const;
};

export const getListConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListConversationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversations>>> = ({ signal }) =>
    listConversations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listConversations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConversationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listConversations>>
>;
export type ListConversationsQueryError = ErrorResponse | HTTPValidationError;

export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ListConversationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversations>>,
          TError,
          Awaited<ReturnType<typeof listConversations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversations>>,
          TError,
          Awaited<ReturnType<typeof listConversations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List user's conversations
 */

export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListConversationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateConversationUrl = () => {
  return `/conversations`;
};

/**
 * Create a new conversation.
 * @summary Create a new conversation
 */
export const createConversation = async (
  createConversationRequest: CreateConversationRequest,
  options?: RequestInit
): Promise<Conversation> => {
  return apiMutator<Conversation>(getCreateConversationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createConversationRequest),
  });
};

export const getCreateConversationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConversation>>,
    TError,
    { data: CreateConversationRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { data: CreateConversationRequest },
  TContext
> => {
  const mutationKey = ["createConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createConversation>>,
    { data: CreateConversationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createConversation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createConversation>>
>;
export type CreateConversationMutationBody = CreateConversationRequest;
export type CreateConversationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create a new conversation
 */
export const useCreateConversation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createConversation>>,
      TError,
      { data: CreateConversationRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { data: CreateConversationRequest },
  TContext
> => {
  return useMutation(getCreateConversationMutationOptions(options), queryClient);
};

export const getGetConversationUrl = (conversationId: string) => {
  return `/conversations/${conversationId}`;
};

/**
 * Get a conversation with all messages.
 * @summary Get a conversation with messages
 */
export const getConversation = async (
  conversationId: string,
  options?: RequestInit
): Promise<ConversationWithMessages> => {
  return apiMutator<ConversationWithMessages>(getGetConversationUrl(conversationId), {
    ...options,
    method: "GET",
  });
};

export const getGetConversationQueryKey = (conversationId: string) => {
  return [`/conversations/${conversationId}`] as const;
};

export const getGetConversationQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) =>
    getConversation(conversationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>;
export type GetConversationQueryError = ErrorResponse | HTTPValidationError;

export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  conversationId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a conversation with messages
 */

export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConversationQueryOptions(conversationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateConversationUrl = (conversationId: string) => {
  return `/conversations/${conversationId}`;
};

/**
 * Update a conversation's title.
 * @summary Update a conversation's title
 */
export const updateConversation = async (
  conversationId: string,
  updateConversationRequest: UpdateConversationRequest,
  options?: RequestInit
): Promise<Conversation> => {
  return apiMutator<Conversation>(getUpdateConversationUrl(conversationId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateConversationRequest),
  });
};

export const getUpdateConversationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConversation>>,
    TError,
    { conversationId: string; data: UpdateConversationRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConversation>>,
  TError,
  { conversationId: string; data: UpdateConversationRequest },
  TContext
> => {
  const mutationKey = ["updateConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConversation>>,
    { conversationId: string; data: UpdateConversationRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return updateConversation(conversationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConversation>>
>;
export type UpdateConversationMutationBody = UpdateConversationRequest;
export type UpdateConversationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update a conversation's title
 */
export const useUpdateConversation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateConversation>>,
      TError,
      { conversationId: string; data: UpdateConversationRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateConversation>>,
  TError,
  { conversationId: string; data: UpdateConversationRequest },
  TContext
> => {
  return useMutation(getUpdateConversationMutationOptions(options), queryClient);
};

export const getDeleteConversationUrl = (conversationId: string) => {
  return `/conversations/${conversationId}`;
};

/**
 * Delete a conversation and all its messages.
 * @summary Delete a conversation
 */
export const deleteConversation = async (
  conversationId: string,
  options?: RequestInit
): Promise<void> => {
  return apiMutator<void>(getDeleteConversationUrl(conversationId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteConversationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConversation>>,
    TError,
    { conversationId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConversation>>,
  TError,
  { conversationId: string },
  TContext
> => {
  const mutationKey = ["deleteConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConversation>>,
    { conversationId: string }
  > = (props) => {
    const { conversationId } = props ?? {};

    return deleteConversation(conversationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConversation>>
>;

export type DeleteConversationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a conversation
 */
export const useDeleteConversation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteConversation>>,
      TError,
      { conversationId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteConversation>>,
  TError,
  { conversationId: string },
  TContext
> => {
  return useMutation(getDeleteConversationMutationOptions(options), queryClient);
};

export const getAddInterruptedMessageUrl = (conversationId: string) => {
  return `/conversations/${conversationId}/interrupted`;
};

/**
 * Save a partial assistant response that was stopped by the user.
 * @summary Persist an interrupted assistant message (spec 078)
 */
export const addInterruptedMessage = async (
  conversationId: string,
  addInterruptedMessageRequest: AddInterruptedMessageRequest,
  options?: RequestInit
): Promise<AddInterruptedMessage201> => {
  return apiMutator<AddInterruptedMessage201>(getAddInterruptedMessageUrl(conversationId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addInterruptedMessageRequest),
  });
};

export const getAddInterruptedMessageMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addInterruptedMessage>>,
    TError,
    { conversationId: string; data: AddInterruptedMessageRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addInterruptedMessage>>,
  TError,
  { conversationId: string; data: AddInterruptedMessageRequest },
  TContext
> => {
  const mutationKey = ["addInterruptedMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addInterruptedMessage>>,
    { conversationId: string; data: AddInterruptedMessageRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return addInterruptedMessage(conversationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddInterruptedMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof addInterruptedMessage>>
>;
export type AddInterruptedMessageMutationBody = AddInterruptedMessageRequest;
export type AddInterruptedMessageMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Persist an interrupted assistant message (spec 078)
 */
export const useAddInterruptedMessage = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addInterruptedMessage>>,
      TError,
      { conversationId: string; data: AddInterruptedMessageRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addInterruptedMessage>>,
  TError,
  { conversationId: string; data: AddInterruptedMessageRequest },
  TContext
> => {
  return useMutation(getAddInterruptedMessageMutationOptions(options), queryClient);
};

export const getSetMessageFeedbackUrl = (conversationId: string, messageId: string) => {
  return `/conversations/${conversationId}/messages/${messageId}/feedback`;
};

/**
 * Thumbs up / down on an answer. Idempotent: a second call replaces it.
 *
 * A thumbs-down leaves its evidence (question, answer, turn ledger, tool
 * trace) as structured log entries; see ``feedback_log.py``.
 * @summary Rate an assistant message (spec 093)
 */
export const setMessageFeedback = async (
  conversationId: string,
  messageId: string,
  messageFeedbackRequest: MessageFeedbackRequest,
  options?: RequestInit
): Promise<MessageFeedback> => {
  return apiMutator<MessageFeedback>(getSetMessageFeedbackUrl(conversationId, messageId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(messageFeedbackRequest),
  });
};

export const getSetMessageFeedbackMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMessageFeedback>>,
    TError,
    { conversationId: string; messageId: string; data: MessageFeedbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setMessageFeedback>>,
  TError,
  { conversationId: string; messageId: string; data: MessageFeedbackRequest },
  TContext
> => {
  const mutationKey = ["setMessageFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMessageFeedback>>,
    { conversationId: string; messageId: string; data: MessageFeedbackRequest }
  > = (props) => {
    const { conversationId, messageId, data } = props ?? {};

    return setMessageFeedback(conversationId, messageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMessageFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMessageFeedback>>
>;
export type SetMessageFeedbackMutationBody = MessageFeedbackRequest;
export type SetMessageFeedbackMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Rate an assistant message (spec 093)
 */
export const useSetMessageFeedback = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setMessageFeedback>>,
      TError,
      { conversationId: string; messageId: string; data: MessageFeedbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setMessageFeedback>>,
  TError,
  { conversationId: string; messageId: string; data: MessageFeedbackRequest },
  TContext
> => {
  return useMutation(getSetMessageFeedbackMutationOptions(options), queryClient);
};

export const getClearMessageFeedbackUrl = (conversationId: string, messageId: string) => {
  return `/conversations/${conversationId}/messages/${messageId}/feedback`;
};

/**
 * Remove the owner's rating from an assistant message.
 * @summary Clear the rating on an assistant message (spec 093)
 */
export const clearMessageFeedback = async (
  conversationId: string,
  messageId: string,
  options?: RequestInit
): Promise<void> => {
  return apiMutator<void>(getClearMessageFeedbackUrl(conversationId, messageId), {
    ...options,
    method: "DELETE",
  });
};

export const getClearMessageFeedbackMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearMessageFeedback>>,
    TError,
    { conversationId: string; messageId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearMessageFeedback>>,
  TError,
  { conversationId: string; messageId: string },
  TContext
> => {
  const mutationKey = ["clearMessageFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearMessageFeedback>>,
    { conversationId: string; messageId: string }
  > = (props) => {
    const { conversationId, messageId } = props ?? {};

    return clearMessageFeedback(conversationId, messageId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearMessageFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearMessageFeedback>>
>;

export type ClearMessageFeedbackMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Clear the rating on an assistant message (spec 093)
 */
export const useClearMessageFeedback = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof clearMessageFeedback>>,
      TError,
      { conversationId: string; messageId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof clearMessageFeedback>>,
  TError,
  { conversationId: string; messageId: string },
  TContext
> => {
  return useMutation(getClearMessageFeedbackMutationOptions(options), queryClient);
};

export const getUploadFileUrl = () => {
  return `/files/upload`;
};

/**
 * Handle file uploads, validate them, and store in GCS for Vertex AI access.
 * @summary Upload File
 */
export const uploadFile = async (
  bodyUploadFileFilesUploadPost: BodyUploadFileFilesUploadPost,
  options?: RequestInit
): Promise<UploadedFile> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadFileFilesUploadPost.file);

  return apiMutator<UploadedFile>(getUploadFileUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { data: BodyUploadFileFilesUploadPost },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: BodyUploadFileFilesUploadPost },
  TContext
> => {
  const mutationKey = ["uploadFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile>>,
    { data: BodyUploadFileFilesUploadPost }
  > = (props) => {
    const { data } = props ?? {};

    return uploadFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadFile>>>;
export type UploadFileMutationBody = BodyUploadFileFilesUploadPost;
export type UploadFileMutationError = HTTPValidationError;

/**
 * @summary Upload File
 */
export const useUploadFile = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFile>>,
      TError,
      { data: BodyUploadFileFilesUploadPost },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: BodyUploadFileFilesUploadPost },
  TContext
> => {
  return useMutation(getUploadFileMutationOptions(options), queryClient);
};

export const getGetPendingApprovalsUrl = () => {
  return `/goals/approvals`;
};

/**
 * Get pending task approvals for manager's team members. Requires WRITE_GOALS with TEAM scope.
 * @summary Get pending approvals
 */
export const getPendingApprovals = async (
  options?: RequestInit
): Promise<PendingApprovalsResponse> => {
  return apiMutator<PendingApprovalsResponse>(getGetPendingApprovalsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPendingApprovalsQueryKey = () => {
  return [`/goals/approvals`] as const;
};

export const getGetPendingApprovalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingApprovals>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPendingApprovalsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingApprovals>>> = ({ signal }) =>
    getPendingApprovals({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingApprovals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingApprovalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingApprovals>>
>;
export type GetPendingApprovalsQueryError = ErrorResponse;

export function useGetPendingApprovals<
  TData = Awaited<ReturnType<typeof getPendingApprovals>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingApprovals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPendingApprovals<
  TData = Awaited<ReturnType<typeof getPendingApprovals>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingApprovals>>,
          TError,
          Awaited<ReturnType<typeof getPendingApprovals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPendingApprovals<
  TData = Awaited<ReturnType<typeof getPendingApprovals>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get pending approvals
 */

export function useGetPendingApprovals<
  TData = Awaited<ReturnType<typeof getPendingApprovals>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPendingApprovalsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApproveTaskCreationUrl = (taskId: string, params: ApproveTaskCreationParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/approve-creation?${stringifiedParams}`
    : `/goals/tasks/${taskId}/approve-creation`;
};

/**
 * Approve a task creation (user-created tasks need manager approval). Requires WRITE_GOALS with TEAM scope.
 * @summary Approve task creation
 */
export const approveTaskCreation = async (
  taskId: string,
  params: ApproveTaskCreationParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getApproveTaskCreationUrl(taskId, params), {
    ...options,
    method: "POST",
  });
};

export const getApproveTaskCreationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveTaskCreation>>,
    TError,
    { taskId: string; params: ApproveTaskCreationParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveTaskCreation>>,
  TError,
  { taskId: string; params: ApproveTaskCreationParams },
  TContext
> => {
  const mutationKey = ["approveTaskCreation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveTaskCreation>>,
    { taskId: string; params: ApproveTaskCreationParams }
  > = (props) => {
    const { taskId, params } = props ?? {};

    return approveTaskCreation(taskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveTaskCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveTaskCreation>>
>;

export type ApproveTaskCreationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Approve task creation
 */
export const useApproveTaskCreation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveTaskCreation>>,
      TError,
      { taskId: string; params: ApproveTaskCreationParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof approveTaskCreation>>,
  TError,
  { taskId: string; params: ApproveTaskCreationParams },
  TContext
> => {
  return useMutation(getApproveTaskCreationMutationOptions(options), queryClient);
};

export const getRejectTaskCreationUrl = (taskId: string, params: RejectTaskCreationParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/reject-creation?${stringifiedParams}`
    : `/goals/tasks/${taskId}/reject-creation`;
};

/**
 * Reject a task creation (user-created tasks need manager rejection). Requires WRITE_GOALS with TEAM scope.
 * @summary Reject task creation
 */
export const rejectTaskCreation = async (
  taskId: string,
  rejectCreationRequest: RejectCreationRequest,
  params: RejectTaskCreationParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getRejectTaskCreationUrl(taskId, params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectCreationRequest),
  });
};

export const getRejectTaskCreationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectTaskCreation>>,
    TError,
    { taskId: string; data: RejectCreationRequest; params: RejectTaskCreationParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectTaskCreation>>,
  TError,
  { taskId: string; data: RejectCreationRequest; params: RejectTaskCreationParams },
  TContext
> => {
  const mutationKey = ["rejectTaskCreation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectTaskCreation>>,
    { taskId: string; data: RejectCreationRequest; params: RejectTaskCreationParams }
  > = (props) => {
    const { taskId, data, params } = props ?? {};

    return rejectTaskCreation(taskId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectTaskCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectTaskCreation>>
>;
export type RejectTaskCreationMutationBody = RejectCreationRequest;
export type RejectTaskCreationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reject task creation
 */
export const useRejectTaskCreation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectTaskCreation>>,
      TError,
      { taskId: string; data: RejectCreationRequest; params: RejectTaskCreationParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof rejectTaskCreation>>,
  TError,
  { taskId: string; data: RejectCreationRequest; params: RejectTaskCreationParams },
  TContext
> => {
  return useMutation(getRejectTaskCreationMutationOptions(options), queryClient);
};

export const getSubmitTaskForCompletionUrl = (
  taskId: string,
  params: SubmitTaskForCompletionParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/submit-completion?${stringifiedParams}`
    : `/goals/tasks/${taskId}/submit-completion`;
};

/**
 * Submit a task for completion approval (for manager-verified tasks).
 * @summary Submit task for completion
 */
export const submitTaskForCompletion = async (
  taskId: string,
  params: SubmitTaskForCompletionParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getSubmitTaskForCompletionUrl(taskId, params), {
    ...options,
    method: "POST",
  });
};

export const getSubmitTaskForCompletionMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitTaskForCompletion>>,
    TError,
    { taskId: string; params: SubmitTaskForCompletionParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitTaskForCompletion>>,
  TError,
  { taskId: string; params: SubmitTaskForCompletionParams },
  TContext
> => {
  const mutationKey = ["submitTaskForCompletion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitTaskForCompletion>>,
    { taskId: string; params: SubmitTaskForCompletionParams }
  > = (props) => {
    const { taskId, params } = props ?? {};

    return submitTaskForCompletion(taskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitTaskForCompletionMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitTaskForCompletion>>
>;

export type SubmitTaskForCompletionMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Submit task for completion
 */
export const useSubmitTaskForCompletion = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitTaskForCompletion>>,
      TError,
      { taskId: string; params: SubmitTaskForCompletionParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitTaskForCompletion>>,
  TError,
  { taskId: string; params: SubmitTaskForCompletionParams },
  TContext
> => {
  return useMutation(getSubmitTaskForCompletionMutationOptions(options), queryClient);
};

export const getApproveTaskCompletionUrl = (
  taskId: string,
  params: ApproveTaskCompletionParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/approve-completion?${stringifiedParams}`
    : `/goals/tasks/${taskId}/approve-completion`;
};

/**
 * Approve a task completion (manager approves user's submitted completion). Requires WRITE_GOALS with TEAM scope.
 * @summary Approve task completion
 */
export const approveTaskCompletion = async (
  taskId: string,
  params: ApproveTaskCompletionParams,
  approveCompletionRequestNull?: ApproveCompletionRequest | null,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getApproveTaskCompletionUrl(taskId, params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(approveCompletionRequestNull),
  });
};

export const getApproveTaskCompletionMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveTaskCompletion>>,
    TError,
    { taskId: string; params: ApproveTaskCompletionParams; data?: ApproveCompletionRequest | null },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveTaskCompletion>>,
  TError,
  { taskId: string; params: ApproveTaskCompletionParams; data?: ApproveCompletionRequest | null },
  TContext
> => {
  const mutationKey = ["approveTaskCompletion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveTaskCompletion>>,
    { taskId: string; params: ApproveTaskCompletionParams; data?: ApproveCompletionRequest | null }
  > = (props) => {
    const { taskId, params, data } = props ?? {};

    return approveTaskCompletion(taskId, params, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveTaskCompletionMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveTaskCompletion>>
>;
export type ApproveTaskCompletionMutationBody = ApproveCompletionRequest | null | undefined;
export type ApproveTaskCompletionMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Approve task completion
 */
export const useApproveTaskCompletion = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveTaskCompletion>>,
      TError,
      {
        taskId: string;
        params: ApproveTaskCompletionParams;
        data?: ApproveCompletionRequest | null;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof approveTaskCompletion>>,
  TError,
  { taskId: string; params: ApproveTaskCompletionParams; data?: ApproveCompletionRequest | null },
  TContext
> => {
  return useMutation(getApproveTaskCompletionMutationOptions(options), queryClient);
};

export const getRejectTaskCompletionUrl = (taskId: string, params: RejectTaskCompletionParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/reject-completion?${stringifiedParams}`
    : `/goals/tasks/${taskId}/reject-completion`;
};

/**
 * Reject a task completion (manager rejects user's submitted completion). Requires WRITE_GOALS with TEAM scope.
 * @summary Reject task completion
 */
export const rejectTaskCompletion = async (
  taskId: string,
  rejectCompletionRequest: RejectCompletionRequest,
  params: RejectTaskCompletionParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getRejectTaskCompletionUrl(taskId, params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectCompletionRequest),
  });
};

export const getRejectTaskCompletionMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectTaskCompletion>>,
    TError,
    { taskId: string; data: RejectCompletionRequest; params: RejectTaskCompletionParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectTaskCompletion>>,
  TError,
  { taskId: string; data: RejectCompletionRequest; params: RejectTaskCompletionParams },
  TContext
> => {
  const mutationKey = ["rejectTaskCompletion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectTaskCompletion>>,
    { taskId: string; data: RejectCompletionRequest; params: RejectTaskCompletionParams }
  > = (props) => {
    const { taskId, data, params } = props ?? {};

    return rejectTaskCompletion(taskId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectTaskCompletionMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectTaskCompletion>>
>;
export type RejectTaskCompletionMutationBody = RejectCompletionRequest;
export type RejectTaskCompletionMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reject task completion
 */
export const useRejectTaskCompletion = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectTaskCompletion>>,
      TError,
      { taskId: string; data: RejectCompletionRequest; params: RejectTaskCompletionParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof rejectTaskCompletion>>,
  TError,
  { taskId: string; data: RejectCompletionRequest; params: RejectTaskCompletionParams },
  TContext
> => {
  return useMutation(getRejectTaskCompletionMutationOptions(options), queryClient);
};

export const getManagerMarkTaskCompleteUrl = (
  taskId: string,
  params: ManagerMarkTaskCompleteParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/manager-complete?${stringifiedParams}`
    : `/goals/tasks/${taskId}/manager-complete`;
};

/**
 * Allow a manager to directly mark a task as complete.
 *
 * This endpoint allows managers to mark a direct report's task as complete
 * without requiring the user to submit it for approval first. This is useful
 * when a manager is reviewing tasks and wants to verify completion directly.
 *
 * Requires WRITE_GOALS with TEAM scope.
 * @summary Manager mark task complete
 */
export const managerMarkTaskComplete = async (
  taskId: string,
  params: ManagerMarkTaskCompleteParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getManagerMarkTaskCompleteUrl(taskId, params), {
    ...options,
    method: "POST",
  });
};

export const getManagerMarkTaskCompleteMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managerMarkTaskComplete>>,
    TError,
    { taskId: string; params: ManagerMarkTaskCompleteParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managerMarkTaskComplete>>,
  TError,
  { taskId: string; params: ManagerMarkTaskCompleteParams },
  TContext
> => {
  const mutationKey = ["managerMarkTaskComplete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managerMarkTaskComplete>>,
    { taskId: string; params: ManagerMarkTaskCompleteParams }
  > = (props) => {
    const { taskId, params } = props ?? {};

    return managerMarkTaskComplete(taskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagerMarkTaskCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof managerMarkTaskComplete>>
>;

export type ManagerMarkTaskCompleteMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Manager mark task complete
 */
export const useManagerMarkTaskComplete = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof managerMarkTaskComplete>>,
      TError,
      { taskId: string; params: ManagerMarkTaskCompleteParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof managerMarkTaskComplete>>,
  TError,
  { taskId: string; params: ManagerMarkTaskCompleteParams },
  TContext
> => {
  return useMutation(getManagerMarkTaskCompleteMutationOptions(options), queryClient);
};

export const getApproveGoalCreationUrl = (goalId: string) => {
  return `/goals/${goalId}/approve-creation`;
};

/**
 * Approve a goal creation (manager approves user-created goal).
 *
 * Cascades approval to all milestones and tasks within the goal.
 * Requires WRITE_GOALS with TEAM scope.
 * @summary Approve goal creation
 */
export const approveGoalCreation = async (
  goalId: string,
  options?: RequestInit
): Promise<GoalResponse> => {
  return apiMutator<GoalResponse>(getApproveGoalCreationUrl(goalId), {
    ...options,
    method: "POST",
  });
};

export const getApproveGoalCreationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveGoalCreation>>,
    TError,
    { goalId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveGoalCreation>>,
  TError,
  { goalId: string },
  TContext
> => {
  const mutationKey = ["approveGoalCreation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveGoalCreation>>,
    { goalId: string }
  > = (props) => {
    const { goalId } = props ?? {};

    return approveGoalCreation(goalId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveGoalCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveGoalCreation>>
>;

export type ApproveGoalCreationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Approve goal creation
 */
export const useApproveGoalCreation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveGoalCreation>>,
      TError,
      { goalId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof approveGoalCreation>>,
  TError,
  { goalId: string },
  TContext
> => {
  return useMutation(getApproveGoalCreationMutationOptions(options), queryClient);
};

export const getRejectGoalCreationUrl = (goalId: string) => {
  return `/goals/${goalId}/reject-creation`;
};

/**
 * Reject a goal creation (manager rejects user-created goal).
 *
 * Requires WRITE_GOALS with TEAM scope.
 * @summary Reject goal creation
 */
export const rejectGoalCreation = async (
  goalId: string,
  rejectCreationRequest: RejectCreationRequest,
  options?: RequestInit
): Promise<GoalResponse> => {
  return apiMutator<GoalResponse>(getRejectGoalCreationUrl(goalId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectCreationRequest),
  });
};

export const getRejectGoalCreationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectGoalCreation>>,
    TError,
    { goalId: string; data: RejectCreationRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectGoalCreation>>,
  TError,
  { goalId: string; data: RejectCreationRequest },
  TContext
> => {
  const mutationKey = ["rejectGoalCreation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectGoalCreation>>,
    { goalId: string; data: RejectCreationRequest }
  > = (props) => {
    const { goalId, data } = props ?? {};

    return rejectGoalCreation(goalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectGoalCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectGoalCreation>>
>;
export type RejectGoalCreationMutationBody = RejectCreationRequest;
export type RejectGoalCreationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reject goal creation
 */
export const useRejectGoalCreation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectGoalCreation>>,
      TError,
      { goalId: string; data: RejectCreationRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof rejectGoalCreation>>,
  TError,
  { goalId: string; data: RejectCreationRequest },
  TContext
> => {
  return useMutation(getRejectGoalCreationMutationOptions(options), queryClient);
};

export const getApproveMilestoneCreationUrl = (goalId: string, milestoneId: string) => {
  return `/goals/${goalId}/milestones/${milestoneId}/approve-creation`;
};

/**
 * Approve a milestone creation (manager approves user-created milestone).
 *
 * Cascades approval to all tasks within the milestone.
 * Requires WRITE_GOALS with TEAM scope.
 * @summary Approve milestone creation
 */
export const approveMilestoneCreation = async (
  goalId: string,
  milestoneId: string,
  options?: RequestInit
): Promise<MilestoneResponse> => {
  return apiMutator<MilestoneResponse>(getApproveMilestoneCreationUrl(goalId, milestoneId), {
    ...options,
    method: "POST",
  });
};

export const getApproveMilestoneCreationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveMilestoneCreation>>,
    TError,
    { goalId: string; milestoneId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveMilestoneCreation>>,
  TError,
  { goalId: string; milestoneId: string },
  TContext
> => {
  const mutationKey = ["approveMilestoneCreation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveMilestoneCreation>>,
    { goalId: string; milestoneId: string }
  > = (props) => {
    const { goalId, milestoneId } = props ?? {};

    return approveMilestoneCreation(goalId, milestoneId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveMilestoneCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveMilestoneCreation>>
>;

export type ApproveMilestoneCreationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Approve milestone creation
 */
export const useApproveMilestoneCreation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveMilestoneCreation>>,
      TError,
      { goalId: string; milestoneId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof approveMilestoneCreation>>,
  TError,
  { goalId: string; milestoneId: string },
  TContext
> => {
  return useMutation(getApproveMilestoneCreationMutationOptions(options), queryClient);
};

export const getRejectMilestoneCreationUrl = (goalId: string, milestoneId: string) => {
  return `/goals/${goalId}/milestones/${milestoneId}/reject-creation`;
};

/**
 * Reject a milestone creation (manager rejects user-created milestone).
 *
 * Requires WRITE_GOALS with TEAM scope.
 * @summary Reject milestone creation
 */
export const rejectMilestoneCreation = async (
  goalId: string,
  milestoneId: string,
  rejectCreationRequest: RejectCreationRequest,
  options?: RequestInit
): Promise<MilestoneResponse> => {
  return apiMutator<MilestoneResponse>(getRejectMilestoneCreationUrl(goalId, milestoneId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectCreationRequest),
  });
};

export const getRejectMilestoneCreationMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectMilestoneCreation>>,
    TError,
    { goalId: string; milestoneId: string; data: RejectCreationRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectMilestoneCreation>>,
  TError,
  { goalId: string; milestoneId: string; data: RejectCreationRequest },
  TContext
> => {
  const mutationKey = ["rejectMilestoneCreation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectMilestoneCreation>>,
    { goalId: string; milestoneId: string; data: RejectCreationRequest }
  > = (props) => {
    const { goalId, milestoneId, data } = props ?? {};

    return rejectMilestoneCreation(goalId, milestoneId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectMilestoneCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectMilestoneCreation>>
>;
export type RejectMilestoneCreationMutationBody = RejectCreationRequest;
export type RejectMilestoneCreationMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reject milestone creation
 */
export const useRejectMilestoneCreation = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectMilestoneCreation>>,
      TError,
      { goalId: string; milestoneId: string; data: RejectCreationRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof rejectMilestoneCreation>>,
  TError,
  { goalId: string; milestoneId: string; data: RejectCreationRequest },
  TContext
> => {
  return useMutation(getRejectMilestoneCreationMutationOptions(options), queryClient);
};

export const getBulkApproveCreationsUrl = () => {
  return `/goals/approvals/bulk-approve`;
};

/**
 * Bulk approve goal, milestone, and task creations.
 *
 * Limited to 50 items per request.
 * Requires WRITE_GOALS with TEAM scope.
 * @summary Bulk approve creations
 */
export const bulkApproveCreations = async (
  bulkApprovalRequest: BulkApprovalRequest,
  options?: RequestInit
): Promise<BulkApprovalResponse> => {
  return apiMutator<BulkApprovalResponse>(getBulkApproveCreationsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkApprovalRequest),
  });
};

export const getBulkApproveCreationsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkApproveCreations>>,
    TError,
    { data: BulkApprovalRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkApproveCreations>>,
  TError,
  { data: BulkApprovalRequest },
  TContext
> => {
  const mutationKey = ["bulkApproveCreations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkApproveCreations>>,
    { data: BulkApprovalRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkApproveCreations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkApproveCreationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkApproveCreations>>
>;
export type BulkApproveCreationsMutationBody = BulkApprovalRequest;
export type BulkApproveCreationsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Bulk approve creations
 */
export const useBulkApproveCreations = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkApproveCreations>>,
      TError,
      { data: BulkApprovalRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkApproveCreations>>,
  TError,
  { data: BulkApprovalRequest },
  TContext
> => {
  return useMutation(getBulkApproveCreationsMutationOptions(options), queryClient);
};

export const getBulkApproveCompletionsUrl = () => {
  return `/goals/approvals/bulk-approve-completions`;
};

/**
 * Bulk approve task completions.
 *
 * Limited to 50 items per request.
 * Requires WRITE_GOALS with TEAM scope.
 * @summary Bulk approve completions
 */
export const bulkApproveCompletions = async (
  bulkApprovalRequest: BulkApprovalRequest,
  options?: RequestInit
): Promise<BulkApprovalResponse> => {
  return apiMutator<BulkApprovalResponse>(getBulkApproveCompletionsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkApprovalRequest),
  });
};

export const getBulkApproveCompletionsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkApproveCompletions>>,
    TError,
    { data: BulkApprovalRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkApproveCompletions>>,
  TError,
  { data: BulkApprovalRequest },
  TContext
> => {
  const mutationKey = ["bulkApproveCompletions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkApproveCompletions>>,
    { data: BulkApprovalRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkApproveCompletions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkApproveCompletionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkApproveCompletions>>
>;
export type BulkApproveCompletionsMutationBody = BulkApprovalRequest;
export type BulkApproveCompletionsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Bulk approve completions
 */
export const useBulkApproveCompletions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkApproveCompletions>>,
      TError,
      { data: BulkApprovalRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkApproveCompletions>>,
  TError,
  { data: BulkApprovalRequest },
  TContext
> => {
  return useMutation(getBulkApproveCompletionsMutationOptions(options), queryClient);
};

export const getListGoalsUrl = (params?: ListGoalsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/goals?${stringifiedParams}` : `/goals`;
};

/**
 * List current user's goals.
 * @summary List user's goals
 */
export const listGoals = async (
  params?: ListGoalsParams,
  options?: RequestInit
): Promise<GoalListResponse> => {
  return apiMutator<GoalListResponse>(getListGoalsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListGoalsQueryKey = (params?: ListGoalsParams) => {
  return [`/goals`, ...(params ? [params] : [])] as const;
};

export const getListGoalsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGoalsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoals>>> = ({ signal }) =>
    listGoals(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGoals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof listGoals>>>;
export type ListGoalsQueryError = ErrorResponse | HTTPValidationError;

export function useListGoals<
  TData = Awaited<ReturnType<typeof listGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ListGoalsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoals>>,
          TError,
          Awaited<ReturnType<typeof listGoals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGoals<
  TData = Awaited<ReturnType<typeof listGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoals>>,
          TError,
          Awaited<ReturnType<typeof listGoals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGoals<
  TData = Awaited<ReturnType<typeof listGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List user's goals
 */

export function useListGoals<
  TData = Awaited<ReturnType<typeof listGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListGoalsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateGoalUrl = () => {
  return `/goals`;
};

/**
 * Create a new goal.
 * @summary Create a goal
 */
export const createGoal = async (
  createGoalRequest: CreateGoalRequest,
  options?: RequestInit
): Promise<GoalResponse> => {
  return apiMutator<GoalResponse>(getCreateGoalUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createGoalRequest),
  });
};

export const getCreateGoalMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoal>>,
    TError,
    { data: CreateGoalRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoal>>,
  TError,
  { data: CreateGoalRequest },
  TContext
> => {
  const mutationKey = ["createGoal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoal>>,
    { data: CreateGoalRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createGoal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createGoal>>>;
export type CreateGoalMutationBody = CreateGoalRequest;
export type CreateGoalMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create a goal
 */
export const useCreateGoal = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGoal>>,
      TError,
      { data: CreateGoalRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createGoal>>,
  TError,
  { data: CreateGoalRequest },
  TContext
> => {
  return useMutation(getCreateGoalMutationOptions(options), queryClient);
};

export const getGetGoalStatsUrl = () => {
  return `/goals/stats`;
};

/**
 * Get current user's goal statistics.
 * @summary Get goal statistics
 */
export const getGoalStats = async (options?: RequestInit): Promise<GoalStatsResponse> => {
  return apiMutator<GoalStatsResponse>(getGetGoalStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGoalStatsQueryKey = () => {
  return [`/goals/stats`] as const;
};

export const getGetGoalStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoalStats>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalStats>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGoalStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoalStats>>> = ({ signal }) =>
    getGoalStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoalStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGoalStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getGoalStats>>>;
export type GetGoalStatsQueryError = ErrorResponse;

export function useGetGoalStats<
  TData = Awaited<ReturnType<typeof getGoalStats>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalStats>>,
          TError,
          Awaited<ReturnType<typeof getGoalStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGoalStats<
  TData = Awaited<ReturnType<typeof getGoalStats>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalStats>>,
          TError,
          Awaited<ReturnType<typeof getGoalStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGoalStats<
  TData = Awaited<ReturnType<typeof getGoalStats>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalStats>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get goal statistics
 */

export function useGetGoalStats<
  TData = Awaited<ReturnType<typeof getGoalStats>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalStats>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGoalStatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetDashboardSummaryUrl = () => {
  return `/goals/dashboard-summary`;
};

/**
 * Get dashboard summary with upcoming milestones.
 *
 * Returns upcoming milestones (max 5) sorted by target date,
 * along with summary counts for active goals and milestones.
 * Only includes milestones that have a target_date set and are not completed.
 * @summary Get dashboard summary
 */
export const getDashboardSummary = async (
  options?: RequestInit
): Promise<DashboardSummaryResponse> => {
  return apiMutator<DashboardSummaryResponse>(getGetDashboardSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = () => {
  return [`/goals/dashboard-summary`] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) =>
    getDashboardSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorResponse;

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get dashboard summary
 */

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDashboardSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTeamGoalsUrl = () => {
  return `/goals/team`;
};

/**
 * Get goals summary for team members. Requires READ_GOALS with TEAM scope.
 * @summary Get team goals summary
 */
export const getTeamGoals = async (options?: RequestInit): Promise<TeamGoalsResponse> => {
  return apiMutator<TeamGoalsResponse>(getGetTeamGoalsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamGoalsQueryKey = () => {
  return [`/goals/team`] as const;
};

export const getGetTeamGoalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamGoals>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamGoals>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamGoalsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamGoals>>> = ({ signal }) =>
    getTeamGoals({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamGoals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamGoals>>>;
export type GetTeamGoalsQueryError = ErrorResponse;

export function useGetTeamGoals<
  TData = Awaited<ReturnType<typeof getTeamGoals>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamGoals>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamGoals>>,
          TError,
          Awaited<ReturnType<typeof getTeamGoals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamGoals<
  TData = Awaited<ReturnType<typeof getTeamGoals>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamGoals>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamGoals>>,
          TError,
          Awaited<ReturnType<typeof getTeamGoals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamGoals<
  TData = Awaited<ReturnType<typeof getTeamGoals>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get team goals summary
 */

export function useGetTeamGoals<
  TData = Awaited<ReturnType<typeof getTeamGoals>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamGoalsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTeamMemberGoalsUrl = (userId: string, params?: GetTeamMemberGoalsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/team/${userId}?${stringifiedParams}`
    : `/goals/team/${userId}`;
};

/**
 * Get goals for a specific team member. Requires READ_GOALS with TEAM scope.
 * @summary Get team member's goals
 */
export const getTeamMemberGoals = async (
  userId: string,
  params?: GetTeamMemberGoalsParams,
  options?: RequestInit
): Promise<GoalListResponse> => {
  return apiMutator<GoalListResponse>(getGetTeamMemberGoalsUrl(userId, params), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamMemberGoalsQueryKey = (
  userId: string,
  params?: GetTeamMemberGoalsParams
) => {
  return [`/goals/team/${userId}`, ...(params ? [params] : [])] as const;
};

export const getGetTeamMemberGoalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamMemberGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetTeamMemberGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamMemberGoalsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamMemberGoals>>> = ({ signal }) =>
    getTeamMemberGoals(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberGoals>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTeamMemberGoalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamMemberGoals>>
>;
export type GetTeamMemberGoalsQueryError = ErrorResponse | HTTPValidationError;

export function useGetTeamMemberGoals<
  TData = Awaited<ReturnType<typeof getTeamMemberGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  params: undefined | GetTeamMemberGoalsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberGoals>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamMemberGoals>>,
          TError,
          Awaited<ReturnType<typeof getTeamMemberGoals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamMemberGoals<
  TData = Awaited<ReturnType<typeof getTeamMemberGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetTeamMemberGoalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberGoals>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamMemberGoals>>,
          TError,
          Awaited<ReturnType<typeof getTeamMemberGoals>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamMemberGoals<
  TData = Awaited<ReturnType<typeof getTeamMemberGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetTeamMemberGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get team member's goals
 */

export function useGetTeamMemberGoals<
  TData = Awaited<ReturnType<typeof getTeamMemberGoals>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  params?: GetTeamMemberGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberGoals>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamMemberGoalsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetAssignableTeamMembersUrl = () => {
  return `/goals/team-members`;
};

/**
 * Get list of team members that goals can be assigned to. Requires READ_GOALS with TEAM scope.
 * @summary Get assignable team members
 */
export const getAssignableTeamMembers = async (
  options?: RequestInit
): Promise<GetAssignableTeamMembers200Item[]> => {
  return apiMutator<GetAssignableTeamMembers200Item[]>(getGetAssignableTeamMembersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAssignableTeamMembersQueryKey = () => {
  return [`/goals/team-members`] as const;
};

export const getGetAssignableTeamMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignableTeamMembers>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAssignableTeamMembers>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssignableTeamMembersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignableTeamMembers>>> = ({
    signal,
  }) => getAssignableTeamMembers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignableTeamMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssignableTeamMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignableTeamMembers>>
>;
export type GetAssignableTeamMembersQueryError = ErrorResponse;

export function useGetAssignableTeamMembers<
  TData = Awaited<ReturnType<typeof getAssignableTeamMembers>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignableTeamMembers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignableTeamMembers>>,
          TError,
          Awaited<ReturnType<typeof getAssignableTeamMembers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssignableTeamMembers<
  TData = Awaited<ReturnType<typeof getAssignableTeamMembers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignableTeamMembers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignableTeamMembers>>,
          TError,
          Awaited<ReturnType<typeof getAssignableTeamMembers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssignableTeamMembers<
  TData = Awaited<ReturnType<typeof getAssignableTeamMembers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignableTeamMembers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get assignable team members
 */

export function useGetAssignableTeamMembers<
  TData = Awaited<ReturnType<typeof getAssignableTeamMembers>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignableTeamMembers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAssignableTeamMembersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateGoalWithMilestonesUrl = () => {
  return `/goals/with-milestones`;
};

/**
 * Create a new goal with milestones in one call.
 * @summary Create goal with milestones
 */
export const createGoalWithMilestones = async (
  createGoalWithMilestonesRequest: CreateGoalWithMilestonesRequest,
  options?: RequestInit
): Promise<GoalResponse> => {
  return apiMutator<GoalResponse>(getCreateGoalWithMilestonesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createGoalWithMilestonesRequest),
  });
};

export const getCreateGoalWithMilestonesMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoalWithMilestones>>,
    TError,
    { data: CreateGoalWithMilestonesRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoalWithMilestones>>,
  TError,
  { data: CreateGoalWithMilestonesRequest },
  TContext
> => {
  const mutationKey = ["createGoalWithMilestones"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoalWithMilestones>>,
    { data: CreateGoalWithMilestonesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createGoalWithMilestones(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoalWithMilestonesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGoalWithMilestones>>
>;
export type CreateGoalWithMilestonesMutationBody = CreateGoalWithMilestonesRequest;
export type CreateGoalWithMilestonesMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create goal with milestones
 */
export const useCreateGoalWithMilestones = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGoalWithMilestones>>,
      TError,
      { data: CreateGoalWithMilestonesRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createGoalWithMilestones>>,
  TError,
  { data: CreateGoalWithMilestonesRequest },
  TContext
> => {
  return useMutation(getCreateGoalWithMilestonesMutationOptions(options), queryClient);
};

export const getGetGoalUrl = (goalId: string, params?: GetGoalParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/${goalId}?${stringifiedParams}`
    : `/goals/${goalId}`;
};

/**
 * Get a goal by ID.
 * @summary Get goal by ID
 */
export const getGoal = async (
  goalId: string,
  params?: GetGoalParams,
  options?: RequestInit
): Promise<GoalResponse> => {
  return apiMutator<GoalResponse>(getGetGoalUrl(goalId, params), {
    ...options,
    method: "GET",
  });
};

export const getGetGoalQueryKey = (goalId: string, params?: GetGoalParams) => {
  return [`/goals/${goalId}`, ...(params ? [params] : [])] as const;
};

export const getGetGoalQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoal>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  goalId: string,
  params?: GetGoalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGoalQueryKey(goalId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoal>>> = ({ signal }) =>
    getGoal(goalId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: goalId !== null && goalId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getGoal>>>;
export type GetGoalQueryError = ErrorResponse | HTTPValidationError;

export function useGetGoal<
  TData = Awaited<ReturnType<typeof getGoal>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  goalId: string,
  params: undefined | GetGoalParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoal>>,
          TError,
          Awaited<ReturnType<typeof getGoal>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGoal<
  TData = Awaited<ReturnType<typeof getGoal>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  goalId: string,
  params?: GetGoalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoal>>,
          TError,
          Awaited<ReturnType<typeof getGoal>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGoal<
  TData = Awaited<ReturnType<typeof getGoal>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  goalId: string,
  params?: GetGoalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get goal by ID
 */

export function useGetGoal<
  TData = Awaited<ReturnType<typeof getGoal>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  goalId: string,
  params?: GetGoalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGoalQueryOptions(goalId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateGoalUrl = (goalId: string) => {
  return `/goals/${goalId}`;
};

/**
 * Update a goal.
 * @summary Update a goal
 */
export const updateGoal = async (
  goalId: string,
  updateGoalRequest: UpdateGoalRequest,
  options?: RequestInit
): Promise<GoalResponse> => {
  return apiMutator<GoalResponse>(getUpdateGoalUrl(goalId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateGoalRequest),
  });
};

export const getUpdateGoalMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoal>>,
    TError,
    { goalId: string; data: UpdateGoalRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGoal>>,
  TError,
  { goalId: string; data: UpdateGoalRequest },
  TContext
> => {
  const mutationKey = ["updateGoal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGoal>>,
    { goalId: string; data: UpdateGoalRequest }
  > = (props) => {
    const { goalId, data } = props ?? {};

    return updateGoal(goalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateGoal>>>;
export type UpdateGoalMutationBody = UpdateGoalRequest;
export type UpdateGoalMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update a goal
 */
export const useUpdateGoal = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateGoal>>,
      TError,
      { goalId: string; data: UpdateGoalRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateGoal>>,
  TError,
  { goalId: string; data: UpdateGoalRequest },
  TContext
> => {
  return useMutation(getUpdateGoalMutationOptions(options), queryClient);
};

export const getDeleteGoalUrl = (goalId: string) => {
  return `/goals/${goalId}`;
};

/**
 * Delete a goal and all its milestones and tasks.
 * @summary Delete a goal
 */
export const deleteGoal = async (goalId: string, options?: RequestInit): Promise<void> => {
  return apiMutator<void>(getDeleteGoalUrl(goalId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteGoalMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoal>>,
    TError,
    { goalId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGoal>>,
  TError,
  { goalId: string },
  TContext
> => {
  const mutationKey = ["deleteGoal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGoal>>, { goalId: string }> = (
    props
  ) => {
    const { goalId } = props ?? {};

    return deleteGoal(goalId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGoalMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGoal>>>;

export type DeleteGoalMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a goal
 */
export const useDeleteGoal = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteGoal>>,
      TError,
      { goalId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteGoal>>,
  TError,
  { goalId: string },
  TContext
> => {
  return useMutation(getDeleteGoalMutationOptions(options), queryClient);
};

export const getCreateMilestoneUrl = (goalId: string) => {
  return `/goals/${goalId}/milestones`;
};

/**
 * Create a new milestone for a goal.
 * @summary Create a milestone
 */
export const createMilestone = async (
  goalId: string,
  createMilestoneRequest: CreateMilestoneRequest,
  options?: RequestInit
): Promise<MilestoneResponse> => {
  return apiMutator<MilestoneResponse>(getCreateMilestoneUrl(goalId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMilestoneRequest),
  });
};

export const getCreateMilestoneMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMilestone>>,
    TError,
    { goalId: string; data: CreateMilestoneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMilestone>>,
  TError,
  { goalId: string; data: CreateMilestoneRequest },
  TContext
> => {
  const mutationKey = ["createMilestone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMilestone>>,
    { goalId: string; data: CreateMilestoneRequest }
  > = (props) => {
    const { goalId, data } = props ?? {};

    return createMilestone(goalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMilestoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMilestone>>
>;
export type CreateMilestoneMutationBody = CreateMilestoneRequest;
export type CreateMilestoneMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create a milestone
 */
export const useCreateMilestone = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMilestone>>,
      TError,
      { goalId: string; data: CreateMilestoneRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createMilestone>>,
  TError,
  { goalId: string; data: CreateMilestoneRequest },
  TContext
> => {
  return useMutation(getCreateMilestoneMutationOptions(options), queryClient);
};

export const getUpdateMilestoneUrl = (milestoneId: string, params: UpdateMilestoneParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/milestones/${milestoneId}?${stringifiedParams}`
    : `/goals/milestones/${milestoneId}`;
};

/**
 * Update a milestone.
 * @summary Update a milestone
 */
export const updateMilestone = async (
  milestoneId: string,
  updateMilestoneRequest: UpdateMilestoneRequest,
  params: UpdateMilestoneParams,
  options?: RequestInit
): Promise<MilestoneResponse> => {
  return apiMutator<MilestoneResponse>(getUpdateMilestoneUrl(milestoneId, params), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMilestoneRequest),
  });
};

export const getUpdateMilestoneMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMilestone>>,
    TError,
    { milestoneId: string; data: UpdateMilestoneRequest; params: UpdateMilestoneParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMilestone>>,
  TError,
  { milestoneId: string; data: UpdateMilestoneRequest; params: UpdateMilestoneParams },
  TContext
> => {
  const mutationKey = ["updateMilestone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMilestone>>,
    { milestoneId: string; data: UpdateMilestoneRequest; params: UpdateMilestoneParams }
  > = (props) => {
    const { milestoneId, data, params } = props ?? {};

    return updateMilestone(milestoneId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMilestoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMilestone>>
>;
export type UpdateMilestoneMutationBody = UpdateMilestoneRequest;
export type UpdateMilestoneMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update a milestone
 */
export const useUpdateMilestone = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMilestone>>,
      TError,
      { milestoneId: string; data: UpdateMilestoneRequest; params: UpdateMilestoneParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateMilestone>>,
  TError,
  { milestoneId: string; data: UpdateMilestoneRequest; params: UpdateMilestoneParams },
  TContext
> => {
  return useMutation(getUpdateMilestoneMutationOptions(options), queryClient);
};

export const getDeleteMilestoneUrl = (milestoneId: string, params: DeleteMilestoneParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/milestones/${milestoneId}?${stringifiedParams}`
    : `/goals/milestones/${milestoneId}`;
};

/**
 * Delete a milestone and all its tasks.
 * @summary Delete a milestone
 */
export const deleteMilestone = async (
  milestoneId: string,
  params: DeleteMilestoneParams,
  options?: RequestInit
): Promise<void> => {
  return apiMutator<void>(getDeleteMilestoneUrl(milestoneId, params), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMilestoneMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMilestone>>,
    TError,
    { milestoneId: string; params: DeleteMilestoneParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMilestone>>,
  TError,
  { milestoneId: string; params: DeleteMilestoneParams },
  TContext
> => {
  const mutationKey = ["deleteMilestone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMilestone>>,
    { milestoneId: string; params: DeleteMilestoneParams }
  > = (props) => {
    const { milestoneId, params } = props ?? {};

    return deleteMilestone(milestoneId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMilestoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMilestone>>
>;

export type DeleteMilestoneMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a milestone
 */
export const useDeleteMilestone = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMilestone>>,
      TError,
      { milestoneId: string; params: DeleteMilestoneParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMilestone>>,
  TError,
  { milestoneId: string; params: DeleteMilestoneParams },
  TContext
> => {
  return useMutation(getDeleteMilestoneMutationOptions(options), queryClient);
};

export const getReorderMilestonesUrl = () => {
  return `/goals/milestones/reorder`;
};

/**
 * Reorder milestones within a goal.
 * @summary Reorder milestones
 */
export const reorderMilestones = async (
  reorderMilestonesRequest: ReorderMilestonesRequest,
  options?: RequestInit
): Promise<ReorderResponse> => {
  return apiMutator<ReorderResponse>(getReorderMilestonesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderMilestonesRequest),
  });
};

export const getReorderMilestonesMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderMilestones>>,
    TError,
    { data: ReorderMilestonesRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderMilestones>>,
  TError,
  { data: ReorderMilestonesRequest },
  TContext
> => {
  const mutationKey = ["reorderMilestones"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderMilestones>>,
    { data: ReorderMilestonesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return reorderMilestones(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderMilestonesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderMilestones>>
>;
export type ReorderMilestonesMutationBody = ReorderMilestonesRequest;
export type ReorderMilestonesMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reorder milestones
 */
export const useReorderMilestones = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderMilestones>>,
      TError,
      { data: ReorderMilestonesRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderMilestones>>,
  TError,
  { data: ReorderMilestonesRequest },
  TContext
> => {
  return useMutation(getReorderMilestonesMutationOptions(options), queryClient);
};

export const getCreateTaskUrl = (milestoneId: string, params: CreateTaskParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/milestones/${milestoneId}/tasks?${stringifiedParams}`
    : `/goals/milestones/${milestoneId}/tasks`;
};

/**
 * Create a new task for a milestone.
 * @summary Create a task
 */
export const createTask = async (
  milestoneId: string,
  createTaskRequest: CreateTaskRequest,
  params: CreateTaskParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getCreateTaskUrl(milestoneId, params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskRequest),
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { milestoneId: string; data: CreateTaskRequest; params: CreateTaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { milestoneId: string; data: CreateTaskRequest; params: CreateTaskParams },
  TContext
> => {
  const mutationKey = ["createTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { milestoneId: string; data: CreateTaskRequest; params: CreateTaskParams }
  > = (props) => {
    const { milestoneId, data, params } = props ?? {};

    return createTask(milestoneId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>;
export type CreateTaskMutationBody = CreateTaskRequest;
export type CreateTaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create a task
 */
export const useCreateTask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTask>>,
      TError,
      { milestoneId: string; data: CreateTaskRequest; params: CreateTaskParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { milestoneId: string; data: CreateTaskRequest; params: CreateTaskParams },
  TContext
> => {
  return useMutation(getCreateTaskMutationOptions(options), queryClient);
};

export const getUpdateTaskUrl = (taskId: string, params: UpdateTaskParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}?${stringifiedParams}`
    : `/goals/tasks/${taskId}`;
};

/**
 * Update a task.
 * @summary Update a task
 */
export const updateTask = async (
  taskId: string,
  updateTaskRequest: UpdateTaskRequest,
  params: UpdateTaskParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getUpdateTaskUrl(taskId, params), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaskRequest),
  });
};

export const getUpdateTaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { taskId: string; data: UpdateTaskRequest; params: UpdateTaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { taskId: string; data: UpdateTaskRequest; params: UpdateTaskParams },
  TContext
> => {
  const mutationKey = ["updateTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { taskId: string; data: UpdateTaskRequest; params: UpdateTaskParams }
  > = (props) => {
    const { taskId, data, params } = props ?? {};

    return updateTask(taskId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>;
export type UpdateTaskMutationBody = UpdateTaskRequest;
export type UpdateTaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update a task
 */
export const useUpdateTask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTask>>,
      TError,
      { taskId: string; data: UpdateTaskRequest; params: UpdateTaskParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { taskId: string; data: UpdateTaskRequest; params: UpdateTaskParams },
  TContext
> => {
  return useMutation(getUpdateTaskMutationOptions(options), queryClient);
};

export const getDeleteTaskUrl = (taskId: string, params: DeleteTaskParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}?${stringifiedParams}`
    : `/goals/tasks/${taskId}`;
};

/**
 * Delete a task.
 * @summary Delete a task
 */
export const deleteTask = async (
  taskId: string,
  params: DeleteTaskParams,
  options?: RequestInit
): Promise<void> => {
  return apiMutator<void>(getDeleteTaskUrl(taskId, params), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { taskId: string; params: DeleteTaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { taskId: string; params: DeleteTaskParams },
  TContext
> => {
  const mutationKey = ["deleteTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTask>>,
    { taskId: string; params: DeleteTaskParams }
  > = (props) => {
    const { taskId, params } = props ?? {};

    return deleteTask(taskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>;

export type DeleteTaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a task
 */
export const useDeleteTask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTask>>,
      TError,
      { taskId: string; params: DeleteTaskParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { taskId: string; params: DeleteTaskParams },
  TContext
> => {
  return useMutation(getDeleteTaskMutationOptions(options), queryClient);
};

export const getToggleTaskUrl = (taskId: string, params: ToggleTaskParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/toggle?${stringifiedParams}`
    : `/goals/tasks/${taskId}/toggle`;
};

/**
 * Toggle task completion status.
 * @summary Toggle task completion
 */
export const toggleTask = async (
  taskId: string,
  params: ToggleTaskParams,
  options?: RequestInit
): Promise<TaskResponse> => {
  return apiMutator<TaskResponse>(getToggleTaskUrl(taskId, params), {
    ...options,
    method: "POST",
  });
};

export const getToggleTaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleTask>>,
    TError,
    { taskId: string; params: ToggleTaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleTask>>,
  TError,
  { taskId: string; params: ToggleTaskParams },
  TContext
> => {
  const mutationKey = ["toggleTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleTask>>,
    { taskId: string; params: ToggleTaskParams }
  > = (props) => {
    const { taskId, params } = props ?? {};

    return toggleTask(taskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleTaskMutationResult = NonNullable<Awaited<ReturnType<typeof toggleTask>>>;

export type ToggleTaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Toggle task completion
 */
export const useToggleTask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleTask>>,
      TError,
      { taskId: string; params: ToggleTaskParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof toggleTask>>,
  TError,
  { taskId: string; params: ToggleTaskParams },
  TContext
> => {
  return useMutation(getToggleTaskMutationOptions(options), queryClient);
};

export const getReorderTasksUrl = (params: ReorderTasksParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/reorder?${stringifiedParams}`
    : `/goals/tasks/reorder`;
};

/**
 * Reorder tasks within a milestone.
 * @summary Reorder tasks
 */
export const reorderTasks = async (
  reorderTasksRequest: ReorderTasksRequest,
  params: ReorderTasksParams,
  options?: RequestInit
): Promise<ReorderResponse> => {
  return apiMutator<ReorderResponse>(getReorderTasksUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderTasksRequest),
  });
};

export const getReorderTasksMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderTasks>>,
    TError,
    { data: ReorderTasksRequest; params: ReorderTasksParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderTasks>>,
  TError,
  { data: ReorderTasksRequest; params: ReorderTasksParams },
  TContext
> => {
  const mutationKey = ["reorderTasks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderTasks>>,
    { data: ReorderTasksRequest; params: ReorderTasksParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return reorderTasks(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderTasksMutationResult = NonNullable<Awaited<ReturnType<typeof reorderTasks>>>;
export type ReorderTasksMutationBody = ReorderTasksRequest;
export type ReorderTasksMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Reorder tasks
 */
export const useReorderTasks = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderTasks>>,
      TError,
      { data: ReorderTasksRequest; params: ReorderTasksParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderTasks>>,
  TError,
  { data: ReorderTasksRequest; params: ReorderTasksParams },
  TContext
> => {
  return useMutation(getReorderTasksMutationOptions(options), queryClient);
};

export const getAddSubtaskUrl = (taskId: string, params: AddSubtaskParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/subtasks?${stringifiedParams}`
    : `/goals/tasks/${taskId}/subtasks`;
};

/**
 * Add a subtask to a task.
 * @summary Add a subtask
 */
export const addSubtask = async (
  taskId: string,
  createSubtaskRequest: CreateSubtaskRequest,
  params: AddSubtaskParams,
  options?: RequestInit
): Promise<SubtaskResponse> => {
  return apiMutator<SubtaskResponse>(getAddSubtaskUrl(taskId, params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSubtaskRequest),
  });
};

export const getAddSubtaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSubtask>>,
    TError,
    { taskId: string; data: CreateSubtaskRequest; params: AddSubtaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSubtask>>,
  TError,
  { taskId: string; data: CreateSubtaskRequest; params: AddSubtaskParams },
  TContext
> => {
  const mutationKey = ["addSubtask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSubtask>>,
    { taskId: string; data: CreateSubtaskRequest; params: AddSubtaskParams }
  > = (props) => {
    const { taskId, data, params } = props ?? {};

    return addSubtask(taskId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSubtaskMutationResult = NonNullable<Awaited<ReturnType<typeof addSubtask>>>;
export type AddSubtaskMutationBody = CreateSubtaskRequest;
export type AddSubtaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Add a subtask
 */
export const useAddSubtask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addSubtask>>,
      TError,
      { taskId: string; data: CreateSubtaskRequest; params: AddSubtaskParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addSubtask>>,
  TError,
  { taskId: string; data: CreateSubtaskRequest; params: AddSubtaskParams },
  TContext
> => {
  return useMutation(getAddSubtaskMutationOptions(options), queryClient);
};

export const getUpdateSubtaskUrl = (
  taskId: string,
  subtaskId: string,
  params: UpdateSubtaskParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/subtasks/${subtaskId}?${stringifiedParams}`
    : `/goals/tasks/${taskId}/subtasks/${subtaskId}`;
};

/**
 * Update a subtask.
 * @summary Update a subtask
 */
export const updateSubtask = async (
  taskId: string,
  subtaskId: string,
  updateSubtaskRequest: UpdateSubtaskRequest,
  params: UpdateSubtaskParams,
  options?: RequestInit
): Promise<SubtaskResponse> => {
  return apiMutator<SubtaskResponse>(getUpdateSubtaskUrl(taskId, subtaskId, params), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSubtaskRequest),
  });
};

export const getUpdateSubtaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubtask>>,
    TError,
    { taskId: string; subtaskId: string; data: UpdateSubtaskRequest; params: UpdateSubtaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubtask>>,
  TError,
  { taskId: string; subtaskId: string; data: UpdateSubtaskRequest; params: UpdateSubtaskParams },
  TContext
> => {
  const mutationKey = ["updateSubtask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubtask>>,
    { taskId: string; subtaskId: string; data: UpdateSubtaskRequest; params: UpdateSubtaskParams }
  > = (props) => {
    const { taskId, subtaskId, data, params } = props ?? {};

    return updateSubtask(taskId, subtaskId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubtaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateSubtask>>>;
export type UpdateSubtaskMutationBody = UpdateSubtaskRequest;
export type UpdateSubtaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update a subtask
 */
export const useUpdateSubtask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSubtask>>,
      TError,
      {
        taskId: string;
        subtaskId: string;
        data: UpdateSubtaskRequest;
        params: UpdateSubtaskParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSubtask>>,
  TError,
  { taskId: string; subtaskId: string; data: UpdateSubtaskRequest; params: UpdateSubtaskParams },
  TContext
> => {
  return useMutation(getUpdateSubtaskMutationOptions(options), queryClient);
};

export const getDeleteSubtaskUrl = (
  taskId: string,
  subtaskId: string,
  params: DeleteSubtaskParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/subtasks/${subtaskId}?${stringifiedParams}`
    : `/goals/tasks/${taskId}/subtasks/${subtaskId}`;
};

/**
 * Delete a subtask.
 * @summary Delete a subtask
 */
export const deleteSubtask = async (
  taskId: string,
  subtaskId: string,
  params: DeleteSubtaskParams,
  options?: RequestInit
): Promise<void> => {
  return apiMutator<void>(getDeleteSubtaskUrl(taskId, subtaskId, params), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSubtaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSubtask>>,
    TError,
    { taskId: string; subtaskId: string; params: DeleteSubtaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSubtask>>,
  TError,
  { taskId: string; subtaskId: string; params: DeleteSubtaskParams },
  TContext
> => {
  const mutationKey = ["deleteSubtask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSubtask>>,
    { taskId: string; subtaskId: string; params: DeleteSubtaskParams }
  > = (props) => {
    const { taskId, subtaskId, params } = props ?? {};

    return deleteSubtask(taskId, subtaskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSubtaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSubtask>>>;

export type DeleteSubtaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a subtask
 */
export const useDeleteSubtask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSubtask>>,
      TError,
      { taskId: string; subtaskId: string; params: DeleteSubtaskParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSubtask>>,
  TError,
  { taskId: string; subtaskId: string; params: DeleteSubtaskParams },
  TContext
> => {
  return useMutation(getDeleteSubtaskMutationOptions(options), queryClient);
};

export const getToggleSubtaskUrl = (
  taskId: string,
  subtaskId: string,
  params: ToggleSubtaskParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/goals/tasks/${taskId}/subtasks/${subtaskId}/toggle?${stringifiedParams}`
    : `/goals/tasks/${taskId}/subtasks/${subtaskId}/toggle`;
};

/**
 * Toggle subtask completion.
 * @summary Toggle subtask completion
 */
export const toggleSubtask = async (
  taskId: string,
  subtaskId: string,
  params: ToggleSubtaskParams,
  options?: RequestInit
): Promise<SubtaskResponse> => {
  return apiMutator<SubtaskResponse>(getToggleSubtaskUrl(taskId, subtaskId, params), {
    ...options,
    method: "POST",
  });
};

export const getToggleSubtaskMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleSubtask>>,
    TError,
    { taskId: string; subtaskId: string; params: ToggleSubtaskParams },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleSubtask>>,
  TError,
  { taskId: string; subtaskId: string; params: ToggleSubtaskParams },
  TContext
> => {
  const mutationKey = ["toggleSubtask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleSubtask>>,
    { taskId: string; subtaskId: string; params: ToggleSubtaskParams }
  > = (props) => {
    const { taskId, subtaskId, params } = props ?? {};

    return toggleSubtask(taskId, subtaskId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleSubtaskMutationResult = NonNullable<Awaited<ReturnType<typeof toggleSubtask>>>;

export type ToggleSubtaskMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Toggle subtask completion
 */
export const useToggleSubtask = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleSubtask>>,
      TError,
      { taskId: string; subtaskId: string; params: ToggleSubtaskParams },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof toggleSubtask>>,
  TError,
  { taskId: string; subtaskId: string; params: ToggleSubtaskParams },
  TContext
> => {
  return useMutation(getToggleSubtaskMutationOptions(options), queryClient);
};

export const getConnectFirefliesUrl = () => {
  return `/integrations/fireflies/connect`;
};

/**
 * Connect Fireflies account by validating and storing API key.
 * @summary Connect Fireflies account
 */
export const connectFireflies = async (
  firefliesConnectRequest: FirefliesConnectRequest,
  options?: RequestInit
): Promise<FirefliesStatusResponse> => {
  return apiMutator<FirefliesStatusResponse>(getConnectFirefliesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(firefliesConnectRequest),
  });
};

export const getConnectFirefliesMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectFireflies>>,
    TError,
    { data: FirefliesConnectRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectFireflies>>,
  TError,
  { data: FirefliesConnectRequest },
  TContext
> => {
  const mutationKey = ["connectFireflies"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectFireflies>>,
    { data: FirefliesConnectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return connectFireflies(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectFirefliesMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectFireflies>>
>;
export type ConnectFirefliesMutationBody = FirefliesConnectRequest;
export type ConnectFirefliesMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Connect Fireflies account
 */
export const useConnectFireflies = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof connectFireflies>>,
      TError,
      { data: FirefliesConnectRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof connectFireflies>>,
  TError,
  { data: FirefliesConnectRequest },
  TContext
> => {
  return useMutation(getConnectFirefliesMutationOptions(options), queryClient);
};

export const getDisconnectFirefliesUrl = () => {
  return `/integrations/fireflies/disconnect`;
};

/**
 * Disconnect Fireflies account by removing stored API key.
 * @summary Disconnect Fireflies account
 */
export const disconnectFireflies = async (
  options?: RequestInit
): Promise<FirefliesDisconnectResponse> => {
  return apiMutator<FirefliesDisconnectResponse>(getDisconnectFirefliesUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectFirefliesMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectFireflies>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof disconnectFireflies>>, TError, void, TContext> => {
  const mutationKey = ["disconnectFireflies"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectFireflies>>,
    void
  > = () => {
    return disconnectFireflies(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectFirefliesMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectFireflies>>
>;

export type DisconnectFirefliesMutationError = ErrorResponse;

/**
 * @summary Disconnect Fireflies account
 */
export const useDisconnectFireflies = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disconnectFireflies>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof disconnectFireflies>>, TError, void, TContext> => {
  return useMutation(getDisconnectFirefliesMutationOptions(options), queryClient);
};

export const getGetFirefliesStatusUrl = () => {
  return `/integrations/fireflies/status`;
};

/**
 * Get current Fireflies connection status.
 * @summary Get Fireflies connection status
 */
export const getFirefliesStatus = async (
  options?: RequestInit
): Promise<FirefliesStatusResponse> => {
  return apiMutator<FirefliesStatusResponse>(getGetFirefliesStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetFirefliesStatusQueryKey = () => {
  return [`/integrations/fireflies/status`] as const;
};

export const getGetFirefliesStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirefliesStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFirefliesStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFirefliesStatus>>> = ({ signal }) =>
    getFirefliesStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFirefliesStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFirefliesStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFirefliesStatus>>
>;
export type GetFirefliesStatusQueryError = ErrorResponse;

export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirefliesStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirefliesStatus>>,
          TError,
          Awaited<ReturnType<typeof getFirefliesStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFirefliesStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirefliesStatus>>,
          TError,
          Awaited<ReturnType<typeof getFirefliesStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirefliesStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Fireflies connection status
 */

export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirefliesStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFirefliesStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListFirefliesTranscriptsUrl = (params?: ListFirefliesTranscriptsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/integrations/fireflies/transcripts?${stringifiedParams}`
    : `/integrations/fireflies/transcripts`;
};

/**
 * List transcripts from Fireflies API.
 * @summary List Fireflies transcripts
 */
export const listFirefliesTranscripts = async (
  params?: ListFirefliesTranscriptsParams,
  options?: RequestInit
): Promise<FirefliesTranscriptListResponse> => {
  return apiMutator<FirefliesTranscriptListResponse>(getListFirefliesTranscriptsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListFirefliesTranscriptsQueryKey = (params?: ListFirefliesTranscriptsParams) => {
  return [`/integrations/fireflies/transcripts`, ...(params ? [params] : [])] as const;
};

export const getListFirefliesTranscriptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFirefliesTranscripts>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFirefliesTranscriptsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFirefliesTranscripts>>> = ({
    signal,
  }) => listFirefliesTranscripts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFirefliesTranscripts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFirefliesTranscriptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFirefliesTranscripts>>
>;
export type ListFirefliesTranscriptsQueryError = ErrorResponse | HTTPValidationError;

export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ListFirefliesTranscriptsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFirefliesTranscripts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFirefliesTranscripts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFirefliesTranscripts>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Fireflies transcripts
 */

export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFirefliesTranscripts>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFirefliesTranscriptsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSearchFirefliesTranscriptsUrl = (params: SearchFirefliesTranscriptsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/integrations/fireflies/transcripts/search?${stringifiedParams}`
    : `/integrations/fireflies/transcripts/search`;
};

/**
 * Search transcripts via Fireflies API.
 * @summary Search Fireflies transcripts
 */
export const searchFirefliesTranscripts = async (
  params: SearchFirefliesTranscriptsParams,
  options?: RequestInit
): Promise<FirefliesTranscriptListResponse> => {
  return apiMutator<FirefliesTranscriptListResponse>(getSearchFirefliesTranscriptsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchFirefliesTranscriptsQueryKey = (
  params?: SearchFirefliesTranscriptsParams
) => {
  return [`/integrations/fireflies/transcripts/search`, ...(params ? [params] : [])] as const;
};

export const getSearchFirefliesTranscriptsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchFirefliesTranscripts>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchFirefliesTranscriptsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchFirefliesTranscripts>>> = ({
    signal,
  }) => searchFirefliesTranscripts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchFirefliesTranscriptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchFirefliesTranscripts>>
>;
export type SearchFirefliesTranscriptsQueryError = ErrorResponse | HTTPValidationError;

export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchFirefliesTranscripts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchFirefliesTranscripts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchFirefliesTranscripts>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Fireflies transcripts
 */

export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchFirefliesTranscripts>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchFirefliesTranscriptsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getImportFirefliesTranscriptUrl = (transcriptId: string) => {
  return `/integrations/fireflies/transcripts/${transcriptId}/import`;
};

/**
 * Import a transcript from Fireflies to local storage.
 * @summary Import a Fireflies transcript
 */
export const importFirefliesTranscript = async (
  transcriptId: string,
  options?: RequestInit
): Promise<ImportTranscriptResponse> => {
  return apiMutator<ImportTranscriptResponse>(getImportFirefliesTranscriptUrl(transcriptId), {
    ...options,
    method: "POST",
  });
};

export const getImportFirefliesTranscriptMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importFirefliesTranscript>>,
    TError,
    { transcriptId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importFirefliesTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  const mutationKey = ["importFirefliesTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importFirefliesTranscript>>,
    { transcriptId: string }
  > = (props) => {
    const { transcriptId } = props ?? {};

    return importFirefliesTranscript(transcriptId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportFirefliesTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof importFirefliesTranscript>>
>;

export type ImportFirefliesTranscriptMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Import a Fireflies transcript
 */
export const useImportFirefliesTranscript = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importFirefliesTranscript>>,
      TError,
      { transcriptId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importFirefliesTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  return useMutation(getImportFirefliesTranscriptMutationOptions(options), queryClient);
};

export const getGetOutlookStatusUrl = () => {
  return `/integrations/outlook/status`;
};

/**
 * Get Outlook calendar availability and sync status.
 *
 * Returns availability status for all users. For Microsoft users,
 * also returns sync settings and statistics.
 * @summary Get Outlook calendar status
 */
export const getOutlookStatus = async (options?: RequestInit): Promise<OutlookStatusResponse> => {
  return apiMutator<OutlookStatusResponse>(getGetOutlookStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOutlookStatusQueryKey = () => {
  return [`/integrations/outlook/status`] as const;
};

export const getGetOutlookStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutlookStatus>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutlookStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOutlookStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutlookStatus>>> = ({ signal }) =>
    getOutlookStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutlookStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOutlookStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOutlookStatus>>>;
export type GetOutlookStatusQueryError = ErrorResponse;

export function useGetOutlookStatus<
  TData = Awaited<ReturnType<typeof getOutlookStatus>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutlookStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutlookStatus>>,
          TError,
          Awaited<ReturnType<typeof getOutlookStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOutlookStatus<
  TData = Awaited<ReturnType<typeof getOutlookStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutlookStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutlookStatus>>,
          TError,
          Awaited<ReturnType<typeof getOutlookStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOutlookStatus<
  TData = Awaited<ReturnType<typeof getOutlookStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutlookStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Outlook calendar status
 */

export function useGetOutlookStatus<
  TData = Awaited<ReturnType<typeof getOutlookStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutlookStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOutlookStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateOutlookSettingsUrl = () => {
  return `/integrations/outlook/settings`;
};

/**
 * Update Outlook sync settings.
 *
 * Requires Microsoft 365 sign-in.
 * @summary Update Outlook sync settings
 */
export const updateOutlookSettings = async (
  outlookSettingsUpdate: OutlookSettingsUpdate,
  options?: RequestInit
): Promise<OutlookSettingsResponse> => {
  return apiMutator<OutlookSettingsResponse>(getUpdateOutlookSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(outlookSettingsUpdate),
  });
};

export const getUpdateOutlookSettingsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOutlookSettings>>,
    TError,
    { data: OutlookSettingsUpdate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOutlookSettings>>,
  TError,
  { data: OutlookSettingsUpdate },
  TContext
> => {
  const mutationKey = ["updateOutlookSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOutlookSettings>>,
    { data: OutlookSettingsUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateOutlookSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOutlookSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOutlookSettings>>
>;
export type UpdateOutlookSettingsMutationBody = OutlookSettingsUpdate;
export type UpdateOutlookSettingsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update Outlook sync settings
 */
export const useUpdateOutlookSettings = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOutlookSettings>>,
      TError,
      { data: OutlookSettingsUpdate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOutlookSettings>>,
  TError,
  { data: OutlookSettingsUpdate },
  TContext
> => {
  return useMutation(getUpdateOutlookSettingsMutationOptions(options), queryClient);
};

export const getTriggerSyncUrl = () => {
  return `/integrations/outlook/sync`;
};

/**
 * Trigger manual sync of all goals and tasks to Outlook.
 *
 * Requires Microsoft 365 sign-in and sync to be enabled.
 * @summary Trigger manual sync to Outlook
 */
export const triggerSync = async (options?: RequestInit): Promise<OutlookSyncResponse> => {
  return apiMutator<OutlookSyncResponse>(getTriggerSyncUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTriggerSyncMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggerSync>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof triggerSync>>, TError, void, TContext> => {
  const mutationKey = ["triggerSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerSync>>, void> = () => {
    return triggerSync(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerSyncMutationResult = NonNullable<Awaited<ReturnType<typeof triggerSync>>>;

export type TriggerSyncMutationError = ErrorResponse;

/**
 * @summary Trigger manual sync to Outlook
 */
export const useTriggerSync = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggerSync>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof triggerSync>>, TError, void, TContext> => {
  return useMutation(getTriggerSyncMutationOptions(options), queryClient);
};

export const getListSyncedEventsUrl = (params?: ListSyncedEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/integrations/outlook/events?${stringifiedParams}`
    : `/integrations/outlook/events`;
};

/**
 * List calendar events synced from Pathways.
 *
 * Requires Microsoft 365 sign-in.
 * @summary List synced calendar events
 */
export const listSyncedEvents = async (
  params?: ListSyncedEventsParams,
  options?: RequestInit
): Promise<CalendarEventListResponse> => {
  return apiMutator<CalendarEventListResponse>(getListSyncedEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSyncedEventsQueryKey = (params?: ListSyncedEventsParams) => {
  return [`/integrations/outlook/events`, ...(params ? [params] : [])] as const;
};

export const getListSyncedEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSyncedEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListSyncedEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncedEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSyncedEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncedEvents>>> = ({ signal }) =>
    listSyncedEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSyncedEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSyncedEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncedEvents>>>;
export type ListSyncedEventsQueryError = ErrorResponse | HTTPValidationError;

export function useListSyncedEvents<
  TData = Awaited<ReturnType<typeof listSyncedEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ListSyncedEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncedEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSyncedEvents>>,
          TError,
          Awaited<ReturnType<typeof listSyncedEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSyncedEvents<
  TData = Awaited<ReturnType<typeof listSyncedEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListSyncedEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncedEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSyncedEvents>>,
          TError,
          Awaited<ReturnType<typeof listSyncedEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSyncedEvents<
  TData = Awaited<ReturnType<typeof listSyncedEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListSyncedEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncedEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List synced calendar events
 */

export function useListSyncedEvents<
  TData = Awaited<ReturnType<typeof listSyncedEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListSyncedEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncedEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSyncedEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getImportMeetingsUrl = (params: ImportMeetingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/integrations/outlook/meetings?${stringifiedParams}`
    : `/integrations/outlook/meetings`;
};

/**
 * Import meetings from Outlook for a date range.
 *
 * Fetches meetings directly from Outlook and returns them.
 * Requires Microsoft 365 sign-in.
 * @summary Import meetings from Outlook
 */
export const importMeetings = async (
  params: ImportMeetingsParams,
  options?: RequestInit
): Promise<MeetingListResponse> => {
  return apiMutator<MeetingListResponse>(getImportMeetingsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getImportMeetingsQueryKey = (params?: ImportMeetingsParams) => {
  return [`/integrations/outlook/meetings`, ...(params ? [params] : [])] as const;
};

export const getImportMeetingsQueryOptions = <
  TData = Awaited<ReturnType<typeof importMeetings>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: ImportMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importMeetings>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getImportMeetingsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof importMeetings>>> = ({ signal }) =>
    importMeetings(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof importMeetings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ImportMeetingsQueryResult = NonNullable<Awaited<ReturnType<typeof importMeetings>>>;
export type ImportMeetingsQueryError = ErrorResponse | HTTPValidationError;

export function useImportMeetings<
  TData = Awaited<ReturnType<typeof importMeetings>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: ImportMeetingsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof importMeetings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importMeetings>>,
          TError,
          Awaited<ReturnType<typeof importMeetings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportMeetings<
  TData = Awaited<ReturnType<typeof importMeetings>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: ImportMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importMeetings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importMeetings>>,
          TError,
          Awaited<ReturnType<typeof importMeetings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportMeetings<
  TData = Awaited<ReturnType<typeof importMeetings>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: ImportMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importMeetings>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import meetings from Outlook
 */

export function useImportMeetings<
  TData = Awaited<ReturnType<typeof importMeetings>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: ImportMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importMeetings>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getImportMeetingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateMeetingCategoryUrl = (meetingId: string) => {
  return `/integrations/outlook/meetings/${meetingId}`;
};

/**
 * Update the category of an imported meeting.
 *
 * Note: This is a placeholder. In a full implementation, this would
 * store the category in Firestore for future reference.
 * @summary Update meeting category
 */
export const updateMeetingCategory = async (
  meetingId: string,
  updateMeetingCategoryRequest: UpdateMeetingCategoryRequest,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getUpdateMeetingCategoryUrl(meetingId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMeetingCategoryRequest),
  });
};

export const getUpdateMeetingCategoryMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingCategory>>,
    TError,
    { meetingId: string; data: UpdateMeetingCategoryRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMeetingCategory>>,
  TError,
  { meetingId: string; data: UpdateMeetingCategoryRequest },
  TContext
> => {
  const mutationKey = ["updateMeetingCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMeetingCategory>>,
    { meetingId: string; data: UpdateMeetingCategoryRequest }
  > = (props) => {
    const { meetingId, data } = props ?? {};

    return updateMeetingCategory(meetingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeetingCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMeetingCategory>>
>;
export type UpdateMeetingCategoryMutationBody = UpdateMeetingCategoryRequest;
export type UpdateMeetingCategoryMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update meeting category
 */
export const useUpdateMeetingCategory = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMeetingCategory>>,
      TError,
      { meetingId: string; data: UpdateMeetingCategoryRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateMeetingCategory>>,
  TError,
  { meetingId: string; data: UpdateMeetingCategoryRequest },
  TContext
> => {
  return useMutation(getUpdateMeetingCategoryMutationOptions(options), queryClient);
};

export const getListUserCalendarsUrl = () => {
  return `/integrations/outlook/calendars`;
};

/**
 * List user's available Outlook calendars.
 *
 * Useful for letting users select which calendar to sync to.
 * Requires Microsoft 365 sign-in.
 * @summary List user's Outlook calendars
 */
export const listUserCalendars = async (options?: RequestInit): Promise<UserCalendarsResponse> => {
  return apiMutator<UserCalendarsResponse>(getListUserCalendarsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListUserCalendarsQueryKey = () => {
  return [`/integrations/outlook/calendars`] as const;
};

export const getListUserCalendarsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUserCalendars>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCalendars>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUserCalendarsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserCalendars>>> = ({ signal }) =>
    listUserCalendars({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUserCalendars>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUserCalendarsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUserCalendars>>
>;
export type ListUserCalendarsQueryError = ErrorResponse;

export function useListUserCalendars<
  TData = Awaited<ReturnType<typeof listUserCalendars>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCalendars>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserCalendars>>,
          TError,
          Awaited<ReturnType<typeof listUserCalendars>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUserCalendars<
  TData = Awaited<ReturnType<typeof listUserCalendars>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCalendars>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserCalendars>>,
          TError,
          Awaited<ReturnType<typeof listUserCalendars>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUserCalendars<
  TData = Awaited<ReturnType<typeof listUserCalendars>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCalendars>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List user's Outlook calendars
 */

export function useListUserCalendars<
  TData = Awaited<ReturnType<typeof listUserCalendars>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCalendars>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListUserCalendarsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTeamOverviewUrl = (params?: GetTeamOverviewParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/overview?${stringifiedParams}`
    : `/reports/overview`;
};

/**
 * Get team overview metrics.
 *
 * Returns aggregated metrics for the Team Overview tab including:
 * - Goal completion rate with trend
 * - Average learning days with trend
 * - AI queries per hour with trend
 * - Engagement score with trend
 * - Time series data for charts
 *
 * Requires manager, director, or administrator role.
 * @summary Get team overview metrics
 */
export const getTeamOverview = async (
  params?: GetTeamOverviewParams,
  options?: RequestInit
): Promise<TeamOverviewResponse> => {
  return apiMutator<TeamOverviewResponse>(getGetTeamOverviewUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamOverviewQueryKey = (params?: GetTeamOverviewParams) => {
  return [`/reports/overview`, ...(params ? [params] : [])] as const;
};

export const getGetTeamOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamOverviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamOverview>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamOverview>>> = ({ signal }) =>
    getTeamOverview(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamOverview>>>;
export type GetTeamOverviewQueryError = ErrorResponse | HTTPValidationError;

export function useGetTeamOverview<
  TData = Awaited<ReturnType<typeof getTeamOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetTeamOverviewParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamOverview>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamOverview>>,
          TError,
          Awaited<ReturnType<typeof getTeamOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamOverview<
  TData = Awaited<ReturnType<typeof getTeamOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamOverviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamOverview>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamOverview>>,
          TError,
          Awaited<ReturnType<typeof getTeamOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamOverview<
  TData = Awaited<ReturnType<typeof getTeamOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamOverviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamOverview>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get team overview metrics
 */

export function useGetTeamOverview<
  TData = Awaited<ReturnType<typeof getTeamOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamOverviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamOverview>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTeamMembersUrl = (params?: GetTeamMembersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/team-members?${stringifiedParams}`
    : `/reports/team-members`;
};

/**
 * Get team members with progress information.
 *
 * Returns a list of team members the viewer can see based on their role:
 * - Managers see users
 * - Directors see users and managers
 * - Administrators see all users
 *
 * Each member includes:
 * - Progress percentage (based on goals)
 * - Status (on_track, behind, at_risk)
 * - Last active timestamp
 *
 * Requires manager, director, or administrator role.
 *
 * If manager_id is provided, returns that manager's direct reports (for drill-down).
 * The current user must be an ancestor of the specified manager to access their team.
 * @summary Get team members with progress
 */
export const getTeamMembers = async (
  params?: GetTeamMembersParams,
  options?: RequestInit
): Promise<TeamMembersResponse> => {
  return apiMutator<TeamMembersResponse>(getGetTeamMembersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamMembersQueryKey = (params?: GetTeamMembersParams) => {
  return [`/reports/team-members`, ...(params ? [params] : [])] as const;
};

export const getGetTeamMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamMembersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamMembers>>> = ({ signal }) =>
    getTeamMembers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamMembers>>>;
export type GetTeamMembersQueryError = ErrorResponse | HTTPValidationError;

export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetTeamMembersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamMembers>>,
          TError,
          Awaited<ReturnType<typeof getTeamMembers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamMembers>>,
          TError,
          Awaited<ReturnType<typeof getTeamMembers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get team members with progress
 */

export function useGetTeamMembers<
  TData = Awaited<ReturnType<typeof getTeamMembers>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTeamMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamMembers>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamMembersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetLearningProgressUrl = (params?: GetLearningProgressParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/learning?${stringifiedParams}`
    : `/reports/learning`;
};

/**
 * Get learning progress metrics.
 *
 * Returns metrics for the Learning Progress tab including:
 * - Pathways (goals) completed count with trend
 * - Average completion time in days with trend
 * - Monthly progress time series
 *
 * Requires manager, director, or administrator role.
 * @summary Get learning progress metrics
 */
export const getLearningProgress = async (
  params?: GetLearningProgressParams,
  options?: RequestInit
): Promise<LearningProgressResponse> => {
  return apiMutator<LearningProgressResponse>(getGetLearningProgressUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetLearningProgressQueryKey = (params?: GetLearningProgressParams) => {
  return [`/reports/learning`, ...(params ? [params] : [])] as const;
};

export const getGetLearningProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof getLearningProgress>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetLearningProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLearningProgress>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLearningProgressQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLearningProgress>>> = ({ signal }) =>
    getLearningProgress(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLearningProgress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLearningProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLearningProgress>>
>;
export type GetLearningProgressQueryError = ErrorResponse | HTTPValidationError;

export function useGetLearningProgress<
  TData = Awaited<ReturnType<typeof getLearningProgress>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetLearningProgressParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLearningProgress>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearningProgress>>,
          TError,
          Awaited<ReturnType<typeof getLearningProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLearningProgress<
  TData = Awaited<ReturnType<typeof getLearningProgress>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetLearningProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLearningProgress>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearningProgress>>,
          TError,
          Awaited<ReturnType<typeof getLearningProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLearningProgress<
  TData = Awaited<ReturnType<typeof getLearningProgress>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetLearningProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLearningProgress>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get learning progress metrics
 */

export function useGetLearningProgress<
  TData = Awaited<ReturnType<typeof getLearningProgress>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetLearningProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLearningProgress>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLearningProgressQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetEngagementUrl = (params?: GetEngagementParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/engagement?${stringifiedParams}`
    : `/reports/engagement`;
};

/**
 * Get engagement metrics.
 *
 * Returns metrics for the Engagement tab including:
 * - Engagement score (percentage of active users)
 * - Active vs total user count
 * - Engagement history time series
 *
 * Requires manager, director, or administrator role.
 * @summary Get engagement metrics
 */
export const getEngagement = async (
  params?: GetEngagementParams,
  options?: RequestInit
): Promise<EngagementResponse> => {
  return apiMutator<EngagementResponse>(getGetEngagementUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetEngagementQueryKey = (params?: GetEngagementParams) => {
  return [`/reports/engagement`, ...(params ? [params] : [])] as const;
};

export const getGetEngagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getEngagement>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetEngagementParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagement>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEngagementQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEngagement>>> = ({ signal }) =>
    getEngagement(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEngagement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEngagementQueryResult = NonNullable<Awaited<ReturnType<typeof getEngagement>>>;
export type GetEngagementQueryError = ErrorResponse | HTTPValidationError;

export function useGetEngagement<
  TData = Awaited<ReturnType<typeof getEngagement>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetEngagementParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagement>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagement>>,
          TError,
          Awaited<ReturnType<typeof getEngagement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEngagement<
  TData = Awaited<ReturnType<typeof getEngagement>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetEngagementParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagement>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagement>>,
          TError,
          Awaited<ReturnType<typeof getEngagement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEngagement<
  TData = Awaited<ReturnType<typeof getEngagement>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetEngagementParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagement>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get engagement metrics
 */

export function useGetEngagement<
  TData = Awaited<ReturnType<typeof getEngagement>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetEngagementParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagement>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEngagementQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetAiUsageUrl = (params?: GetAiUsageParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/ai-usage?${stringifiedParams}`
    : `/reports/ai-usage`;
};

/**
 * Get AI usage metrics.
 *
 * Returns metrics for the AI Usage tab including:
 * - Queries per hour with trend
 * - Total conversations count
 * - Usage trend time series
 *
 * Requires manager, director, or administrator role.
 * @summary Get AI usage metrics
 */
export const getAiUsage = async (
  params?: GetAiUsageParams,
  options?: RequestInit
): Promise<AIUsageResponse> => {
  return apiMutator<AIUsageResponse>(getGetAiUsageUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAiUsageQueryKey = (params?: GetAiUsageParams) => {
  return [`/reports/ai-usage`, ...(params ? [params] : [])] as const;
};

export const getGetAiUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetAiUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiUsage>>> = ({ signal }) =>
    getAiUsage(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAiUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getAiUsage>>>;
export type GetAiUsageQueryError = ErrorResponse | HTTPValidationError;

export function useGetAiUsage<
  TData = Awaited<ReturnType<typeof getAiUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetAiUsageParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiUsage>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiUsage>>,
          TError,
          Awaited<ReturnType<typeof getAiUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAiUsage<
  TData = Awaited<ReturnType<typeof getAiUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetAiUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiUsage>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiUsage>>,
          TError,
          Awaited<ReturnType<typeof getAiUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAiUsage<
  TData = Awaited<ReturnType<typeof getAiUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetAiUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get AI usage metrics
 */

export function useGetAiUsage<
  TData = Awaited<ReturnType<typeof getAiUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetAiUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAiUsageQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getExportTeamReportUrl = (params?: ExportTeamReportParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/reports/export?${stringifiedParams}` : `/reports/export`;
};

/**
 * Export team report data.
 *
 * Downloads a file containing team progress data.
 *
 * Query parameters:
 * - range: Date range for metrics (30d, 90d, 6mo, 1yr)
 * - format: Export format (csv or pdf)
 *
 * Requires manager, director, or administrator role.
 * @summary Export team report data
 */
export const exportTeamReport = async (
  params?: ExportTeamReportParams,
  options?: RequestInit
): Promise<unknown> => {
  return apiMutator<unknown>(getExportTeamReportUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getExportTeamReportQueryKey = (params?: ExportTeamReportParams) => {
  return [`/reports/export`, ...(params ? [params] : [])] as const;
};

export const getExportTeamReportQueryOptions = <
  TData = Awaited<ReturnType<typeof exportTeamReport>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ExportTeamReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTeamReport>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportTeamReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportTeamReport>>> = ({ signal }) =>
    exportTeamReport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportTeamReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportTeamReportQueryResult = NonNullable<Awaited<ReturnType<typeof exportTeamReport>>>;
export type ExportTeamReportQueryError = ErrorResponse | HTTPValidationError;

export function useExportTeamReport<
  TData = Awaited<ReturnType<typeof exportTeamReport>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ExportTeamReportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTeamReport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTeamReport>>,
          TError,
          Awaited<ReturnType<typeof exportTeamReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportTeamReport<
  TData = Awaited<ReturnType<typeof exportTeamReport>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ExportTeamReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTeamReport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTeamReport>>,
          TError,
          Awaited<ReturnType<typeof exportTeamReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportTeamReport<
  TData = Awaited<ReturnType<typeof exportTeamReport>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ExportTeamReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTeamReport>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export team report data
 */

export function useExportTeamReport<
  TData = Awaited<ReturnType<typeof exportTeamReport>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ExportTeamReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTeamReport>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportTeamReportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTrainingOverviewUrl = (params?: GetTrainingOverviewParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/training?${stringifiedParams}`
    : `/reports/training`;
};

/**
 * Get training completion overview for the team.
 *
 * Returns metrics for the Training tab including:
 * - Average completion rate with trend
 * - Total courses completed and enrolled
 * - Connected users count
 * - Completion trend time series
 * - Per-member training breakdown
 *
 * Requires manager, director, or administrator role.
 * @summary Get training completion overview
 */
export const getTrainingOverview = async (
  params?: GetTrainingOverviewParams,
  options?: RequestInit
): Promise<TrainingOverviewResponse> => {
  return apiMutator<TrainingOverviewResponse>(getGetTrainingOverviewUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainingOverviewQueryKey = (params?: GetTrainingOverviewParams) => {
  return [`/reports/training`, ...(params ? [params] : [])] as const;
};

export const getGetTrainingOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainingOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainingOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainingOverview>>> = ({ signal }) =>
    getTrainingOverview(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainingOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrainingOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainingOverview>>
>;
export type GetTrainingOverviewQueryError = ErrorResponse | HTTPValidationError;

export function useGetTrainingOverview<
  TData = Awaited<ReturnType<typeof getTrainingOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetTrainingOverviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingOverview>>,
          TError,
          Awaited<ReturnType<typeof getTrainingOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTrainingOverview<
  TData = Awaited<ReturnType<typeof getTrainingOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingOverview>>,
          TError,
          Awaited<ReturnType<typeof getTrainingOverview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTrainingOverview<
  TData = Awaited<ReturnType<typeof getTrainingOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get training completion overview
 */

export function useGetTrainingOverview<
  TData = Awaited<ReturnType<typeof getTrainingOverview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTrainingOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetCoachingUsageUrl = (params?: GetCoachingUsageParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/coaching-usage?${stringifiedParams}`
    : `/reports/coaching-usage`;
};

/**
 * Get AI coaching usage report.
 *
 * Returns coaching usage metrics including:
 * - Summary statistics (sessions, messages, unique users)
 * - Usage breakdown by coaching role
 * - Usage breakdown by team member
 *
 * Managers see their direct reports' usage.
 * Directors and administrators see all usage.
 *
 * Requires manager, director, or administrator role.
 * @summary Get AI coaching usage report
 */
export const getCoachingUsage = async (
  params?: GetCoachingUsageParams,
  options?: RequestInit
): Promise<CoachingUsageReportResponse> => {
  return apiMutator<CoachingUsageReportResponse>(getGetCoachingUsageUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetCoachingUsageQueryKey = (params?: GetCoachingUsageParams) => {
  return [`/reports/coaching-usage`, ...(params ? [params] : [])] as const;
};

export const getGetCoachingUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachingUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCoachingUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoachingUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoachingUsage>>> = ({ signal }) =>
    getCoachingUsage(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoachingUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCoachingUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getCoachingUsage>>>;
export type GetCoachingUsageQueryError = ErrorResponse | HTTPValidationError;

export function useGetCoachingUsage<
  TData = Awaited<ReturnType<typeof getCoachingUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetCoachingUsageParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingUsage>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachingUsage>>,
          TError,
          Awaited<ReturnType<typeof getCoachingUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCoachingUsage<
  TData = Awaited<ReturnType<typeof getCoachingUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCoachingUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingUsage>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoachingUsage>>,
          TError,
          Awaited<ReturnType<typeof getCoachingUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCoachingUsage<
  TData = Awaited<ReturnType<typeof getCoachingUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCoachingUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get AI coaching usage report
 */

export function useGetCoachingUsage<
  TData = Awaited<ReturnType<typeof getCoachingUsage>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetCoachingUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoachingUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCoachingUsageQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetApprovalWorkflowMetricsUrl = (params?: GetApprovalWorkflowMetricsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/reports/approval-workflow?${stringifiedParams}`
    : `/reports/approval-workflow`;
};

/**
 * Get approval workflow metrics for the team.
 *
 * Returns metrics including:
 * - Pending creation count (goals, milestones, tasks awaiting approval)
 * - Pending completion count (task completions awaiting approval)
 *
 * Requires manager, director, or administrator role.
 * @summary Get approval workflow metrics
 */
export const getApprovalWorkflowMetrics = async (
  params?: GetApprovalWorkflowMetricsParams,
  options?: RequestInit
): Promise<ApprovalWorkflowResponse> => {
  return apiMutator<ApprovalWorkflowResponse>(getGetApprovalWorkflowMetricsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetApprovalWorkflowMetricsQueryKey = (
  params?: GetApprovalWorkflowMetricsParams
) => {
  return [`/reports/approval-workflow`, ...(params ? [params] : [])] as const;
};

export const getGetApprovalWorkflowMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetApprovalWorkflowMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApprovalWorkflowMetricsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>> = ({
    signal,
  }) => getApprovalWorkflowMetrics(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApprovalWorkflowMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>
>;
export type GetApprovalWorkflowMetricsQueryError = ErrorResponse | HTTPValidationError;

export function useGetApprovalWorkflowMetrics<
  TData = Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetApprovalWorkflowMetricsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
          TError,
          Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApprovalWorkflowMetrics<
  TData = Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetApprovalWorkflowMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
          TError,
          Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApprovalWorkflowMetrics<
  TData = Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetApprovalWorkflowMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get approval workflow metrics
 */

export function useGetApprovalWorkflowMetrics<
  TData = Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetApprovalWorkflowMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApprovalWorkflowMetrics>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApprovalWorkflowMetricsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListCategoriesUrl = () => {
  return `/resource-categories`;
};

/**
 * List all resource categories for dropdown selection.
 *
 * Returns categories sorted by display_order, with 'uncategorized' last.
 * This endpoint is cached for performance.
 * @summary List resource categories
 */
export const listCategories = async (
  options?: RequestInit
): Promise<ResourceCategoryListResponse> => {
  return apiMutator<ResourceCategoryListResponse>(getListCategoriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCategoriesQueryKey = () => {
  return [`/resource-categories`] as const;
};

export const getListCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({ signal }) =>
    listCategories({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>;
export type ListCategoriesQueryError = ErrorResponse;

export function useListCategories<
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategories>>,
          TError,
          Awaited<ReturnType<typeof listCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCategories<
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategories>>,
          TError,
          Awaited<ReturnType<typeof listCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCategories<
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List resource categories
 */

export function useListCategories<
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetUploadUrlUrl = () => {
  return `/resources/upload-url`;
};

/**
 * Generate a signed URL for direct file upload to GCS.
 *
 * Requires WRITE_RESOURCES permission.
 * @summary Generate upload URL
 */
export const getUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit
): Promise<UploadUrlResponse> => {
  return apiMutator<UploadUrlResponse>(getGetUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getGetUploadUrlMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUploadUrl>>,
    TError,
    { data: UploadUrlRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUploadUrl>>,
  TError,
  { data: UploadUrlRequest },
  TContext
> => {
  const mutationKey = ["getUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUploadUrl>>,
    { data: UploadUrlRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof getUploadUrl>>>;
export type GetUploadUrlMutationBody = UploadUrlRequest;
export type GetUploadUrlMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Generate upload URL
 */
export const useGetUploadUrl = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getUploadUrl>>,
      TError,
      { data: UploadUrlRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getUploadUrl>>,
  TError,
  { data: UploadUrlRequest },
  TContext
> => {
  return useMutation(getGetUploadUrlMutationOptions(options), queryClient);
};

export const getCreateResourceUrl = () => {
  return `/resources`;
};

/**
 * Create a new resource after file upload completes.
 *
 * Requires WRITE_RESOURCES permission.
 * Verifies the upload completed, moves file to permanent storage,
 * creates metadata, and logs the action.
 * @summary Create resource
 */
export const createResource = async (
  resourceCreate: ResourceCreate,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getCreateResourceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resourceCreate),
  });
};

export const getCreateResourceMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createResource>>,
    TError,
    { data: ResourceCreate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createResource>>,
  TError,
  { data: ResourceCreate },
  TContext
> => {
  const mutationKey = ["createResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createResource>>,
    { data: ResourceCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createResource(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateResourceMutationResult = NonNullable<Awaited<ReturnType<typeof createResource>>>;
export type CreateResourceMutationBody = ResourceCreate;
export type CreateResourceMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create resource
 */
export const useCreateResource = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createResource>>,
      TError,
      { data: ResourceCreate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createResource>>,
  TError,
  { data: ResourceCreate },
  TContext
> => {
  return useMutation(getCreateResourceMutationOptions(options), queryClient);
};

export const getListResourcesUrl = (params?: ListResourcesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/resources?${stringifiedParams}` : `/resources`;
};

/**
 * List resources with filtering and pagination.
 *
 * All authenticated users can view resources.
 * Only admins can include deleted resources.
 * Visibility filtering: organization (all), team (creator's team), private (creator only).
 * Department restrictions: Resources with department_restrictions only visible to
 * users in those departments (admins bypass this check).
 * @summary List resources
 */
export const listResources = async (
  params?: ListResourcesParams,
  options?: RequestInit
): Promise<PaginatedResources> => {
  return apiMutator<PaginatedResources>(getListResourcesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListResourcesQueryKey = (params?: ListResourcesParams) => {
  return [`/resources`, ...(params ? [params] : [])] as const;
};

export const getListResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListResourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListResourcesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listResources>>> = ({ signal }) =>
    listResources(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listResources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listResources>>>;
export type ListResourcesQueryError = ErrorResponse | HTTPValidationError;

export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ListResourcesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listResources>>,
          TError,
          Awaited<ReturnType<typeof listResources>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListResourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listResources>>,
          TError,
          Awaited<ReturnType<typeof listResources>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListResourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List resources
 */

export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListResourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListResourcesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateLinkResourceUrl = () => {
  return `/resources/link`;
};

/**
 * Create an external link resource (no file upload).
 *
 * Requires WRITE_RESOURCES permission.
 * @summary Create link resource
 */
export const createLinkResource = async (
  resourceLinkCreate: ResourceLinkCreate,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getCreateLinkResourceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resourceLinkCreate),
  });
};

export const getCreateLinkResourceMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLinkResource>>,
    TError,
    { data: ResourceLinkCreate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLinkResource>>,
  TError,
  { data: ResourceLinkCreate },
  TContext
> => {
  const mutationKey = ["createLinkResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLinkResource>>,
    { data: ResourceLinkCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createLinkResource(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLinkResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLinkResource>>
>;
export type CreateLinkResourceMutationBody = ResourceLinkCreate;
export type CreateLinkResourceMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create link resource
 */
export const useCreateLinkResource = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLinkResource>>,
      TError,
      { data: ResourceLinkCreate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLinkResource>>,
  TError,
  { data: ResourceLinkCreate },
  TContext
> => {
  return useMutation(getCreateLinkResourceMutationOptions(options), queryClient);
};

export const getGetResourceUrl = (resourceId: string) => {
  return `/resources/${resourceId}`;
};

/**
 * Get a single resource by ID.
 * @summary Get resource by ID
 */
export const getResource = async (
  resourceId: string,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getGetResourceUrl(resourceId), {
    ...options,
    method: "GET",
  });
};

export const getGetResourceQueryKey = (resourceId: string) => {
  return [`/resources/${resourceId}`] as const;
};

export const getGetResourceQueryOptions = <
  TData = Awaited<ReturnType<typeof getResource>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetResourceQueryKey(resourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getResource>>> = ({ signal }) =>
    getResource(resourceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: resourceId !== null && resourceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetResourceQueryResult = NonNullable<Awaited<ReturnType<typeof getResource>>>;
export type GetResourceQueryError = ErrorResponse | HTTPValidationError;

export function useGetResource<
  TData = Awaited<ReturnType<typeof getResource>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetResource<
  TData = Awaited<ReturnType<typeof getResource>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetResource<
  TData = Awaited<ReturnType<typeof getResource>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get resource by ID
 */

export function useGetResource<
  TData = Awaited<ReturnType<typeof getResource>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetResourceQueryOptions(resourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateResourceUrl = (resourceId: string) => {
  return `/resources/${resourceId}`;
};

/**
 * Update resource metadata.
 *
 * Requires WRITE_RESOURCES permission.
 * Managers can only update their own resources.
 * Admins can update any resource.
 * @summary Update resource metadata
 */
export const updateResource = async (
  resourceId: string,
  resourceUpdate: ResourceUpdate,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getUpdateResourceUrl(resourceId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resourceUpdate),
  });
};

export const getUpdateResourceMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateResource>>,
    TError,
    { resourceId: string; data: ResourceUpdate },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateResource>>,
  TError,
  { resourceId: string; data: ResourceUpdate },
  TContext
> => {
  const mutationKey = ["updateResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateResource>>,
    { resourceId: string; data: ResourceUpdate }
  > = (props) => {
    const { resourceId, data } = props ?? {};

    return updateResource(resourceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateResourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateResource>>>;
export type UpdateResourceMutationBody = ResourceUpdate;
export type UpdateResourceMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update resource metadata
 */
export const useUpdateResource = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateResource>>,
      TError,
      { resourceId: string; data: ResourceUpdate },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateResource>>,
  TError,
  { resourceId: string; data: ResourceUpdate },
  TContext
> => {
  return useMutation(getUpdateResourceMutationOptions(options), queryClient);
};

export const getDeleteResourceUrl = (resourceId: string) => {
  return `/resources/${resourceId}`;
};

/**
 * Soft delete a resource.
 *
 * Requires DELETE_RESOURCES permission.
 * Managers can only delete their own resources.
 * Admins can delete any resource.
 * @summary Delete resource
 */
export const deleteResource = async (
  resourceId: string,
  options?: RequestInit
): Promise<DeleteResponse> => {
  return apiMutator<DeleteResponse>(getDeleteResourceUrl(resourceId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteResourceMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteResource>>,
    TError,
    { resourceId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationKey = ["deleteResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteResource>>,
    { resourceId: string }
  > = (props) => {
    const { resourceId } = props ?? {};

    return deleteResource(resourceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteResourceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResource>>>;

export type DeleteResourceMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete resource
 */
export const useDeleteResource = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteResource>>,
      TError,
      { resourceId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  return useMutation(getDeleteResourceMutationOptions(options), queryClient);
};

export const getGetDownloadUrlUrl = (resourceId: string) => {
  return `/resources/${resourceId}/download`;
};

/**
 * Get a fresh download URL and increment view count.
 * @summary Get download URL
 */
export const getDownloadUrl = async (
  resourceId: string,
  options?: RequestInit
): Promise<DownloadUrlResponse> => {
  return apiMutator<DownloadUrlResponse>(getGetDownloadUrlUrl(resourceId), {
    ...options,
    method: "GET",
  });
};

export const getGetDownloadUrlQueryKey = (resourceId: string) => {
  return [`/resources/${resourceId}/download`] as const;
};

export const getGetDownloadUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadUrl>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDownloadUrlQueryKey(resourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDownloadUrl>>> = ({ signal }) =>
    getDownloadUrl(resourceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: resourceId !== null && resourceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDownloadUrl>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetDownloadUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getDownloadUrl>>>;
export type GetDownloadUrlQueryError = ErrorResponse | HTTPValidationError;

export function useGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadUrl>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDownloadUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadUrl>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDownloadUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadUrl>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get download URL
 */

export function useGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrl>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDownloadUrl>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDownloadUrlQueryOptions(resourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getReplaceResourceFileUrl = (resourceId: string) => {
  return `/resources/${resourceId}/replace`;
};

/**
 * Replace a resource's file with a new version.
 *
 * Requires WRITE_RESOURCES permission.
 * Creates a new version in the history.
 * @summary Replace resource file
 */
export const replaceResourceFile = async (
  resourceId: string,
  resourceReplaceRequest: ResourceReplaceRequest,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getReplaceResourceFileUrl(resourceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resourceReplaceRequest),
  });
};

export const getReplaceResourceFileMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceResourceFile>>,
    TError,
    { resourceId: string; data: ResourceReplaceRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceResourceFile>>,
  TError,
  { resourceId: string; data: ResourceReplaceRequest },
  TContext
> => {
  const mutationKey = ["replaceResourceFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceResourceFile>>,
    { resourceId: string; data: ResourceReplaceRequest }
  > = (props) => {
    const { resourceId, data } = props ?? {};

    return replaceResourceFile(resourceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceResourceFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceResourceFile>>
>;
export type ReplaceResourceFileMutationBody = ResourceReplaceRequest;
export type ReplaceResourceFileMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Replace resource file
 */
export const useReplaceResourceFile = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof replaceResourceFile>>,
      TError,
      { resourceId: string; data: ResourceReplaceRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof replaceResourceFile>>,
  TError,
  { resourceId: string; data: ResourceReplaceRequest },
  TContext
> => {
  return useMutation(getReplaceResourceFileMutationOptions(options), queryClient);
};

export const getRestoreResourceUrl = (resourceId: string) => {
  return `/resources/${resourceId}/restore`;
};

/**
 * Restore a soft-deleted resource.
 *
 * Requires DELETE_RESOURCES permission with ALL scope.
 * @summary Restore deleted resource
 */
export const restoreResource = async (
  resourceId: string,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getRestoreResourceUrl(resourceId), {
    ...options,
    method: "POST",
  });
};

export const getRestoreResourceMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreResource>>,
    TError,
    { resourceId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationKey = ["restoreResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreResource>>,
    { resourceId: string }
  > = (props) => {
    const { resourceId } = props ?? {};

    return restoreResource(resourceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreResource>>
>;

export type RestoreResourceMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Restore deleted resource
 */
export const useRestoreResource = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreResource>>,
      TError,
      { resourceId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  return useMutation(getRestoreResourceMutationOptions(options), queryClient);
};

export const getPermanentDeleteResourceUrl = (resourceId: string) => {
  return `/resources/${resourceId}/permanent`;
};

/**
 * Permanently delete a resource and all its files.
 *
 * Requires DELETE_RESOURCES permission with ALL scope.
 * This action cannot be undone.
 * @summary Permanently delete resource
 */
export const permanentDeleteResource = async (
  resourceId: string,
  options?: RequestInit
): Promise<DeleteResponse> => {
  return apiMutator<DeleteResponse>(getPermanentDeleteResourceUrl(resourceId), {
    ...options,
    method: "DELETE",
  });
};

export const getPermanentDeleteResourceMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof permanentDeleteResource>>,
    TError,
    { resourceId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof permanentDeleteResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationKey = ["permanentDeleteResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof permanentDeleteResource>>,
    { resourceId: string }
  > = (props) => {
    const { resourceId } = props ?? {};

    return permanentDeleteResource(resourceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PermanentDeleteResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof permanentDeleteResource>>
>;

export type PermanentDeleteResourceMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Permanently delete resource
 */
export const usePermanentDeleteResource = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof permanentDeleteResource>>,
      TError,
      { resourceId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof permanentDeleteResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  return useMutation(getPermanentDeleteResourceMutationOptions(options), queryClient);
};

export const getUpdateResourceVisibilityUrl = (resourceId: string) => {
  return `/resources/${resourceId}/visibility`;
};

/**
 * Update resource visibility and/or department restrictions.
 *
 * Requires WRITE_RESOURCES permission.
 * Managers can only update their own resources.
 * Admins can update any resource.
 * @summary Update resource visibility
 */
export const updateResourceVisibility = async (
  resourceId: string,
  updateVisibilityRequest: UpdateVisibilityRequest,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getUpdateResourceVisibilityUrl(resourceId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVisibilityRequest),
  });
};

export const getUpdateResourceVisibilityMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateResourceVisibility>>,
    TError,
    { resourceId: string; data: UpdateVisibilityRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateResourceVisibility>>,
  TError,
  { resourceId: string; data: UpdateVisibilityRequest },
  TContext
> => {
  const mutationKey = ["updateResourceVisibility"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateResourceVisibility>>,
    { resourceId: string; data: UpdateVisibilityRequest }
  > = (props) => {
    const { resourceId, data } = props ?? {};

    return updateResourceVisibility(resourceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateResourceVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateResourceVisibility>>
>;
export type UpdateResourceVisibilityMutationBody = UpdateVisibilityRequest;
export type UpdateResourceVisibilityMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update resource visibility
 */
export const useUpdateResourceVisibility = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateResourceVisibility>>,
      TError,
      { resourceId: string; data: UpdateVisibilityRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateResourceVisibility>>,
  TError,
  { resourceId: string; data: UpdateVisibilityRequest },
  TContext
> => {
  return useMutation(getUpdateResourceVisibilityMutationOptions(options), queryClient);
};

export const getGetResourceCoachingRolesUrl = (resourceId: string) => {
  return `/resources/${resourceId}/coaching-roles`;
};

/**
 * Get coaching roles associated with a resource.
 *
 * Returns a list of coaching roles that have this resource in their resource_ids.
 * @summary Get associated coaching roles
 */
export const getResourceCoachingRoles = async (
  resourceId: string,
  options?: RequestInit
): Promise<ResourceCoachingRolesResponse> => {
  return apiMutator<ResourceCoachingRolesResponse>(getGetResourceCoachingRolesUrl(resourceId), {
    ...options,
    method: "GET",
  });
};

export const getGetResourceCoachingRolesQueryKey = (resourceId: string) => {
  return [`/resources/${resourceId}/coaching-roles`] as const;
};

export const getGetResourceCoachingRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getResourceCoachingRoles>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getResourceCoachingRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetResourceCoachingRolesQueryKey(resourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceCoachingRoles>>> = ({
    signal,
  }) => getResourceCoachingRoles(resourceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: resourceId !== null && resourceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getResourceCoachingRoles>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetResourceCoachingRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getResourceCoachingRoles>>
>;
export type GetResourceCoachingRolesQueryError = ErrorResponse | HTTPValidationError;

export function useGetResourceCoachingRoles<
  TData = Awaited<ReturnType<typeof getResourceCoachingRoles>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getResourceCoachingRoles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceCoachingRoles>>,
          TError,
          Awaited<ReturnType<typeof getResourceCoachingRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetResourceCoachingRoles<
  TData = Awaited<ReturnType<typeof getResourceCoachingRoles>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getResourceCoachingRoles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceCoachingRoles>>,
          TError,
          Awaited<ReturnType<typeof getResourceCoachingRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetResourceCoachingRoles<
  TData = Awaited<ReturnType<typeof getResourceCoachingRoles>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getResourceCoachingRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get associated coaching roles
 */

export function useGetResourceCoachingRoles<
  TData = Awaited<ReturnType<typeof getResourceCoachingRoles>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getResourceCoachingRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetResourceCoachingRolesQueryOptions(resourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateResourceCoachingRolesUrl = (resourceId: string) => {
  return `/resources/${resourceId}/coaching-roles`;
};

/**
 * Update which coaching roles are associated with a resource.
 *
 * Requires WRITE_RESOURCES permission with ALL scope.
 * This updates the resource_ids field on the specified coaching roles.
 * @summary Update associated coaching roles
 */
export const updateResourceCoachingRoles = async (
  resourceId: string,
  updateResourceCoachingRolesRequest: UpdateResourceCoachingRolesRequest,
  options?: RequestInit
): Promise<ResourceCoachingRolesResponse> => {
  return apiMutator<ResourceCoachingRolesResponse>(getUpdateResourceCoachingRolesUrl(resourceId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateResourceCoachingRolesRequest),
  });
};

export const getUpdateResourceCoachingRolesMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateResourceCoachingRoles>>,
    TError,
    { resourceId: string; data: UpdateResourceCoachingRolesRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateResourceCoachingRoles>>,
  TError,
  { resourceId: string; data: UpdateResourceCoachingRolesRequest },
  TContext
> => {
  const mutationKey = ["updateResourceCoachingRoles"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateResourceCoachingRoles>>,
    { resourceId: string; data: UpdateResourceCoachingRolesRequest }
  > = (props) => {
    const { resourceId, data } = props ?? {};

    return updateResourceCoachingRoles(resourceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateResourceCoachingRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateResourceCoachingRoles>>
>;
export type UpdateResourceCoachingRolesMutationBody = UpdateResourceCoachingRolesRequest;
export type UpdateResourceCoachingRolesMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update associated coaching roles
 */
export const useUpdateResourceCoachingRoles = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateResourceCoachingRoles>>,
      TError,
      { resourceId: string; data: UpdateResourceCoachingRolesRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateResourceCoachingRoles>>,
  TError,
  { resourceId: string; data: UpdateResourceCoachingRolesRequest },
  TContext
> => {
  return useMutation(getUpdateResourceCoachingRolesMutationOptions(options), queryClient);
};

export const getGetVersionHistoryUrl = (resourceId: string) => {
  return `/resources/${resourceId}/versions`;
};

/**
 * Get version history for a resource.
 * @summary Get version history
 */
export const getVersionHistory = async (
  resourceId: string,
  options?: RequestInit
): Promise<VersionHistoryResponse> => {
  return apiMutator<VersionHistoryResponse>(getGetVersionHistoryUrl(resourceId), {
    ...options,
    method: "GET",
  });
};

export const getGetVersionHistoryQueryKey = (resourceId: string) => {
  return [`/resources/${resourceId}/versions`] as const;
};

export const getGetVersionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getVersionHistory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVersionHistoryQueryKey(resourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersionHistory>>> = ({ signal }) =>
    getVersionHistory(resourceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: resourceId !== null && resourceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetVersionHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVersionHistory>>
>;
export type GetVersionHistoryQueryError = ErrorResponse | HTTPValidationError;

export function useGetVersionHistory<
  TData = Awaited<ReturnType<typeof getVersionHistory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersionHistory>>,
          TError,
          Awaited<ReturnType<typeof getVersionHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetVersionHistory<
  TData = Awaited<ReturnType<typeof getVersionHistory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersionHistory>>,
          TError,
          Awaited<ReturnType<typeof getVersionHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetVersionHistory<
  TData = Awaited<ReturnType<typeof getVersionHistory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get version history
 */

export function useGetVersionHistory<
  TData = Awaited<ReturnType<typeof getVersionHistory>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetVersionHistoryQueryOptions(resourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getRestoreVersionUrl = (resourceId: string) => {
  return `/resources/${resourceId}/restore-version`;
};

/**
 * Restore a previous version as the current version.
 *
 * Requires WRITE_RESOURCES permission.
 * This creates a new version (copy) from the specified old version.
 * @summary Restore previous version
 */
export const restoreVersion = async (
  resourceId: string,
  restoreVersionRequest: RestoreVersionRequest,
  options?: RequestInit
): Promise<ResourceResponse> => {
  return apiMutator<ResourceResponse>(getRestoreVersionUrl(resourceId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(restoreVersionRequest),
  });
};

export const getRestoreVersionMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreVersion>>,
    TError,
    { resourceId: string; data: RestoreVersionRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreVersion>>,
  TError,
  { resourceId: string; data: RestoreVersionRequest },
  TContext
> => {
  const mutationKey = ["restoreVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreVersion>>,
    { resourceId: string; data: RestoreVersionRequest }
  > = (props) => {
    const { resourceId, data } = props ?? {};

    return restoreVersion(resourceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreVersionMutationResult = NonNullable<Awaited<ReturnType<typeof restoreVersion>>>;
export type RestoreVersionMutationBody = RestoreVersionRequest;
export type RestoreVersionMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Restore previous version
 */
export const useRestoreVersion = <TError = ErrorResponse | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreVersion>>,
      TError,
      { resourceId: string; data: RestoreVersionRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreVersion>>,
  TError,
  { resourceId: string; data: RestoreVersionRequest },
  TContext
> => {
  return useMutation(getRestoreVersionMutationOptions(options), queryClient);
};

export const getGetRagStatusUrl = (resourceId: string) => {
  return `/resources/${resourceId}/rag-status`;
};

/**
 * Get RAG indexing status for a resource.
 * @summary Get RAG indexing status
 */
export const getRagStatus = async (
  resourceId: string,
  options?: RequestInit
): Promise<RAGStatusResponse> => {
  return apiMutator<RAGStatusResponse>(getGetRagStatusUrl(resourceId), {
    ...options,
    method: "GET",
  });
};

export const getGetRagStatusQueryKey = (resourceId: string) => {
  return [`/resources/${resourceId}/rag-status`] as const;
};

export const getGetRagStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getRagStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRagStatusQueryKey(resourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRagStatus>>> = ({ signal }) =>
    getRagStatus(resourceId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: resourceId !== null && resourceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRagStatus>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetRagStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getRagStatus>>>;
export type GetRagStatusQueryError = ErrorResponse | HTTPValidationError;

export function useGetRagStatus<
  TData = Awaited<ReturnType<typeof getRagStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRagStatus>>,
          TError,
          Awaited<ReturnType<typeof getRagStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRagStatus<
  TData = Awaited<ReturnType<typeof getRagStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRagStatus>>,
          TError,
          Awaited<ReturnType<typeof getRagStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRagStatus<
  TData = Awaited<ReturnType<typeof getRagStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get RAG indexing status
 */

export function useGetRagStatus<
  TData = Awaited<ReturnType<typeof getRagStatus>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  resourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRagStatusQueryOptions(resourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getReindexResourceUrl = (resourceId: string) => {
  return `/resources/${resourceId}/reindex`;
};

/**
 * Manually trigger RAG re-indexing for a resource.
 *
 * Requires WRITE_RESOURCES permission with ALL scope.
 * Useful for retrying failed indexing or forcing re-index.
 * @summary Trigger RAG re-indexing
 */
export const reindexResource = async (
  resourceId: string,
  options?: RequestInit
): Promise<RAGStatusResponse> => {
  return apiMutator<RAGStatusResponse>(getReindexResourceUrl(resourceId), {
    ...options,
    method: "POST",
  });
};

export const getReindexResourceMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reindexResource>>,
    TError,
    { resourceId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reindexResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  const mutationKey = ["reindexResource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reindexResource>>,
    { resourceId: string }
  > = (props) => {
    const { resourceId } = props ?? {};

    return reindexResource(resourceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReindexResourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof reindexResource>>
>;

export type ReindexResourceMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Trigger RAG re-indexing
 */
export const useReindexResource = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reindexResource>>,
      TError,
      { resourceId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reindexResource>>,
  TError,
  { resourceId: string },
  TContext
> => {
  return useMutation(getReindexResourceMutationOptions(options), queryClient);
};

export const getGetRagStatsUrl = () => {
  return `/resources/admin/rag-stats`;
};

/**
 * Get RAG system statistics.
 *
 * Requires READ_RESOURCES permission with ALL scope.
 * Returns counts of indexed resources and chunks.
 * @summary Get RAG system statistics
 */
export const getRagStats = async (options?: RequestInit): Promise<RAGStatsResponse> => {
  return apiMutator<RAGStatsResponse>(getGetRagStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRagStatsQueryKey = () => {
  return [`/resources/admin/rag-stats`] as const;
};

export const getGetRagStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRagStats>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStats>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRagStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRagStats>>> = ({ signal }) =>
    getRagStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRagStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRagStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getRagStats>>>;
export type GetRagStatsQueryError = ErrorResponse;

export function useGetRagStats<
  TData = Awaited<ReturnType<typeof getRagStats>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRagStats>>,
          TError,
          Awaited<ReturnType<typeof getRagStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRagStats<
  TData = Awaited<ReturnType<typeof getRagStats>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRagStats>>,
          TError,
          Awaited<ReturnType<typeof getRagStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRagStats<
  TData = Awaited<ReturnType<typeof getRagStats>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStats>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get RAG system statistics
 */

export function useGetRagStats<
  TData = Awaited<ReturnType<typeof getRagStats>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRagStats>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRagStatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSearchUrl = (params: SearchParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/search?${stringifiedParams}` : `/search`;
};

/**
 * Search across all content types.
 *
 * Returns categorized results from goals, conversations, transcripts,
 * resources, and enrollments based on user permissions.
 *
 * When SEARCH_USE_SEMANTIC is enabled, uses vector-based semantic search
 * for better relevance. Otherwise, falls back to prefix-query search.
 *
 * Args:
 *     q: Search query string (minimum 2 characters).
 *     limit: Maximum results per category (1-10, default 3).
 *     types: Optional comma-separated list of result types to include.
 *     current_user: The authenticated user.
 *     search_service: Prefix-query search service instance.
 *     semantic_search_service: Semantic search service instance.
 *
 * Returns:
 *     SearchResponse with categorized results.
 *
 * Raises:
 *     HTTPException: 400 if query is invalid.
 * @summary Search across all content types
 */
export const search = async (
  params: SearchParams,
  options?: RequestInit
): Promise<SearchResponse> => {
  return apiMutator<SearchResponse>(getSearchUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchQueryKey = (params?: SearchParams) => {
  return [`/search`, ...(params ? [params] : [])] as const;
};

export const getSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof search>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof search>>> = ({ signal }) =>
    search(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof search>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchQueryResult = NonNullable<Awaited<ReturnType<typeof search>>>;
export type SearchQueryError = ErrorResponse | HTTPValidationError;

export function useSearch<
  TData = Awaited<ReturnType<typeof search>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof search>>,
          TError,
          Awaited<ReturnType<typeof search>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearch<
  TData = Awaited<ReturnType<typeof search>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof search>>,
          TError,
          Awaited<ReturnType<typeof search>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearch<
  TData = Awaited<ReturnType<typeof search>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search across all content types
 */

export function useSearch<
  TData = Awaited<ReturnType<typeof search>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: SearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetSessionSettingsUrl = () => {
  return `/session/settings`;
};

/**
 * Get session settings for inactivity timeout configuration.
 *
 * Returns the current inactivity timeout settings.
 * Available to all authenticated users.
 * @summary Get session settings
 */
export const getSessionSettings = async (
  options?: RequestInit
): Promise<SessionSettingsResponse> => {
  return apiMutator<SessionSettingsResponse>(getGetSessionSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSessionSettingsQueryKey = () => {
  return [`/session/settings`] as const;
};

export const getGetSessionSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSessionSettings>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionSettings>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSessionSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionSettings>>> = ({ signal }) =>
    getSessionSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSessionSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSessionSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSessionSettings>>
>;
export type GetSessionSettingsQueryError = ErrorResponse;

export function useGetSessionSettings<
  TData = Awaited<ReturnType<typeof getSessionSettings>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionSettings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionSettings>>,
          TError,
          Awaited<ReturnType<typeof getSessionSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSessionSettings<
  TData = Awaited<ReturnType<typeof getSessionSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSessionSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionSettings>>,
          TError,
          Awaited<ReturnType<typeof getSessionSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSessionSettings<
  TData = Awaited<ReturnType<typeof getSessionSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionSettings>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get session settings
 */

export function useGetSessionSettings<
  TData = Awaited<ReturnType<typeof getSessionSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionSettings>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSessionSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getStartThinkificConnectionUrl = () => {
  return `/integrations/thinkific/connect`;
};

/**
 * Start Thinkific OAuth connection flow.
 *
 * Requires WRITE_INTEGRATIONS permission.
 * Returns an authorization URL that the admin should be redirected to.
 * @summary Start Thinkific OAuth connection flow
 */
export const startThinkificConnection = async (
  thinkificConnectRequest: ThinkificConnectRequest,
  options?: RequestInit
): Promise<ThinkificOAuthStartResponse> => {
  return apiMutator<ThinkificOAuthStartResponse>(getStartThinkificConnectionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(thinkificConnectRequest),
  });
};

export const getStartThinkificConnectionMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startThinkificConnection>>,
    TError,
    { data: ThinkificConnectRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startThinkificConnection>>,
  TError,
  { data: ThinkificConnectRequest },
  TContext
> => {
  const mutationKey = ["startThinkificConnection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startThinkificConnection>>,
    { data: ThinkificConnectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return startThinkificConnection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartThinkificConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof startThinkificConnection>>
>;
export type StartThinkificConnectionMutationBody = ThinkificConnectRequest;
export type StartThinkificConnectionMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Start Thinkific OAuth connection flow
 */
export const useStartThinkificConnection = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startThinkificConnection>>,
      TError,
      { data: ThinkificConnectRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof startThinkificConnection>>,
  TError,
  { data: ThinkificConnectRequest },
  TContext
> => {
  return useMutation(getStartThinkificConnectionMutationOptions(options), queryClient);
};

export const getCompleteThinkificConnectionUrl = () => {
  return `/integrations/thinkific/callback`;
};

/**
 * Complete Thinkific OAuth connection with authorization code.
 *
 * Requires WRITE_INTEGRATIONS permission.
 * Called by frontend after OAuth redirect with the code and state.
 * @summary Complete Thinkific OAuth connection
 */
export const completeThinkificConnection = async (
  thinkificOAuthCallbackRequest: ThinkificOAuthCallbackRequest,
  options?: RequestInit
): Promise<ThinkificStatusResponse> => {
  return apiMutator<ThinkificStatusResponse>(getCompleteThinkificConnectionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(thinkificOAuthCallbackRequest),
  });
};

export const getCompleteThinkificConnectionMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeThinkificConnection>>,
    TError,
    { data: ThinkificOAuthCallbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeThinkificConnection>>,
  TError,
  { data: ThinkificOAuthCallbackRequest },
  TContext
> => {
  const mutationKey = ["completeThinkificConnection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeThinkificConnection>>,
    { data: ThinkificOAuthCallbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return completeThinkificConnection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteThinkificConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeThinkificConnection>>
>;
export type CompleteThinkificConnectionMutationBody = ThinkificOAuthCallbackRequest;
export type CompleteThinkificConnectionMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Complete Thinkific OAuth connection
 */
export const useCompleteThinkificConnection = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeThinkificConnection>>,
      TError,
      { data: ThinkificOAuthCallbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof completeThinkificConnection>>,
  TError,
  { data: ThinkificOAuthCallbackRequest },
  TContext
> => {
  return useMutation(getCompleteThinkificConnectionMutationOptions(options), queryClient);
};

export const getConnectThinkificApiKeyUrl = () => {
  return `/integrations/thinkific/connect-api-key`;
};

/**
 * Connect Thinkific using API key authentication.
 *
 * Requires WRITE_INTEGRATIONS permission.
 * Alternative to OAuth for users who are not the Site Owner.
 * @summary Connect Thinkific using API key
 */
export const connectThinkificApiKey = async (
  thinkificApiKeyConnectRequest: ThinkificApiKeyConnectRequest,
  options?: RequestInit
): Promise<ThinkificStatusResponse> => {
  return apiMutator<ThinkificStatusResponse>(getConnectThinkificApiKeyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(thinkificApiKeyConnectRequest),
  });
};

export const getConnectThinkificApiKeyMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectThinkificApiKey>>,
    TError,
    { data: ThinkificApiKeyConnectRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectThinkificApiKey>>,
  TError,
  { data: ThinkificApiKeyConnectRequest },
  TContext
> => {
  const mutationKey = ["connectThinkificApiKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectThinkificApiKey>>,
    { data: ThinkificApiKeyConnectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return connectThinkificApiKey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectThinkificApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectThinkificApiKey>>
>;
export type ConnectThinkificApiKeyMutationBody = ThinkificApiKeyConnectRequest;
export type ConnectThinkificApiKeyMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Connect Thinkific using API key
 */
export const useConnectThinkificApiKey = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof connectThinkificApiKey>>,
      TError,
      { data: ThinkificApiKeyConnectRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof connectThinkificApiKey>>,
  TError,
  { data: ThinkificApiKeyConnectRequest },
  TContext
> => {
  return useMutation(getConnectThinkificApiKeyMutationOptions(options), queryClient);
};

export const getDisconnectThinkificUrl = () => {
  return `/integrations/thinkific/disconnect`;
};

/**
 * Disconnect Thinkific by removing stored credentials.
 *
 * Requires WRITE_INTEGRATIONS permission.
 * @summary Disconnect Thinkific integration
 */
export const disconnectThinkific = async (
  options?: RequestInit
): Promise<ThinkificStatusResponse> => {
  return apiMutator<ThinkificStatusResponse>(getDisconnectThinkificUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectThinkificMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectThinkific>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof disconnectThinkific>>, TError, void, TContext> => {
  const mutationKey = ["disconnectThinkific"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectThinkific>>,
    void
  > = () => {
    return disconnectThinkific(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectThinkificMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectThinkific>>
>;

export type DisconnectThinkificMutationError = ErrorResponse;

/**
 * @summary Disconnect Thinkific integration
 */
export const useDisconnectThinkific = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disconnectThinkific>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof disconnectThinkific>>, TError, void, TContext> => {
  return useMutation(getDisconnectThinkificMutationOptions(options), queryClient);
};

export const getGetThinkificStatusUrl = () => {
  return `/integrations/thinkific/status`;
};

/**
 * Get current Thinkific connection status.
 *
 * Requires READ_INTEGRATIONS permission with ALL scope.
 * @summary Get Thinkific connection status
 */
export const getThinkificStatus = async (
  options?: RequestInit
): Promise<ThinkificStatusResponse> => {
  return apiMutator<ThinkificStatusResponse>(getGetThinkificStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetThinkificStatusQueryKey = () => {
  return [`/integrations/thinkific/status`] as const;
};

export const getGetThinkificStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getThinkificStatus>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getThinkificStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetThinkificStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getThinkificStatus>>> = ({ signal }) =>
    getThinkificStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getThinkificStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetThinkificStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getThinkificStatus>>
>;
export type GetThinkificStatusQueryError = ErrorResponse;

export function useGetThinkificStatus<
  TData = Awaited<ReturnType<typeof getThinkificStatus>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getThinkificStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThinkificStatus>>,
          TError,
          Awaited<ReturnType<typeof getThinkificStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetThinkificStatus<
  TData = Awaited<ReturnType<typeof getThinkificStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThinkificStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThinkificStatus>>,
          TError,
          Awaited<ReturnType<typeof getThinkificStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetThinkificStatus<
  TData = Awaited<ReturnType<typeof getThinkificStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getThinkificStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Thinkific connection status
 */

export function useGetThinkificStatus<
  TData = Awaited<ReturnType<typeof getThinkificStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getThinkificStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetThinkificStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateThinkificSettingsUrl = () => {
  return `/integrations/thinkific/settings`;
};

/**
 * Update Thinkific settings (bundle filter).
 *
 * Requires WRITE_INTEGRATIONS permission.
 * @summary Update Thinkific settings
 */
export const updateThinkificSettings = async (
  thinkificSettingsUpdateRequest: ThinkificSettingsUpdateRequest,
  options?: RequestInit
): Promise<ThinkificStatusResponse> => {
  return apiMutator<ThinkificStatusResponse>(getUpdateThinkificSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(thinkificSettingsUpdateRequest),
  });
};

export const getUpdateThinkificSettingsMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateThinkificSettings>>,
    TError,
    { data: ThinkificSettingsUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateThinkificSettings>>,
  TError,
  { data: ThinkificSettingsUpdateRequest },
  TContext
> => {
  const mutationKey = ["updateThinkificSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateThinkificSettings>>,
    { data: ThinkificSettingsUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateThinkificSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateThinkificSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateThinkificSettings>>
>;
export type UpdateThinkificSettingsMutationBody = ThinkificSettingsUpdateRequest;
export type UpdateThinkificSettingsMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Update Thinkific settings
 */
export const useUpdateThinkificSettings = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateThinkificSettings>>,
      TError,
      { data: ThinkificSettingsUpdateRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateThinkificSettings>>,
  TError,
  { data: ThinkificSettingsUpdateRequest },
  TContext
> => {
  return useMutation(getUpdateThinkificSettingsMutationOptions(options), queryClient);
};

export const getListThinkificBundlesUrl = () => {
  return `/integrations/thinkific/bundles`;
};

/**
 * List all available bundles from the connected Thinkific account.
 *
 * Requires WRITE_INTEGRATIONS permission.
 * @summary List available Thinkific bundles
 */
export const listThinkificBundles = async (
  options?: RequestInit
): Promise<ThinkificBundleListResponse> => {
  return apiMutator<ThinkificBundleListResponse>(getListThinkificBundlesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListThinkificBundlesQueryKey = () => {
  return [`/integrations/thinkific/bundles`] as const;
};

export const getListThinkificBundlesQueryOptions = <
  TData = Awaited<ReturnType<typeof listThinkificBundles>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listThinkificBundles>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListThinkificBundlesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listThinkificBundles>>> = ({ signal }) =>
    listThinkificBundles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listThinkificBundles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThinkificBundlesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listThinkificBundles>>
>;
export type ListThinkificBundlesQueryError = ErrorResponse;

export function useListThinkificBundles<
  TData = Awaited<ReturnType<typeof listThinkificBundles>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThinkificBundles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThinkificBundles>>,
          TError,
          Awaited<ReturnType<typeof listThinkificBundles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListThinkificBundles<
  TData = Awaited<ReturnType<typeof listThinkificBundles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThinkificBundles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThinkificBundles>>,
          TError,
          Awaited<ReturnType<typeof listThinkificBundles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListThinkificBundles<
  TData = Awaited<ReturnType<typeof listThinkificBundles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThinkificBundles>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List available Thinkific bundles
 */

export function useListThinkificBundles<
  TData = Awaited<ReturnType<typeof listThinkificBundles>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThinkificBundles>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListThinkificBundlesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSyncThinkificUrl = () => {
  return `/integrations/thinkific/sync`;
};

/**
 * Trigger manual sync of courses and enrollments from Thinkific.
 *
 * Requires WRITE_INTEGRATIONS permission.
 * @summary Trigger Thinkific course and enrollment sync
 */
export const syncThinkific = async (options?: RequestInit): Promise<ThinkificSyncResponse> => {
  return apiMutator<ThinkificSyncResponse>(getSyncThinkificUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSyncThinkificMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof syncThinkific>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof syncThinkific>>, TError, void, TContext> => {
  const mutationKey = ["syncThinkific"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncThinkific>>, void> = () => {
    return syncThinkific(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncThinkificMutationResult = NonNullable<Awaited<ReturnType<typeof syncThinkific>>>;

export type SyncThinkificMutationError = ErrorResponse;

/**
 * @summary Trigger Thinkific course and enrollment sync
 */
export const useSyncThinkific = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof syncThinkific>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof syncThinkific>>, TError, void, TContext> => {
  return useMutation(getSyncThinkificMutationOptions(options), queryClient);
};

export const getGetThinkificCoursesUrl = () => {
  return `/integrations/thinkific/courses`;
};

/**
 * Get list of available courses from Thinkific.
 *
 * Available to all authenticated users.
 * @summary List available Thinkific courses
 */
export const getThinkificCourses = async (
  options?: RequestInit
): Promise<ThinkificCourseListResponse> => {
  return apiMutator<ThinkificCourseListResponse>(getGetThinkificCoursesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetThinkificCoursesQueryKey = () => {
  return [`/integrations/thinkific/courses`] as const;
};

export const getGetThinkificCoursesQueryOptions = <
  TData = Awaited<ReturnType<typeof getThinkificCourses>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getThinkificCourses>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetThinkificCoursesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getThinkificCourses>>> = ({ signal }) =>
    getThinkificCourses({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getThinkificCourses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetThinkificCoursesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getThinkificCourses>>
>;
export type GetThinkificCoursesQueryError = ErrorResponse;

export function useGetThinkificCourses<
  TData = Awaited<ReturnType<typeof getThinkificCourses>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThinkificCourses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThinkificCourses>>,
          TError,
          Awaited<ReturnType<typeof getThinkificCourses>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetThinkificCourses<
  TData = Awaited<ReturnType<typeof getThinkificCourses>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThinkificCourses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThinkificCourses>>,
          TError,
          Awaited<ReturnType<typeof getThinkificCourses>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetThinkificCourses<
  TData = Awaited<ReturnType<typeof getThinkificCourses>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThinkificCourses>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List available Thinkific courses
 */

export function useGetThinkificCourses<
  TData = Awaited<ReturnType<typeof getThinkificCourses>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThinkificCourses>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetThinkificCoursesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getVerifyThinkificTasksUrl = () => {
  return `/integrations/thinkific/verify-tasks`;
};

/**
 * Manually trigger task verification against Thinkific enrollments.
 *
 * Requires WRITE_INTEGRATIONS permission with ALL scope.
 * This verifies all api-linked tasks against completed Thinkific courses
 * and auto-completes tasks where the linked course is 100% complete.
 * @summary Verify tasks against Thinkific enrollments
 */
export const verifyThinkificTasks = async (
  options?: RequestInit
): Promise<ThinkificVerifyTasksResponse> => {
  return apiMutator<ThinkificVerifyTasksResponse>(getVerifyThinkificTasksUrl(), {
    ...options,
    method: "POST",
  });
};

export const getVerifyThinkificTasksMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyThinkificTasks>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyThinkificTasks>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["verifyThinkificTasks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyThinkificTasks>>,
    void
  > = () => {
    return verifyThinkificTasks(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyThinkificTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyThinkificTasks>>
>;

export type VerifyThinkificTasksMutationError = ErrorResponse;

/**
 * @summary Verify tasks against Thinkific enrollments
 */
export const useVerifyThinkificTasks = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyThinkificTasks>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof verifyThinkificTasks>>, TError, void, TContext> => {
  return useMutation(getVerifyThinkificTasksMutationOptions(options), queryClient);
};

export const getGetWebhookConfigUrl = () => {
  return `/integrations/thinkific/webhook-config`;
};

/**
 * Get Thinkific webhook configuration.
 *
 * Requires READ_INTEGRATIONS permission with ALL scope.
 * Returns the webhook URL and secret status (without exposing the full secret).
 * @summary Get webhook configuration
 */
export const getWebhookConfig = async (options?: RequestInit): Promise<WebhookConfigResponse> => {
  return apiMutator<WebhookConfigResponse>(getGetWebhookConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWebhookConfigQueryKey = () => {
  return [`/integrations/thinkific/webhook-config`] as const;
};

export const getGetWebhookConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookConfig>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookConfig>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebhookConfig>>> = ({ signal }) =>
    getWebhookConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWebhookConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getWebhookConfig>>>;
export type GetWebhookConfigQueryError = ErrorResponse;

export function useGetWebhookConfig<
  TData = Awaited<ReturnType<typeof getWebhookConfig>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookConfig>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookConfig>>,
          TError,
          Awaited<ReturnType<typeof getWebhookConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWebhookConfig<
  TData = Awaited<ReturnType<typeof getWebhookConfig>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookConfig>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookConfig>>,
          TError,
          Awaited<ReturnType<typeof getWebhookConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWebhookConfig<
  TData = Awaited<ReturnType<typeof getWebhookConfig>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookConfig>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get webhook configuration
 */

export function useGetWebhookConfig<
  TData = Awaited<ReturnType<typeof getWebhookConfig>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookConfig>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetWebhookConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getRegenerateWebhookSecretUrl = () => {
  return `/integrations/thinkific/webhook-config/regenerate-secret`;
};

/**
 * Generate or regenerate the Thinkific webhook secret.
 *
 * Requires WRITE_INTEGRATIONS permission with ALL scope.
 * Returns the new secret (shown only once) and the webhook URL to configure in Thinkific.
 * @summary Generate or regenerate webhook secret
 */
export const regenerateWebhookSecret = async (
  options?: RequestInit
): Promise<WebhookSecretResponse> => {
  return apiMutator<WebhookSecretResponse>(getRegenerateWebhookSecretUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRegenerateWebhookSecretMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateWebhookSecret>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateWebhookSecret>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["regenerateWebhookSecret"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateWebhookSecret>>,
    void
  > = () => {
    return regenerateWebhookSecret(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateWebhookSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateWebhookSecret>>
>;

export type RegenerateWebhookSecretMutationError = ErrorResponse;

/**
 * @summary Generate or regenerate webhook secret
 */
export const useRegenerateWebhookSecret = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateWebhookSecret>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateWebhookSecret>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRegenerateWebhookSecretMutationOptions(options), queryClient);
};

export const getGetWebhookEventsUrl = (params?: GetWebhookEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/integrations/thinkific/webhook-events?${stringifiedParams}`
    : `/integrations/thinkific/webhook-events`;
};

/**
 * Get recent Thinkific webhook events.
 *
 * Requires READ_INTEGRATIONS permission with ALL scope.
 * Returns up to `limit` most recent webhook events, optionally filtered by status.
 * @summary Get recent webhook events
 */
export const getWebhookEvents = async (
  params?: GetWebhookEventsParams,
  options?: RequestInit
): Promise<WebhookEventsListResponse> => {
  return apiMutator<WebhookEventsListResponse>(getGetWebhookEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetWebhookEventsQueryKey = (params?: GetWebhookEventsParams) => {
  return [`/integrations/thinkific/webhook-events`, ...(params ? [params] : [])] as const;
};

export const getGetWebhookEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebhookEvents>>> = ({ signal }) =>
    getWebhookEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWebhookEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebhookEvents>>>;
export type GetWebhookEventsQueryError = ErrorResponse | HTTPValidationError;

export function useGetWebhookEvents<
  TData = Awaited<ReturnType<typeof getWebhookEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetWebhookEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookEvents>>,
          TError,
          Awaited<ReturnType<typeof getWebhookEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWebhookEvents<
  TData = Awaited<ReturnType<typeof getWebhookEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookEvents>>,
          TError,
          Awaited<ReturnType<typeof getWebhookEvents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWebhookEvents<
  TData = Awaited<ReturnType<typeof getWebhookEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get recent webhook events
 */

export function useGetWebhookEvents<
  TData = Awaited<ReturnType<typeof getWebhookEvents>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebhookEvents>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetWebhookEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetWebhookEventSummaryUrl = (params?: GetWebhookEventSummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/integrations/thinkific/webhook-events/summary?${stringifiedParams}`
    : `/integrations/thinkific/webhook-events/summary`;
};

/**
 * Get summary statistics for webhook events.
 *
 * Requires READ_INTEGRATIONS permission with ALL scope.
 * Returns event counts by status for the specified time period.
 * @summary Get webhook event summary
 */
export const getWebhookEventSummary = async (
  params?: GetWebhookEventSummaryParams,
  options?: RequestInit
): Promise<WebhookEventSummaryResponse> => {
  return apiMutator<WebhookEventSummaryResponse>(getGetWebhookEventSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetWebhookEventSummaryQueryKey = (params?: GetWebhookEventSummaryParams) => {
  return [`/integrations/thinkific/webhook-events/summary`, ...(params ? [params] : [])] as const;
};

export const getGetWebhookEventSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookEventSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookEventSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookEventSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebhookEventSummary>>> = ({ signal }) =>
    getWebhookEventSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookEventSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWebhookEventSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookEventSummary>>
>;
export type GetWebhookEventSummaryQueryError = ErrorResponse | HTTPValidationError;

export function useGetWebhookEventSummary<
  TData = Awaited<ReturnType<typeof getWebhookEventSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetWebhookEventSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookEventSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookEventSummary>>,
          TError,
          Awaited<ReturnType<typeof getWebhookEventSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWebhookEventSummary<
  TData = Awaited<ReturnType<typeof getWebhookEventSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookEventSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookEventSummary>>,
          TError,
          Awaited<ReturnType<typeof getWebhookEventSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWebhookEventSummary<
  TData = Awaited<ReturnType<typeof getWebhookEventSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookEventSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get webhook event summary
 */

export function useGetWebhookEventSummary<
  TData = Awaited<ReturnType<typeof getWebhookEventSummary>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetWebhookEventSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWebhookEventSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetWebhookEventSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetMyEnrollmentsUrl = () => {
  return `/training/my-enrollments`;
};

/**
 * Get current user's training enrollments.
 *
 * Available to all authenticated users.
 * Automatically triggers a background sync if data is stale.
 * @summary Get current user's training enrollments
 */
export const getMyEnrollments = async (
  options?: RequestInit
): Promise<ThinkificEnrollmentListResponse> => {
  return apiMutator<ThinkificEnrollmentListResponse>(getGetMyEnrollmentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyEnrollmentsQueryKey = () => {
  return [`/training/my-enrollments`] as const;
};

export const getGetMyEnrollmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyEnrollments>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollments>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyEnrollmentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyEnrollments>>> = ({ signal }) =>
    getMyEnrollments({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyEnrollments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyEnrollments>>>;
export type GetMyEnrollmentsQueryError = ErrorResponse;

export function useGetMyEnrollments<
  TData = Awaited<ReturnType<typeof getMyEnrollments>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getMyEnrollments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyEnrollments<
  TData = Awaited<ReturnType<typeof getMyEnrollments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getMyEnrollments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyEnrollments<
  TData = Awaited<ReturnType<typeof getMyEnrollments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollments>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current user's training enrollments
 */

export function useGetMyEnrollments<
  TData = Awaited<ReturnType<typeof getMyEnrollments>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollments>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyEnrollmentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSyncMyEnrollmentsUrl = () => {
  return `/training/my-enrollments/sync`;
};

/**
 * Sync current user's enrollments from Thinkific.
 *
 * Available to all authenticated users.
 * @summary Sync current user's enrollments from Thinkific
 */
export const syncMyEnrollments = async (
  options?: RequestInit
): Promise<ThinkificEnrollmentListResponse> => {
  return apiMutator<ThinkificEnrollmentListResponse>(getSyncMyEnrollmentsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSyncMyEnrollmentsMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncMyEnrollments>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof syncMyEnrollments>>, TError, void, TContext> => {
  const mutationKey = ["syncMyEnrollments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncMyEnrollments>>, void> = () => {
    return syncMyEnrollments(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncMyEnrollmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncMyEnrollments>>
>;

export type SyncMyEnrollmentsMutationError = ErrorResponse;

/**
 * @summary Sync current user's enrollments from Thinkific
 */
export const useSyncMyEnrollments = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof syncMyEnrollments>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof syncMyEnrollments>>, TError, void, TContext> => {
  return useMutation(getSyncMyEnrollmentsMutationOptions(options), queryClient);
};

export const getGetTeamTrainingUrl = () => {
  return `/training/team`;
};

/**
 * Get training summary for manager's team.
 *
 * Requires READ_TRAINING permission with TEAM scope or higher.
 * @summary Get training summary for manager's team
 */
export const getTeamTraining = async (options?: RequestInit): Promise<TeamTrainingResponse> => {
  return apiMutator<TeamTrainingResponse>(getGetTeamTrainingUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamTrainingQueryKey = () => {
  return [`/training/team`] as const;
};

export const getGetTeamTrainingQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamTraining>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamTraining>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamTrainingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamTraining>>> = ({ signal }) =>
    getTeamTraining({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamTraining>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamTrainingQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamTraining>>>;
export type GetTeamTrainingQueryError = ErrorResponse;

export function useGetTeamTraining<
  TData = Awaited<ReturnType<typeof getTeamTraining>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamTraining>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamTraining>>,
          TError,
          Awaited<ReturnType<typeof getTeamTraining>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamTraining<
  TData = Awaited<ReturnType<typeof getTeamTraining>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamTraining>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamTraining>>,
          TError,
          Awaited<ReturnType<typeof getTeamTraining>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeamTraining<
  TData = Awaited<ReturnType<typeof getTeamTraining>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamTraining>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get training summary for manager's team
 */

export function useGetTeamTraining<
  TData = Awaited<ReturnType<typeof getTeamTraining>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamTraining>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamTrainingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetAllUsersTrainingUrl = () => {
  return `/training/all-users`;
};

/**
 * Get training summary for all users.
 *
 * Requires READ_TRAINING permission with ALL scope.
 * @summary Get training summary for all users
 */
export const getAllUsersTraining = async (options?: RequestInit): Promise<TeamTrainingResponse> => {
  return apiMutator<TeamTrainingResponse>(getGetAllUsersTrainingUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAllUsersTrainingQueryKey = () => {
  return [`/training/all-users`] as const;
};

export const getGetAllUsersTrainingQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllUsersTraining>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsersTraining>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllUsersTrainingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsersTraining>>> = ({ signal }) =>
    getAllUsersTraining({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllUsersTraining>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllUsersTrainingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllUsersTraining>>
>;
export type GetAllUsersTrainingQueryError = ErrorResponse;

export function useGetAllUsersTraining<
  TData = Awaited<ReturnType<typeof getAllUsersTraining>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllUsersTraining>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsersTraining>>,
          TError,
          Awaited<ReturnType<typeof getAllUsersTraining>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllUsersTraining<
  TData = Awaited<ReturnType<typeof getAllUsersTraining>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllUsersTraining>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsersTraining>>,
          TError,
          Awaited<ReturnType<typeof getAllUsersTraining>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllUsersTraining<
  TData = Awaited<ReturnType<typeof getAllUsersTraining>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllUsersTraining>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get training summary for all users
 */

export function useGetAllUsersTraining<
  TData = Awaited<ReturnType<typeof getAllUsersTraining>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllUsersTraining>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllUsersTrainingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetUserEnrollmentsUrl = (userId: string) => {
  return `/training/user/${userId}/enrollments`;
};

/**
 * Get a specific user's training enrollments.
 *
 * Requires READ_TRAINING permission with TEAM scope or higher.
 * Manager can view their team members' enrollments.
 * Admin/Director can view any user's enrollments.
 * @summary Get a specific user's training enrollments
 */
export const getUserEnrollments = async (
  userId: string,
  options?: RequestInit
): Promise<ThinkificEnrollmentListResponse> => {
  return apiMutator<ThinkificEnrollmentListResponse>(getGetUserEnrollmentsUrl(userId), {
    ...options,
    method: "GET",
  });
};

export const getGetUserEnrollmentsQueryKey = (userId: string) => {
  return [`/training/user/${userId}/enrollments`] as const;
};

export const getGetUserEnrollmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserEnrollments>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEnrollments>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserEnrollmentsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEnrollments>>> = ({ signal }) =>
    getUserEnrollments(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUserEnrollments>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUserEnrollmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserEnrollments>>
>;
export type GetUserEnrollmentsQueryError = ErrorResponse | HTTPValidationError;

export function useGetUserEnrollments<
  TData = Awaited<ReturnType<typeof getUserEnrollments>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEnrollments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getUserEnrollments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserEnrollments<
  TData = Awaited<ReturnType<typeof getUserEnrollments>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserEnrollments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getUserEnrollments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserEnrollments<
  TData = Awaited<ReturnType<typeof getUserEnrollments>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEnrollments>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a specific user's training enrollments
 */

export function useGetUserEnrollments<
  TData = Awaited<ReturnType<typeof getUserEnrollments>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEnrollments>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserEnrollmentsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTrainingRequirementsUrl = (params?: GetTrainingRequirementsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/training/requirements?${stringifiedParams}`
    : `/training/requirements`;
};

/**
 * Get training requirements.
 *
 * Available to all authenticated users.
 * Optionally filter by role and/or department.
 * @summary Get training requirements
 */
export const getTrainingRequirements = async (
  params?: GetTrainingRequirementsParams,
  options?: RequestInit
): Promise<TrainingRequirementListResponse> => {
  return apiMutator<TrainingRequirementListResponse>(getGetTrainingRequirementsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTrainingRequirementsQueryKey = (params?: GetTrainingRequirementsParams) => {
  return [`/training/requirements`, ...(params ? [params] : [])] as const;
};

export const getGetTrainingRequirementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrainingRequirements>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingRequirementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingRequirements>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrainingRequirementsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainingRequirements>>> = ({
    signal,
  }) => getTrainingRequirements(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrainingRequirements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrainingRequirementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrainingRequirements>>
>;
export type GetTrainingRequirementsQueryError = ErrorResponse | HTTPValidationError;

export function useGetTrainingRequirements<
  TData = Awaited<ReturnType<typeof getTrainingRequirements>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetTrainingRequirementsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingRequirements>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingRequirements>>,
          TError,
          Awaited<ReturnType<typeof getTrainingRequirements>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTrainingRequirements<
  TData = Awaited<ReturnType<typeof getTrainingRequirements>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingRequirementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingRequirements>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrainingRequirements>>,
          TError,
          Awaited<ReturnType<typeof getTrainingRequirements>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTrainingRequirements<
  TData = Awaited<ReturnType<typeof getTrainingRequirements>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingRequirementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingRequirements>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get training requirements
 */

export function useGetTrainingRequirements<
  TData = Awaited<ReturnType<typeof getTrainingRequirements>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetTrainingRequirementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTrainingRequirements>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTrainingRequirementsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateTrainingRequirementUrl = () => {
  return `/training/requirements`;
};

/**
 * Create a new training requirement.
 *
 * Requires WRITE_TRAINING permission.
 * Also creates training goals for all matching users.
 * @summary Create a training requirement
 */
export const createTrainingRequirement = async (
  createRequirementRequest: CreateRequirementRequest,
  options?: RequestInit
): Promise<TrainingRequirement> => {
  return apiMutator<TrainingRequirement>(getCreateTrainingRequirementUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRequirementRequest),
  });
};

export const getCreateTrainingRequirementMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrainingRequirement>>,
    TError,
    { data: CreateRequirementRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrainingRequirement>>,
  TError,
  { data: CreateRequirementRequest },
  TContext
> => {
  const mutationKey = ["createTrainingRequirement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrainingRequirement>>,
    { data: CreateRequirementRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createTrainingRequirement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrainingRequirementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrainingRequirement>>
>;
export type CreateTrainingRequirementMutationBody = CreateRequirementRequest;
export type CreateTrainingRequirementMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Create a training requirement
 */
export const useCreateTrainingRequirement = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTrainingRequirement>>,
      TError,
      { data: CreateRequirementRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTrainingRequirement>>,
  TError,
  { data: CreateRequirementRequest },
  TContext
> => {
  return useMutation(getCreateTrainingRequirementMutationOptions(options), queryClient);
};

export const getGetRequirementPreviewUrl = (params?: GetRequirementPreviewParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/training/requirements/preview?${stringifiedParams}`
    : `/training/requirements/preview`;
};

/**
 * Preview users matching requirement criteria.
 *
 * Requires WRITE_TRAINING permission.
 * Returns count and sample of users matching the given roles and departments.
 * @summary Preview users matching requirement criteria
 */
export const getRequirementPreview = async (
  params?: GetRequirementPreviewParams,
  options?: RequestInit
): Promise<RequirementPreviewResponse> => {
  return apiMutator<RequirementPreviewResponse>(getGetRequirementPreviewUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRequirementPreviewQueryKey = (params?: GetRequirementPreviewParams) => {
  return [`/training/requirements/preview`, ...(params ? [params] : [])] as const;
};

export const getGetRequirementPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getRequirementPreview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetRequirementPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRequirementPreview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRequirementPreviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementPreview>>> = ({ signal }) =>
    getRequirementPreview(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRequirementPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRequirementPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRequirementPreview>>
>;
export type GetRequirementPreviewQueryError = ErrorResponse | HTTPValidationError;

export function useGetRequirementPreview<
  TData = Awaited<ReturnType<typeof getRequirementPreview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | GetRequirementPreviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRequirementPreview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequirementPreview>>,
          TError,
          Awaited<ReturnType<typeof getRequirementPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRequirementPreview<
  TData = Awaited<ReturnType<typeof getRequirementPreview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetRequirementPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRequirementPreview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequirementPreview>>,
          TError,
          Awaited<ReturnType<typeof getRequirementPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRequirementPreview<
  TData = Awaited<ReturnType<typeof getRequirementPreview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetRequirementPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRequirementPreview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Preview users matching requirement criteria
 */

export function useGetRequirementPreview<
  TData = Awaited<ReturnType<typeof getRequirementPreview>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: GetRequirementPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRequirementPreview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRequirementPreviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDeleteTrainingRequirementUrl = (requirementId: string) => {
  return `/training/requirements/${requirementId}`;
};

/**
 * Delete a training requirement.
 *
 * Requires WRITE_TRAINING permission.
 * Also removes associated training tasks from all users.
 * @summary Delete a training requirement
 */
export const deleteTrainingRequirement = async (
  requirementId: string,
  options?: RequestInit
): Promise<SuccessResponse> => {
  return apiMutator<SuccessResponse>(getDeleteTrainingRequirementUrl(requirementId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTrainingRequirementMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrainingRequirement>>,
    TError,
    { requirementId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrainingRequirement>>,
  TError,
  { requirementId: string },
  TContext
> => {
  const mutationKey = ["deleteTrainingRequirement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrainingRequirement>>,
    { requirementId: string }
  > = (props) => {
    const { requirementId } = props ?? {};

    return deleteTrainingRequirement(requirementId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrainingRequirementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrainingRequirement>>
>;

export type DeleteTrainingRequirementMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a training requirement
 */
export const useDeleteTrainingRequirement = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTrainingRequirement>>,
      TError,
      { requirementId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrainingRequirement>>,
  TError,
  { requirementId: string },
  TContext
> => {
  return useMutation(getDeleteTrainingRequirementMutationOptions(options), queryClient);
};

export const getListTranscriptsUrl = (params?: ListTranscriptsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/transcripts?${stringifiedParams}` : `/transcripts`;
};

/**
 * List imported transcripts for the current user.
 * @summary List imported transcripts
 */
export const listTranscripts = async (
  params?: ListTranscriptsParams,
  options?: RequestInit
): Promise<TranscriptListResponse> => {
  return apiMutator<TranscriptListResponse>(getListTranscriptsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTranscriptsQueryKey = (params?: ListTranscriptsParams) => {
  return [`/transcripts`, ...(params ? [params] : [])] as const;
};

export const getListTranscriptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTranscripts>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTranscriptsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTranscripts>>> = ({ signal }) =>
    listTranscripts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTranscripts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTranscriptsQueryResult = NonNullable<Awaited<ReturnType<typeof listTranscripts>>>;
export type ListTranscriptsQueryError = ErrorResponse | HTTPValidationError;

export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params: undefined | ListTranscriptsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTranscripts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTranscripts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTranscripts>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List imported transcripts
 */

export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTranscripts>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTranscriptsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTranscriptUrl = (transcriptId: string) => {
  return `/transcripts/${transcriptId}`;
};

/**
 * Get a single imported transcript by ID.
 * @summary Get a transcript by ID
 */
export const getTranscript = async (
  transcriptId: string,
  options?: RequestInit
): Promise<ImportedTranscript> => {
  return apiMutator<ImportedTranscript>(getGetTranscriptUrl(transcriptId), {
    ...options,
    method: "GET",
  });
};

export const getGetTranscriptQueryKey = (transcriptId: string) => {
  return [`/transcripts/${transcriptId}`] as const;
};

export const getGetTranscriptQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTranscriptQueryKey(transcriptId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranscript>>> = ({ signal }) =>
    getTranscript(transcriptId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: transcriptId !== null && transcriptId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTranscriptQueryResult = NonNullable<Awaited<ReturnType<typeof getTranscript>>>;
export type GetTranscriptQueryError = ErrorResponse | HTTPValidationError;

export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  transcriptId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranscript>>,
          TError,
          Awaited<ReturnType<typeof getTranscript>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranscript>>,
          TError,
          Awaited<ReturnType<typeof getTranscript>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a transcript by ID
 */

export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = ErrorResponse | HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTranscriptQueryOptions(transcriptId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDeleteTranscriptUrl = (transcriptId: string) => {
  return `/transcripts/${transcriptId}`;
};

/**
 * Delete an imported transcript.
 * @summary Delete a transcript
 */
export const deleteTranscript = async (
  transcriptId: string,
  options?: RequestInit
): Promise<DeleteTranscriptResponse> => {
  return apiMutator<DeleteTranscriptResponse>(getDeleteTranscriptUrl(transcriptId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTranscriptMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTranscript>>,
    TError,
    { transcriptId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  const mutationKey = ["deleteTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTranscript>>,
    { transcriptId: string }
  > = (props) => {
    const { transcriptId } = props ?? {};

    return deleteTranscript(transcriptId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTranscript>>
>;

export type DeleteTranscriptMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Delete a transcript
 */
export const useDeleteTranscript = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTranscript>>,
      TError,
      { transcriptId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  return useMutation(getDeleteTranscriptMutationOptions(options), queryClient);
};

export const getListKbItemsUrl = (params?: ListKbItemsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/kb/items?${stringifiedParams}` : `/v1/kb/items`;
};

/**
 * List the current user's KB items, newest first.
 * @summary List Kb Items
 */
export const listKbItems = async (
  params?: ListKbItemsParams,
  options?: RequestInit
): Promise<KbItemListResponse> => {
  return apiMutator<KbItemListResponse>(getListKbItemsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListKbItemsQueryKey = (params?: ListKbItemsParams) => {
  return [`/v1/kb/items`, ...(params ? [params] : [])] as const;
};

export const getListKbItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listKbItems>>,
  TError = HTTPValidationError,
>(
  params?: ListKbItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKbItems>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListKbItemsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listKbItems>>> = ({ signal }) =>
    listKbItems(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listKbItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListKbItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listKbItems>>>;
export type ListKbItemsQueryError = HTTPValidationError;

export function useListKbItems<
  TData = Awaited<ReturnType<typeof listKbItems>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListKbItemsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKbItems>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKbItems>>,
          TError,
          Awaited<ReturnType<typeof listKbItems>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListKbItems<
  TData = Awaited<ReturnType<typeof listKbItems>>,
  TError = HTTPValidationError,
>(
  params?: ListKbItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKbItems>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKbItems>>,
          TError,
          Awaited<ReturnType<typeof listKbItems>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListKbItems<
  TData = Awaited<ReturnType<typeof listKbItems>>,
  TError = HTTPValidationError,
>(
  params?: ListKbItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKbItems>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Kb Items
 */

export function useListKbItems<
  TData = Awaited<ReturnType<typeof listKbItems>>,
  TError = HTTPValidationError,
>(
  params?: ListKbItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKbItems>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListKbItemsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getItemsExistUrl = (params: ItemsExistParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/kb/items/exists?${stringifiedParams}`
    : `/v1/kb/items/exists`;
};

/**
 * Batch existence check — the Sources panel uses this on mount.
 * @summary Items Exist
 */
export const itemsExist = async (
  params: ItemsExistParams,
  options?: RequestInit
): Promise<KbItemsExistsResponse> => {
  return apiMutator<KbItemsExistsResponse>(getItemsExistUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getItemsExistQueryKey = (params?: ItemsExistParams) => {
  return [`/v1/kb/items/exists`, ...(params ? [params] : [])] as const;
};

export const getItemsExistQueryOptions = <
  TData = Awaited<ReturnType<typeof itemsExist>>,
  TError = HTTPValidationError,
>(
  params: ItemsExistParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof itemsExist>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getItemsExistQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof itemsExist>>> = ({ signal }) =>
    itemsExist(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsExist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsExistQueryResult = NonNullable<Awaited<ReturnType<typeof itemsExist>>>;
export type ItemsExistQueryError = HTTPValidationError;

export function useItemsExist<
  TData = Awaited<ReturnType<typeof itemsExist>>,
  TError = HTTPValidationError,
>(
  params: ItemsExistParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof itemsExist>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsExist>>,
          TError,
          Awaited<ReturnType<typeof itemsExist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useItemsExist<
  TData = Awaited<ReturnType<typeof itemsExist>>,
  TError = HTTPValidationError,
>(
  params: ItemsExistParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof itemsExist>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsExist>>,
          TError,
          Awaited<ReturnType<typeof itemsExist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useItemsExist<
  TData = Awaited<ReturnType<typeof itemsExist>>,
  TError = HTTPValidationError,
>(
  params: ItemsExistParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof itemsExist>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Items Exist
 */

export function useItemsExist<
  TData = Awaited<ReturnType<typeof itemsExist>>,
  TError = HTTPValidationError,
>(
  params: ItemsExistParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof itemsExist>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getItemsExistQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetKbItemUrl = (itemId: string) => {
  return `/v1/kb/items/${itemId}`;
};

/**
 * @summary Get Kb Item
 */
export const getKbItem = async (itemId: string, options?: RequestInit): Promise<KbItem> => {
  return apiMutator<KbItem>(getGetKbItemUrl(itemId), {
    ...options,
    method: "GET",
  });
};

export const getGetKbItemQueryKey = (itemId: string) => {
  return [`/v1/kb/items/${itemId}`] as const;
};

export const getGetKbItemQueryOptions = <
  TData = Awaited<ReturnType<typeof getKbItem>>,
  TError = HTTPValidationError,
>(
  itemId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKbItem>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKbItemQueryKey(itemId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKbItem>>> = ({ signal }) =>
    getKbItem(itemId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: itemId !== null && itemId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getKbItem>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetKbItemQueryResult = NonNullable<Awaited<ReturnType<typeof getKbItem>>>;
export type GetKbItemQueryError = HTTPValidationError;

export function useGetKbItem<
  TData = Awaited<ReturnType<typeof getKbItem>>,
  TError = HTTPValidationError,
>(
  itemId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKbItem>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKbItem>>,
          TError,
          Awaited<ReturnType<typeof getKbItem>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetKbItem<
  TData = Awaited<ReturnType<typeof getKbItem>>,
  TError = HTTPValidationError,
>(
  itemId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKbItem>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKbItem>>,
          TError,
          Awaited<ReturnType<typeof getKbItem>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetKbItem<
  TData = Awaited<ReturnType<typeof getKbItem>>,
  TError = HTTPValidationError,
>(
  itemId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKbItem>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Kb Item
 */

export function useGetKbItem<
  TData = Awaited<ReturnType<typeof getKbItem>>,
  TError = HTTPValidationError,
>(
  itemId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKbItem>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetKbItemQueryOptions(itemId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPatchKbItemUrl = (itemId: string) => {
  return `/v1/kb/items/${itemId}`;
};

/**
 * @summary Patch Kb Item
 */
export const patchKbItem = async (
  itemId: string,
  kbItemPatchRequest: KbItemPatchRequest,
  options?: RequestInit
): Promise<KbItem> => {
  return apiMutator<KbItem>(getPatchKbItemUrl(itemId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbItemPatchRequest),
  });
};

export const getPatchKbItemMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchKbItem>>,
    TError,
    { itemId: string; data: KbItemPatchRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchKbItem>>,
  TError,
  { itemId: string; data: KbItemPatchRequest },
  TContext
> => {
  const mutationKey = ["patchKbItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchKbItem>>,
    { itemId: string; data: KbItemPatchRequest }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return patchKbItem(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchKbItemMutationResult = NonNullable<Awaited<ReturnType<typeof patchKbItem>>>;
export type PatchKbItemMutationBody = KbItemPatchRequest;
export type PatchKbItemMutationError = HTTPValidationError;

/**
 * @summary Patch Kb Item
 */
export const usePatchKbItem = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchKbItem>>,
      TError,
      { itemId: string; data: KbItemPatchRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchKbItem>>,
  TError,
  { itemId: string; data: KbItemPatchRequest },
  TContext
> => {
  return useMutation(getPatchKbItemMutationOptions(options), queryClient);
};

export const getDeleteKbItemUrl = (itemId: string) => {
  return `/v1/kb/items/${itemId}`;
};

/**
 * @summary Delete Kb Item
 */
export const deleteKbItem = async (itemId: string, options?: RequestInit): Promise<void> => {
  return apiMutator<void>(getDeleteKbItemUrl(itemId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteKbItemMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteKbItem>>,
    TError,
    { itemId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteKbItem>>,
  TError,
  { itemId: string },
  TContext
> => {
  const mutationKey = ["deleteKbItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteKbItem>>,
    { itemId: string }
  > = (props) => {
    const { itemId } = props ?? {};

    return deleteKbItem(itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteKbItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteKbItem>>>;

export type DeleteKbItemMutationError = HTTPValidationError;

/**
 * @summary Delete Kb Item
 */
export const useDeleteKbItem = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteKbItem>>,
      TError,
      { itemId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteKbItem>>,
  TError,
  { itemId: string },
  TContext
> => {
  return useMutation(getDeleteKbItemMutationOptions(options), queryClient);
};

export const getSaveFromAgentUrl = () => {
  return `/v1/kb/items/from-agent`;
};

/**
 * Save a tool-result row from the chat Sources panel.
 *
 * Phase 8.3: gated behind ``KB_SAVE_FROM_AGENT_ENABLED`` to allow a
 * staged rollout. When the flag is off, responds 503.
 * @summary Save From Agent
 */
export const saveFromAgent = async (
  kbSaveFromAgentRequest: KbSaveFromAgentRequest,
  options?: RequestInit
): Promise<KbSaveResponse> => {
  return apiMutator<KbSaveResponse>(getSaveFromAgentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbSaveFromAgentRequest),
  });
};

export const getSaveFromAgentMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveFromAgent>>,
    TError,
    { data: KbSaveFromAgentRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveFromAgent>>,
  TError,
  { data: KbSaveFromAgentRequest },
  TContext
> => {
  const mutationKey = ["saveFromAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveFromAgent>>,
    { data: KbSaveFromAgentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return saveFromAgent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveFromAgentMutationResult = NonNullable<Awaited<ReturnType<typeof saveFromAgent>>>;
export type SaveFromAgentMutationBody = KbSaveFromAgentRequest;
export type SaveFromAgentMutationError = HTTPValidationError;

/**
 * @summary Save From Agent
 */
export const useSaveFromAgent = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveFromAgent>>,
      TError,
      { data: KbSaveFromAgentRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof saveFromAgent>>,
  TError,
  { data: KbSaveFromAgentRequest },
  TContext
> => {
  return useMutation(getSaveFromAgentMutationOptions(options), queryClient);
};

export const getSaveManualUrl = () => {
  return `/v1/kb/items/manual`;
};

/**
 * Save an arbitrary URL from the ``/my-kb`` manual-save dialog.
 * @summary Save Manual
 */
export const saveManual = async (
  kbManualSaveRequest: KbManualSaveRequest,
  options?: RequestInit
): Promise<KbSaveResponse> => {
  return apiMutator<KbSaveResponse>(getSaveManualUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbManualSaveRequest),
  });
};

export const getSaveManualMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveManual>>,
    TError,
    { data: KbManualSaveRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveManual>>,
  TError,
  { data: KbManualSaveRequest },
  TContext
> => {
  const mutationKey = ["saveManual"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveManual>>,
    { data: KbManualSaveRequest }
  > = (props) => {
    const { data } = props ?? {};

    return saveManual(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveManualMutationResult = NonNullable<Awaited<ReturnType<typeof saveManual>>>;
export type SaveManualMutationBody = KbManualSaveRequest;
export type SaveManualMutationError = HTTPValidationError;

/**
 * @summary Save Manual
 */
export const useSaveManual = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveManual>>,
      TError,
      { data: KbManualSaveRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof saveManual>>,
  TError,
  { data: KbManualSaveRequest },
  TContext
> => {
  return useMutation(getSaveManualMutationOptions(options), queryClient);
};

export const getRetryEnrichmentUrl = (itemId: string) => {
  return `/v1/kb/items/${itemId}/retry-enrichment`;
};

/**
 * Reset a FAILED item to PENDING and re-enqueue enrichment.
 * @summary Retry Enrichment
 */
export const retryEnrichment = async (itemId: string, options?: RequestInit): Promise<KbItem> => {
  return apiMutator<KbItem>(getRetryEnrichmentUrl(itemId), {
    ...options,
    method: "POST",
  });
};

export const getRetryEnrichmentMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryEnrichment>>,
    TError,
    { itemId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryEnrichment>>,
  TError,
  { itemId: string },
  TContext
> => {
  const mutationKey = ["retryEnrichment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryEnrichment>>,
    { itemId: string }
  > = (props) => {
    const { itemId } = props ?? {};

    return retryEnrichment(itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryEnrichmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryEnrichment>>
>;

export type RetryEnrichmentMutationError = HTTPValidationError;

/**
 * @summary Retry Enrichment
 */
export const useRetryEnrichment = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof retryEnrichment>>,
      TError,
      { itemId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof retryEnrichment>>,
  TError,
  { itemId: string },
  TContext
> => {
  return useMutation(getRetryEnrichmentMutationOptions(options), queryClient);
};

export const getPromoteKbItemUrl = (itemId: string) => {
  return `/v1/kb/items/${itemId}/promote`;
};

/**
 * Promote a KB item into the company Resource Library.
 * @summary Promote Kb Item
 */
export const promoteKbItem = async (
  itemId: string,
  kbPromoteRequest?: KbPromoteRequest,
  options?: RequestInit
): Promise<KbPromoteResponse> => {
  return apiMutator<KbPromoteResponse>(getPromoteKbItemUrl(itemId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbPromoteRequest),
  });
};

export const getPromoteKbItemMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteKbItem>>,
    TError,
    { itemId: string; data?: KbPromoteRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteKbItem>>,
  TError,
  { itemId: string; data?: KbPromoteRequest },
  TContext
> => {
  const mutationKey = ["promoteKbItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteKbItem>>,
    { itemId: string; data?: KbPromoteRequest }
  > = (props) => {
    const { itemId, data } = props ?? {};

    return promoteKbItem(itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteKbItemMutationResult = NonNullable<Awaited<ReturnType<typeof promoteKbItem>>>;
export type PromoteKbItemMutationBody = KbPromoteRequest | undefined;
export type PromoteKbItemMutationError = HTTPValidationError;

/**
 * @summary Promote Kb Item
 */
export const usePromoteKbItem = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof promoteKbItem>>,
      TError,
      { itemId: string; data?: KbPromoteRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof promoteKbItem>>,
  TError,
  { itemId: string; data?: KbPromoteRequest },
  TContext
> => {
  return useMutation(getPromoteKbItemMutationOptions(options), queryClient);
};

export const getHubspotStatusUrl = () => {
  return `/integrations/hubspot/status`;
};

/**
 * Return HubSpot connection status for the current user.
 * @summary Hubspot Status
 */
export const hubspotStatus = async (options?: RequestInit): Promise<HubSpotConnectionStatus> => {
  return apiMutator<HubSpotConnectionStatus>(getHubspotStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHubspotStatusQueryKey = () => {
  return [`/integrations/hubspot/status`] as const;
};

export const getHubspotStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof hubspotStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHubspotStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hubspotStatus>>> = ({ signal }) =>
    hubspotStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof hubspotStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HubspotStatusQueryResult = NonNullable<Awaited<ReturnType<typeof hubspotStatus>>>;
export type HubspotStatusQueryError = unknown;

export function useHubspotStatus<
  TData = Awaited<ReturnType<typeof hubspotStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotStatus>>,
          TError,
          Awaited<ReturnType<typeof hubspotStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHubspotStatus<
  TData = Awaited<ReturnType<typeof hubspotStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotStatus>>,
          TError,
          Awaited<ReturnType<typeof hubspotStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHubspotStatus<
  TData = Awaited<ReturnType<typeof hubspotStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hubspot Status
 */

export function useHubspotStatus<
  TData = Awaited<ReturnType<typeof hubspotStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHubspotStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getHubspotConnectUrl = () => {
  return `/integrations/hubspot/connect`;
};

/**
 * Generate the HubSpot OAuth authorization URL.
 * @summary Hubspot Connect
 */
export const hubspotConnect = async (options?: RequestInit): Promise<HubSpotConnectResponse> => {
  return apiMutator<HubSpotConnectResponse>(getHubspotConnectUrl(), {
    ...options,
    method: "POST",
  });
};

export const getHubspotConnectMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof hubspotConnect>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof hubspotConnect>>, TError, void, TContext> => {
  const mutationKey = ["hubspotConnect"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof hubspotConnect>>, void> = () => {
    return hubspotConnect(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HubspotConnectMutationResult = NonNullable<Awaited<ReturnType<typeof hubspotConnect>>>;

export type HubspotConnectMutationError = unknown;

/**
 * @summary Hubspot Connect
 */
export const useHubspotConnect = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof hubspotConnect>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof hubspotConnect>>, TError, void, TContext> => {
  return useMutation(getHubspotConnectMutationOptions(options), queryClient);
};

export const getHubspotCallbackUrl = (params: HubspotCallbackParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/integrations/hubspot/callback?${stringifiedParams}`
    : `/integrations/hubspot/callback`;
};

/**
 * OAuth callback — exchange code for tokens and redirect.
 * @summary Hubspot Callback
 */
export const hubspotCallback = async (
  params: HubspotCallbackParams,
  options?: RequestInit
): Promise<unknown> => {
  return apiMutator<unknown>(getHubspotCallbackUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getHubspotCallbackQueryKey = (params?: HubspotCallbackParams) => {
  return [`/integrations/hubspot/callback`, ...(params ? [params] : [])] as const;
};

export const getHubspotCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof hubspotCallback>>,
  TError = HTTPValidationError,
>(
  params: HubspotCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallback>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHubspotCallbackQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hubspotCallback>>> = ({ signal }) =>
    hubspotCallback(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof hubspotCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HubspotCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof hubspotCallback>>>;
export type HubspotCallbackQueryError = HTTPValidationError;

export function useHubspotCallback<
  TData = Awaited<ReturnType<typeof hubspotCallback>>,
  TError = HTTPValidationError,
>(
  params: HubspotCallbackParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallback>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotCallback>>,
          TError,
          Awaited<ReturnType<typeof hubspotCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHubspotCallback<
  TData = Awaited<ReturnType<typeof hubspotCallback>>,
  TError = HTTPValidationError,
>(
  params: HubspotCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallback>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotCallback>>,
          TError,
          Awaited<ReturnType<typeof hubspotCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHubspotCallback<
  TData = Awaited<ReturnType<typeof hubspotCallback>>,
  TError = HTTPValidationError,
>(
  params: HubspotCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallback>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hubspot Callback
 */

export function useHubspotCallback<
  TData = Awaited<ReturnType<typeof hubspotCallback>>,
  TError = HTTPValidationError,
>(
  params: HubspotCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallback>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHubspotCallbackQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getHubspotDisconnectUrl = () => {
  return `/integrations/hubspot/disconnect`;
};

/**
 * Disconnect HubSpot — revoke token and clear credentials.
 * @summary Hubspot Disconnect
 */
export const hubspotDisconnect = async (options?: RequestInit): Promise<HubspotDisconnect200> => {
  return apiMutator<HubspotDisconnect200>(getHubspotDisconnectUrl(), {
    ...options,
    method: "POST",
  });
};

export const getHubspotDisconnectMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hubspotDisconnect>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<Awaited<ReturnType<typeof hubspotDisconnect>>, TError, void, TContext> => {
  const mutationKey = ["hubspotDisconnect"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof hubspotDisconnect>>, void> = () => {
    return hubspotDisconnect(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HubspotDisconnectMutationResult = NonNullable<
  Awaited<ReturnType<typeof hubspotDisconnect>>
>;

export type HubspotDisconnectMutationError = unknown;

/**
 * @summary Hubspot Disconnect
 */
export const useHubspotDisconnect = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof hubspotDisconnect>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof hubspotDisconnect>>, TError, void, TContext> => {
  return useMutation(getHubspotDisconnectMutationOptions(options), queryClient);
};

export const getHubspotAdminStatusUrl = () => {
  return `/admin/integrations/hubspot`;
};

/**
 * Admin: get HubSpot configuration status + connected user count.
 * @summary Hubspot Admin Status
 */
export const hubspotAdminStatus = async (options?: RequestInit): Promise<HubSpotAdminStatus> => {
  return apiMutator<HubSpotAdminStatus>(getHubspotAdminStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHubspotAdminStatusQueryKey = () => {
  return [`/admin/integrations/hubspot`] as const;
};

export const getHubspotAdminStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof hubspotAdminStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAdminStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHubspotAdminStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hubspotAdminStatus>>> = ({ signal }) =>
    hubspotAdminStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof hubspotAdminStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HubspotAdminStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof hubspotAdminStatus>>
>;
export type HubspotAdminStatusQueryError = unknown;

export function useHubspotAdminStatus<
  TData = Awaited<ReturnType<typeof hubspotAdminStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAdminStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotAdminStatus>>,
          TError,
          Awaited<ReturnType<typeof hubspotAdminStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHubspotAdminStatus<
  TData = Awaited<ReturnType<typeof hubspotAdminStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hubspotAdminStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotAdminStatus>>,
          TError,
          Awaited<ReturnType<typeof hubspotAdminStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHubspotAdminStatus<
  TData = Awaited<ReturnType<typeof hubspotAdminStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAdminStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hubspot Admin Status
 */

export function useHubspotAdminStatus<
  TData = Awaited<ReturnType<typeof hubspotAdminStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAdminStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHubspotAdminStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getHubspotAdminConfigUrl = () => {
  return `/admin/integrations/hubspot`;
};

/**
 * Admin: configure OAuth client_id and client_secret.
 * @summary Hubspot Admin Config
 */
export const hubspotAdminConfig = async (
  hubSpotAdminConfigRequest: HubSpotAdminConfigRequest,
  options?: RequestInit
): Promise<HubspotAdminConfig200> => {
  return apiMutator<HubspotAdminConfig200>(getHubspotAdminConfigUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(hubSpotAdminConfigRequest),
  });
};

export const getHubspotAdminConfigMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hubspotAdminConfig>>,
    TError,
    { data: HubSpotAdminConfigRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hubspotAdminConfig>>,
  TError,
  { data: HubSpotAdminConfigRequest },
  TContext
> => {
  const mutationKey = ["hubspotAdminConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hubspotAdminConfig>>,
    { data: HubSpotAdminConfigRequest }
  > = (props) => {
    const { data } = props ?? {};

    return hubspotAdminConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HubspotAdminConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof hubspotAdminConfig>>
>;
export type HubspotAdminConfigMutationBody = HubSpotAdminConfigRequest;
export type HubspotAdminConfigMutationError = HTTPValidationError;

/**
 * @summary Hubspot Admin Config
 */
export const useHubspotAdminConfig = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof hubspotAdminConfig>>,
      TError,
      { data: HubSpotAdminConfigRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof hubspotAdminConfig>>,
  TError,
  { data: HubSpotAdminConfigRequest },
  TContext
> => {
  return useMutation(getHubspotAdminConfigMutationOptions(options), queryClient);
};

export const getHubspotAdminRevokeAllUrl = () => {
  return `/admin/integrations/hubspot/revoke-all`;
};

/**
 * Admin: emergency revoke all user HubSpot connections.
 * @summary Hubspot Admin Revoke All
 */
export const hubspotAdminRevokeAll = async (
  options?: RequestInit
): Promise<HubspotAdminRevokeAll200> => {
  return apiMutator<HubspotAdminRevokeAll200>(getHubspotAdminRevokeAllUrl(), {
    ...options,
    method: "POST",
  });
};

export const getHubspotAdminRevokeAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hubspotAdminRevokeAll>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hubspotAdminRevokeAll>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["hubspotAdminRevokeAll"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hubspotAdminRevokeAll>>,
    void
  > = () => {
    return hubspotAdminRevokeAll(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HubspotAdminRevokeAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof hubspotAdminRevokeAll>>
>;

export type HubspotAdminRevokeAllMutationError = unknown;

/**
 * @summary Hubspot Admin Revoke All
 */
export const useHubspotAdminRevokeAll = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof hubspotAdminRevokeAll>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof hubspotAdminRevokeAll>>, TError, void, TContext> => {
  return useMutation(getHubspotAdminRevokeAllMutationOptions(options), queryClient);
};

export const getAutotaskAdminStatusUrl = () => {
  return `/admin/integrations/autotask`;
};

/**
 * Admin: get AutoTask configuration status + MCP health.
 * @summary Autotask Admin Status
 */
export const autotaskAdminStatus = async (options?: RequestInit): Promise<AutoTaskAdminStatus> => {
  return apiMutator<AutoTaskAdminStatus>(getAutotaskAdminStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAutotaskAdminStatusQueryKey = () => {
  return [`/admin/integrations/autotask`] as const;
};

export const getAutotaskAdminStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof autotaskAdminStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof autotaskAdminStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAutotaskAdminStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof autotaskAdminStatus>>> = ({ signal }) =>
    autotaskAdminStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof autotaskAdminStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutotaskAdminStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof autotaskAdminStatus>>
>;
export type AutotaskAdminStatusQueryError = unknown;

export function useAutotaskAdminStatus<
  TData = Awaited<ReturnType<typeof autotaskAdminStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof autotaskAdminStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autotaskAdminStatus>>,
          TError,
          Awaited<ReturnType<typeof autotaskAdminStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAutotaskAdminStatus<
  TData = Awaited<ReturnType<typeof autotaskAdminStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof autotaskAdminStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autotaskAdminStatus>>,
          TError,
          Awaited<ReturnType<typeof autotaskAdminStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAutotaskAdminStatus<
  TData = Awaited<ReturnType<typeof autotaskAdminStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof autotaskAdminStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Autotask Admin Status
 */

export function useAutotaskAdminStatus<
  TData = Awaited<ReturnType<typeof autotaskAdminStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof autotaskAdminStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAutotaskAdminStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAutotaskAdminConfigUrl = () => {
  return `/admin/integrations/autotask`;
};

/**
 * Admin: configure AutoTask API credentials.
 * @summary Autotask Admin Config
 */
export const autotaskAdminConfig = async (
  autoTaskAdminConfigRequest: AutoTaskAdminConfigRequest,
  options?: RequestInit
): Promise<AutotaskAdminConfig200> => {
  return apiMutator<AutotaskAdminConfig200>(getAutotaskAdminConfigUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(autoTaskAdminConfigRequest),
  });
};

export const getAutotaskAdminConfigMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autotaskAdminConfig>>,
    TError,
    { data: AutoTaskAdminConfigRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof autotaskAdminConfig>>,
  TError,
  { data: AutoTaskAdminConfigRequest },
  TContext
> => {
  const mutationKey = ["autotaskAdminConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof autotaskAdminConfig>>,
    { data: AutoTaskAdminConfigRequest }
  > = (props) => {
    const { data } = props ?? {};

    return autotaskAdminConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AutotaskAdminConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof autotaskAdminConfig>>
>;
export type AutotaskAdminConfigMutationBody = AutoTaskAdminConfigRequest;
export type AutotaskAdminConfigMutationError = HTTPValidationError;

/**
 * @summary Autotask Admin Config
 */
export const useAutotaskAdminConfig = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof autotaskAdminConfig>>,
      TError,
      { data: AutoTaskAdminConfigRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof autotaskAdminConfig>>,
  TError,
  { data: AutoTaskAdminConfigRequest },
  TContext
> => {
  return useMutation(getAutotaskAdminConfigMutationOptions(options), queryClient);
};

export const getReceiveThinkificWebhookUrl = () => {
  return `/webhooks/thinkific`;
};

/**
 * Receive and process Thinkific webhook events.
 *
 * This endpoint:
 * 1. Validates the webhook signature
 * 2. Returns 200 OK immediately
 * 3. Processes the event asynchronously in the background
 *
 * Supported topics:
 * - enrollment.created: User enrolled in course
 * - enrollment.progress: Course progress updated
 * - lesson.completed: User completed a lesson
 * @summary Receive Thinkific webhook events
 */
export const receiveThinkificWebhook = async (options?: RequestInit): Promise<unknown> => {
  return apiMutator<unknown>(getReceiveThinkificWebhookUrl(), {
    ...options,
    method: "POST",
  });
};

export const getReceiveThinkificWebhookMutationOptions = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveThinkificWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiveThinkificWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["receiveThinkificWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiveThinkificWebhook>>,
    void
  > = () => {
    return receiveThinkificWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiveThinkificWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiveThinkificWebhook>>
>;

export type ReceiveThinkificWebhookMutationError = ErrorResponse | HTTPValidationError;

/**
 * @summary Receive Thinkific webhook events
 */
export const useReceiveThinkificWebhook = <
  TError = ErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof receiveThinkificWebhook>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof receiveThinkificWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getReceiveThinkificWebhookMutationOptions(options), queryClient);
};

export const getEnrichYoutubeVideoUrl = () => {
  return `/internal/kb/enrich/youtube_video`;
};

/**
 * @summary Enrich Youtube Video
 */
export const enrichYoutubeVideo = async (
  kbEnrichmentJobRequest: KbEnrichmentJobRequest,
  options?: RequestInit
): Promise<EnrichYoutubeVideo200> => {
  return apiMutator<EnrichYoutubeVideo200>(getEnrichYoutubeVideoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbEnrichmentJobRequest),
  });
};

export const getEnrichYoutubeVideoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichYoutubeVideo>>,
    TError,
    { data: KbEnrichmentJobRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrichYoutubeVideo>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  const mutationKey = ["enrichYoutubeVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrichYoutubeVideo>>,
    { data: KbEnrichmentJobRequest }
  > = (props) => {
    const { data } = props ?? {};

    return enrichYoutubeVideo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrichYoutubeVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrichYoutubeVideo>>
>;
export type EnrichYoutubeVideoMutationBody = KbEnrichmentJobRequest;
export type EnrichYoutubeVideoMutationError = HTTPValidationError;

/**
 * @summary Enrich Youtube Video
 */
export const useEnrichYoutubeVideo = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrichYoutubeVideo>>,
      TError,
      { data: KbEnrichmentJobRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enrichYoutubeVideo>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  return useMutation(getEnrichYoutubeVideoMutationOptions(options), queryClient);
};

export const getEnrichMsLearnDocUrl = () => {
  return `/internal/kb/enrich/ms_learn_doc`;
};

/**
 * @summary Enrich Ms Learn Doc
 */
export const enrichMsLearnDoc = async (
  kbEnrichmentJobRequest: KbEnrichmentJobRequest,
  options?: RequestInit
): Promise<EnrichMsLearnDoc200> => {
  return apiMutator<EnrichMsLearnDoc200>(getEnrichMsLearnDocUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbEnrichmentJobRequest),
  });
};

export const getEnrichMsLearnDocMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichMsLearnDoc>>,
    TError,
    { data: KbEnrichmentJobRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrichMsLearnDoc>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  const mutationKey = ["enrichMsLearnDoc"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrichMsLearnDoc>>,
    { data: KbEnrichmentJobRequest }
  > = (props) => {
    const { data } = props ?? {};

    return enrichMsLearnDoc(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrichMsLearnDocMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrichMsLearnDoc>>
>;
export type EnrichMsLearnDocMutationBody = KbEnrichmentJobRequest;
export type EnrichMsLearnDocMutationError = HTTPValidationError;

/**
 * @summary Enrich Ms Learn Doc
 */
export const useEnrichMsLearnDoc = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrichMsLearnDoc>>,
      TError,
      { data: KbEnrichmentJobRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enrichMsLearnDoc>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  return useMutation(getEnrichMsLearnDocMutationOptions(options), queryClient);
};

export const getEnrichVulnerabilityUrl = () => {
  return `/internal/kb/enrich/vulnerability`;
};

/**
 * @summary Enrich Vulnerability
 */
export const enrichVulnerability = async (
  kbEnrichmentJobRequest: KbEnrichmentJobRequest,
  options?: RequestInit
): Promise<EnrichVulnerability200> => {
  return apiMutator<EnrichVulnerability200>(getEnrichVulnerabilityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbEnrichmentJobRequest),
  });
};

export const getEnrichVulnerabilityMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichVulnerability>>,
    TError,
    { data: KbEnrichmentJobRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrichVulnerability>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  const mutationKey = ["enrichVulnerability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrichVulnerability>>,
    { data: KbEnrichmentJobRequest }
  > = (props) => {
    const { data } = props ?? {};

    return enrichVulnerability(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrichVulnerabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrichVulnerability>>
>;
export type EnrichVulnerabilityMutationBody = KbEnrichmentJobRequest;
export type EnrichVulnerabilityMutationError = HTTPValidationError;

/**
 * @summary Enrich Vulnerability
 */
export const useEnrichVulnerability = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrichVulnerability>>,
      TError,
      { data: KbEnrichmentJobRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enrichVulnerability>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  return useMutation(getEnrichVulnerabilityMutationOptions(options), queryClient);
};

export const getEnrichRoadmapItemUrl = () => {
  return `/internal/kb/enrich/roadmap_item`;
};

/**
 * @summary Enrich Roadmap Item
 */
export const enrichRoadmapItem = async (
  kbEnrichmentJobRequest: KbEnrichmentJobRequest,
  options?: RequestInit
): Promise<EnrichRoadmapItem200> => {
  return apiMutator<EnrichRoadmapItem200>(getEnrichRoadmapItemUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbEnrichmentJobRequest),
  });
};

export const getEnrichRoadmapItemMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichRoadmapItem>>,
    TError,
    { data: KbEnrichmentJobRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrichRoadmapItem>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  const mutationKey = ["enrichRoadmapItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrichRoadmapItem>>,
    { data: KbEnrichmentJobRequest }
  > = (props) => {
    const { data } = props ?? {};

    return enrichRoadmapItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrichRoadmapItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrichRoadmapItem>>
>;
export type EnrichRoadmapItemMutationBody = KbEnrichmentJobRequest;
export type EnrichRoadmapItemMutationError = HTTPValidationError;

/**
 * @summary Enrich Roadmap Item
 */
export const useEnrichRoadmapItem = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrichRoadmapItem>>,
      TError,
      { data: KbEnrichmentJobRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enrichRoadmapItem>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  return useMutation(getEnrichRoadmapItemMutationOptions(options), queryClient);
};

export const getEnrichPricingSnapshotUrl = () => {
  return `/internal/kb/enrich/pricing_snapshot`;
};

/**
 * @summary Enrich Pricing Snapshot
 */
export const enrichPricingSnapshot = async (
  kbEnrichmentJobRequest: KbEnrichmentJobRequest,
  options?: RequestInit
): Promise<EnrichPricingSnapshot200> => {
  return apiMutator<EnrichPricingSnapshot200>(getEnrichPricingSnapshotUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbEnrichmentJobRequest),
  });
};

export const getEnrichPricingSnapshotMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichPricingSnapshot>>,
    TError,
    { data: KbEnrichmentJobRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrichPricingSnapshot>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  const mutationKey = ["enrichPricingSnapshot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrichPricingSnapshot>>,
    { data: KbEnrichmentJobRequest }
  > = (props) => {
    const { data } = props ?? {};

    return enrichPricingSnapshot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrichPricingSnapshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrichPricingSnapshot>>
>;
export type EnrichPricingSnapshotMutationBody = KbEnrichmentJobRequest;
export type EnrichPricingSnapshotMutationError = HTTPValidationError;

/**
 * @summary Enrich Pricing Snapshot
 */
export const useEnrichPricingSnapshot = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrichPricingSnapshot>>,
      TError,
      { data: KbEnrichmentJobRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enrichPricingSnapshot>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  return useMutation(getEnrichPricingSnapshotMutationOptions(options), queryClient);
};

export const getEnrichUrlUrl = () => {
  return `/internal/kb/enrich/url`;
};

/**
 * @summary Enrich Url
 */
export const enrichUrl = async (
  kbEnrichmentJobRequest: KbEnrichmentJobRequest,
  options?: RequestInit
): Promise<EnrichUrl200> => {
  return apiMutator<EnrichUrl200>(getEnrichUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(kbEnrichmentJobRequest),
  });
};

export const getEnrichUrlMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrichUrl>>,
    TError,
    { data: KbEnrichmentJobRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrichUrl>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  const mutationKey = ["enrichUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrichUrl>>,
    { data: KbEnrichmentJobRequest }
  > = (props) => {
    const { data } = props ?? {};

    return enrichUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrichUrlMutationResult = NonNullable<Awaited<ReturnType<typeof enrichUrl>>>;
export type EnrichUrlMutationBody = KbEnrichmentJobRequest;
export type EnrichUrlMutationError = HTTPValidationError;

/**
 * @summary Enrich Url
 */
export const useEnrichUrl = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrichUrl>>,
      TError,
      { data: KbEnrichmentJobRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiMutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enrichUrl>>,
  TError,
  { data: KbEnrichmentJobRequest },
  TContext
> => {
  return useMutation(getEnrichUrlMutationOptions(options), queryClient);
};
